<template>
  <footer
    class="pos-footer"
    :class="{
      'pos-footer-checkout': section.checkout || section.cashCardTopup,
    }"
    v-if="!fullscreen"
  >
    <div class="row mx-0 h-100 align-items-end">
      <div
        :class="
          section.movieDetail
            ? 'col-lg-12 col-xl-12 px-0'
            : 'col-lg-9 col-xl-9 col-md-9 col-sm-9 px-0'
        "
      >
        <div class="pos-menus" :class="posHiddenMenus ? 'rounded-top-0' : ''">
          <div class="row h-100 d-flex">
            <div class="col-2 px-0" v-if="posHiddenMenus == false">
              <button
                class="btn-pos-menu border-0"
                v-on:click="showHiddenMenus()"
              >
                <div class="svg-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="6"
                    height="6"
                    viewBox="0 0 6 6"
                  >
                    <circle
                      id="Ellipse_39"
                      data-name="Ellipse 39"
                      cx="3"
                      cy="3"
                      r="3"
                      transform="translate(0)"
                      fill="#969696"
                    />
                  </svg>

                  <span class="mx-1 position-relative" style="top: -1px">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="6"
                      height="6"
                      viewBox="0 0 6 6"
                    >
                      <circle
                        id="Ellipse_39"
                        data-name="Ellipse 39"
                        cx="3"
                        cy="3"
                        r="3"
                        transform="translate(0)"
                        fill="#969696"
                      />
                    </svg>
                  </span>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="6"
                    height="6"
                    viewBox="0 0 6 6"
                  >
                    <circle
                      id="Ellipse_39"
                      data-name="Ellipse 39"
                      cx="3"
                      cy="3"
                      r="3"
                      transform="translate(0)"
                      fill="#969696"
                    />
                  </svg>
                </div>
                <div>{{ $t("more") }}</div>
              </button>
            </div>

            <div class="col-2 px-0" v-if="posHiddenMenus == true">
              <button
                class="btn-pos-menu border-0"
                v-on:click="showHiddenMenus()"
              >
                <div class="svg-container">
                  <img src="@/assets/img/icons/close-x.svg" width="20" alt />
                </div>
                <div>{{ $t("close") }}</div>
              </button>
            </div>

            <!-- Swap Ticket -->
            <div
              v-if="section.checkout && type_id != 2"
              class="col-2 px-0 border-bottom child"
              :style="'order:' + order(2)"
            >
              <button class="btn-pos-menu" @click="posFooterAction('Swap')">
                <div class="svg-container">
                  <svg
                    height="100px"
                    width="100px"
                    fill="#969696"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 24 24"
                    version="1.1"
                    x="0px"
                    y="0px"
                  >
                    <title>Swap</title>
                    <desc>Created with Sketch.</desc>
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g>
                        <rect x="0" y="0" width="24" height="24"></rect>
                        <path
                          d="M12,22.75 C6.06293894,22.75 1.25,17.9370611 1.25,12 C1.25,6.06293894 6.06293894,1.25 12,1.25 C17.9370611,1.25 22.75,6.06293894 22.75,12 C22.75,17.9370611 17.9370611,22.75 12,22.75 Z M12,21.25 C17.1086339,21.25 21.25,17.1086339 21.25,12 C21.25,6.89136606 17.1086339,2.75 12,2.75 C6.89136606,2.75 2.75,6.89136606 2.75,12 C2.75,17.1086339 6.89136606,21.25 12,21.25 Z"
                          fill="#969696"
                          fill-rule="nonzero"
                        ></path>
                        <path
                          d="M15.75,8.81066017 L15.75,17 C15.75,17.4142136 15.4142136,17.75 15,17.75 C14.5857864,17.75 14.25,17.4142136 14.25,17 L14.25,8.81066017 L12.5303301,10.5303301 C12.2374369,10.8232233 11.7625631,10.8232233 11.4696699,10.5303301 C11.1767767,10.2374369 11.1767767,9.76256313 11.4696699,9.46966991 L14.4696699,6.46966991 C14.7625631,6.1767767 15.2374369,6.1767767 15.5303301,6.46966991 L18.5303301,9.46966991 C18.8232233,9.76256313 18.8232233,10.2374369 18.5303301,10.5303301 C18.2374369,10.8232233 17.7625631,10.8232233 17.4696699,10.5303301 L15.75,8.81066017 Z M8.25,15.1893398 L8.25,7 C8.25,6.58578644 8.58578644,6.25 9,6.25 C9.41421356,6.25 9.75,6.58578644 9.75,7 L9.75,15.1893398 L11.4696699,13.4696699 C11.7625631,13.1767767 12.2374369,13.1767767 12.5303301,13.4696699 C12.8232233,13.7625631 12.8232233,14.2374369 12.5303301,14.5303301 L9.53033009,17.5303301 C9.23743687,17.8232233 8.76256313,17.8232233 8.46966991,17.5303301 L5.46966991,14.5303301 C5.1767767,14.2374369 5.1767767,13.7625631 5.46966991,13.4696699 C5.76256313,13.1767767 6.23743687,13.1767767 6.53033009,13.4696699 L8.25,15.1893398 Z"
                          fill="#969696"
                          fill-rule="nonzero"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </div>
                <div>Swap</div>
              </button>
            </div>

            <div
              v-if="section.checkout && payment_mode_id != 58"
              class="col-2 px-0 border-bottom child"
              :style="'order:' + order(2)"
            >
              <button
                class="btn-pos-menu"
                @click="posFooterAction('AddMoreFnb')"
              >
                <div class="svg-container">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <circle
                      cx="12"
                      cy="12"
                      r="9"
                      fill="none"
                      stroke="#969696"
                      stroke-width="1.8"
                    />
                    <path
                      d="M12 8v8M8 12h8"
                      fill="none"
                      stroke="#969696"
                      stroke-width="1.8"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                <div>Add F&amp;B</div>
              </button>
            </div>

            <div
              v-if="section.checkout && ['2', '3'].includes(String(type_id))"
              class="col-2 px-0 border-bottom child"
              :style="'order:' + order(2)"
            >
              <button
                class="btn-pos-menu"
                @click="$bvModal.show('FnBRemarks')"
              >
                <div class="svg-container">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      d="M6 4h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-7l-5 4v-4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"
                      fill="none"
                      stroke="#969696"
                      stroke-width="1.7"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8 8h8M8 12h5"
                      fill="none"
                      stroke="#969696"
                      stroke-width="1.7"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                <div>F&amp;B Remarks</div>
              </button>
            </div>

            <div
              v-if="
                section.checkout &&
                ['1', '3'].includes(String(type_id)) &&
                authorizeClient(CLIENT_NAMES_OBJ_LIST.trx_comment_mandatory)
              "
              class="col-2 px-0 border-bottom child"
              :style="'order:' + order(2)"
            >
              <button
                class="btn-pos-menu"
                @click="$bvModal.show('BoRemarks')"
              >
                <div class="svg-container">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      d="M6 4h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-7l-5 4v-4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"
                      fill="none"
                      stroke="#969696"
                      stroke-width="1.7"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8 8h8M8 12h5"
                      fill="none"
                      stroke="#969696"
                      stroke-width="1.7"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                <div>BO Remarks</div>
              </button>
            </div>

            <div
              class="col-2 px-0 border-bottom child"
              v-if="section.checkout && false"
              @click="posFooterAction('MultiCurrency')"
            >
              <button class="btn-pos-menu">
                <div class="svg-container">
                  <svg
                    height="100px"
                    width="100px"
                    fill="#000000"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 96 96"
                    enable-background="new 0 0 96 96"
                    xml:space="preserve"
                  >
                    <path
                      d="M18.954,27.396l-5.912-1.12l-2.413,12.744H4.75v38.545h57.009v3.197h22.343v-8.598h-1.576v-5.598h3.154V57.97h-0.585  l6.38-15.977l-67.576-26.98L18.954,27.396z M14.237,28.03l4.149,0.786l0.751,0.143l0.75,0.142l3.685,0.698l0.751,0.142l0.751,0.143  l35.305,6.688l3.849,0.729l3.847,0.729l4.18,0.792h-2.196h-2.021h-2.023h-8.954h-1.203h-1.406h-1.965l-3.861-0.731l-1.56-0.296  l-1.26-0.238l-22.12-4.19l-0.751-0.143l-0.521-0.099l-0.14,0.737c-0.188,0.995-0.7,1.854-1.4,2.504  c-0.823,0.763-1.912,1.231-3.099,1.232c-0.286,0-0.576-0.027-0.86-0.082l-0.431-0.081l-0.307-0.059l-0.273,1.445H15.12h-0.808  h-2.157L14.237,28.03z M25.641,28.663l0.022-0.056c0.504,0.133,1.021,0.2,1.543,0.2c2.252-0.001,4.272-1.217,5.333-3.153  l20.562,8.21L25.641,28.663z M44.424,39.021h-0.42H21.505h-0.808h-0.807h-0.334c0.134-0.041,0.262-0.097,0.393-0.146  c0.352-0.137,0.688-0.301,1.006-0.498c0.437-0.271,0.837-0.593,1.192-0.964c0.629-0.657,1.126-1.447,1.413-2.344l20.52,3.887  L44.424,39.021z M61.759,73.974v0.764v1.328H6.25V64.222v-2.078V40.521h4.095h0.764h0.763h1.843h0.808h0.808h0.288h0.764h0.763  h2.147h0.808h0.808h21.729h0.962h1.027h3.818h2.477h1.161h0.261h0.547h0.808h2.675h0.101h1.017h0.95h1.964h9.367h2.022h2.021h2.199  v0.878v0.808v0.808v5.821v0.801v3.307v4.031v0.996h-0.188h-0.764h-0.764h-1.964v-8.432h-0.75c-2.529,0-4.587-2.059-4.587-4.588V44.2  h-6.854h-0.775h-0.774h-4.099h-2.267h-0.808h-0.191h-0.616h-0.705h-1.675h-0.016h-0.75h-0.753h-4.228h-0.309h-0.461h-0.768h-0.447  h-1.327H22.428H21.5h-1.004h-4.05h-0.763h-0.417v0.75c0,1.088-0.396,2.075-1.031,2.862c-0.617,0.765-1.465,1.328-2.446,1.574  c-0.277,0.069-0.563,0.109-0.857,0.126c-0.085,0.005-0.166,0.025-0.252,0.025h-0.517h-0.05H9.93v0.46v0.773v0.165v12.455v0.764  v0.764v2.131h0.75c2.529,0,4.587,2.058,4.587,4.586v0.75h34.081h4.031h4.031h2.771v0.525v0.754h1.577V73.974z M70.833,50.992v6.978  h-7.496v7.098h-0.003h-2.023h-1.129v0.356v2.215v0.764v0.764v0.222v0.807v0.691H59.89H49.492h-4.031H41.43H16.721  c-0.341-2.758-2.533-4.95-5.291-5.29v-0.394v-0.763v-0.764v-12.14v-0.544c0.148-0.019,0.287-0.063,0.432-0.091  c0.399-0.08,0.782-0.195,1.149-0.349c0.271-0.113,0.53-0.245,0.78-0.396c0.315-0.189,0.61-0.404,0.886-0.646  c0.355-0.312,0.685-0.65,0.96-1.035c0.572-0.804,0.957-1.75,1.084-2.776h4.809h0.8h0.776H37.62h1.002h1.085h1.008h0.747h0.756h3.412  h0.764h0.764h0.289h1.48h1.086h0.677h0.131h0.131h0.677h0.15h0.151h0.855h6.077h0.747h0.755h5.178  C65.883,48.459,68.075,50.651,70.833,50.992z M61.759,72.165h-0.077v-0.529v-0.034v-0.716v-0.092v-0.808V69.45v-0.764v-0.764v-1.355  h1.363h0.292h1.73h2.023h1.152h0.011h0.656h0.436h0.519h0.13h0.819h0.123h1.396h3.68h0.393v5.598h-0.393h-8.874h-0.143h-1.88h-2.022  H61.759z M77.982,73.761v0.648v1.373v3.48H63.259v-1.697v-0.75v-0.75v-1.045v-0.764v-0.592h0.905h2.687h2.022h2.022h5.117h0.583  h0.167h0.451h0.146h0.153h0.47V73.761z M78.659,66.805v3.239v0.792v1.229v0.1h-0.04h-0.212h-0.502v-0.232v-1.148v-4.031v-0.186  h0.035h0.719V66.805z M78.225,65.067h-0.712h-0.75h-0.08h-0.67h-0.137h-0.201h-1.195h-0.764h-1.383h-0.265h-0.485h-0.75h-0.285  h-0.11h-5.601V59.47h5.996h0.75h0.75h1.68h0.764h0.764h0.473h0.75h0.54h0.21h0.599h0.807h0.367h0.275v2.577v3.021h-0.572H78.225z   M80.236,79.263h-0.754v-5.598h0.754V79.263z M81.025,68.161v4.004h-0.866v-1.834V68.31v-1.742h0.695h0.171V68.161z M81.061,65.067  V64.03V59.47h0.753v2.674v2.022v0.901h-0.36H81.061z M82.602,73.665v5.598h-0.865v-5.598h0.789H82.602z M84.18,60.262v4.806h-0.866  v-2.636v-2.022V59.47h0.375h0.491V60.262z M89.525,42.829L83.48,57.97h-2.384l1.426-7.523l0.241-0.605l-0.118-0.047l1.711-9.028  L89.525,42.829z M81.243,49.133l-0.148,0.782l-0.75,3.961l-0.729,3.847l-0.047,0.247h-0.052H78.71h-0.808h-0.39V43.612v-0.808  v-0.808v-1.98l5.269,0.998L81.243,49.133z M79.686,38.9l-18.89-3.578L31.743,23.722l-0.277,0.697c-0.7,1.754-2.372,2.888-4.26,2.889  c-0.582,0-1.153-0.111-1.7-0.329L24.81,26.7l-0.67,1.679l-3.685-0.698l4.279-10.719L79.686,38.9z"
                    ></path>
                    <path
                      d="M50.771,56.25c-0.054-0.253-0.12-0.501-0.192-0.747c-0.076-0.257-0.166-0.507-0.263-0.755  c-0.335-0.866-0.79-1.671-1.343-2.398c-0.173-0.228-0.354-0.445-0.546-0.656c-0.05-0.056-0.099-0.111-0.149-0.165  c-0.137-0.145-0.278-0.284-0.424-0.42c-0.246-0.23-0.503-0.446-0.771-0.65c-0.234-0.179-0.476-0.347-0.726-0.504  c-0.002-0.001-0.003-0.002-0.005-0.003c-0.224-0.141-0.452-0.275-0.688-0.397c-0.057-0.03-0.116-0.056-0.174-0.085  c-0.03-0.015-0.061-0.028-0.091-0.043c-0.146-0.07-0.286-0.147-0.435-0.21c-0.73-0.31-1.509-0.521-2.316-0.646  c-0.056-0.009-0.111-0.018-0.168-0.025c-0.191-0.026-0.385-0.05-0.58-0.064c-0.073-0.006-0.147-0.007-0.221-0.012  c-0.179-0.01-0.356-0.026-0.538-0.027c-0.003,0-0.006,0-0.009,0c-0.075,0-0.148,0.01-0.224,0.012  c-1.265,0.028-2.473,0.289-3.577,0.752c-0.314,0.133-0.621,0.28-0.918,0.443c-0.313,0.171-0.611,0.361-0.902,0.564  c-1.037,0.724-1.929,1.641-2.622,2.7c-0.139,0.212-0.273,0.427-0.396,0.649c-0.121,0.22-0.227,0.447-0.331,0.676  c-0.505,1.112-0.805,2.333-0.861,3.618c-0.007,0.146-0.022,0.29-0.022,0.438c0,0.124,0.014,0.244,0.019,0.367  c0.011,0.28,0.028,0.559,0.062,0.832c0.122,0.999,0.395,1.951,0.793,2.836c0.131,0.289,0.274,0.57,0.432,0.845  c0.172,0.301,0.361,0.591,0.563,0.87c1.791,2.48,4.699,4.104,7.985,4.104c1.966,0,3.794-0.585,5.333-1.58  c0.291-0.188,0.572-0.388,0.841-0.604c0.028-0.023,0.061-0.043,0.089-0.066c0.215-0.178,0.418-0.366,0.617-0.562  c0.001,0,0.001-0.001,0.002-0.001c0.191-0.188,0.372-0.385,0.548-0.587c0.813-0.935,1.45-2.023,1.867-3.217  c0.083-0.236,0.155-0.476,0.22-0.72c0.063-0.239,0.121-0.479,0.167-0.726c0.001-0.005,0.001-0.01,0.002-0.015  c0.062-0.337,0.104-0.681,0.131-1.028c0.019-0.248,0.038-0.495,0.038-0.748c0-0.092-0.012-0.182-0.014-0.272  C50.956,57.416,50.892,56.823,50.771,56.25z M49.438,59.186c-0.012,0.106-0.033,0.209-0.049,0.314  c-0.029,0.207-0.063,0.413-0.108,0.614c-0.01,0.046-0.023,0.091-0.035,0.136c-0.059,0.246-0.128,0.488-0.208,0.725  c-0.011,0.032-0.024,0.064-0.035,0.097c-0.414,1.167-1.073,2.219-1.926,3.083c-0.194,0.197-0.398,0.386-0.611,0.563  c-0.109,0.091-0.227,0.173-0.34,0.258c-0.121,0.091-0.24,0.184-0.366,0.268c-0.173,0.116-0.353,0.223-0.534,0.325  c-0.374,0.211-0.767,0.39-1.172,0.542c-0.911,0.342-1.893,0.537-2.921,0.537c-2.142,0-4.09-0.816-5.57-2.146  c-0.322-0.29-0.627-0.599-0.901-0.935c-0.227-0.278-0.431-0.575-0.62-0.881c-0.481-0.773-0.84-1.628-1.048-2.541  c-0.064-0.284-0.116-0.573-0.15-0.867c-0.032-0.273-0.051-0.55-0.056-0.83c-0.001-0.052-0.008-0.102-0.008-0.154  c0-1.251,0.284-2.434,0.778-3.5c0.106-0.229,0.222-0.452,0.347-0.669c0.128-0.221,0.265-0.436,0.412-0.644  c0.309-0.436,0.656-0.84,1.04-1.208c0.239-0.229,0.494-0.442,0.76-0.643c0.251-0.19,0.513-0.366,0.785-0.526  c1.193-0.706,2.573-1.123,4.05-1.155c0.062-0.001,0.12-0.009,0.182-0.009c0.079,0,0.155,0.01,0.234,0.012  c0.111,0.003,0.223,0.01,0.333,0.017c0.163,0.012,0.325,0.025,0.485,0.046c0.093,0.012,0.185,0.027,0.276,0.042  c0.219,0.035,0.434,0.078,0.646,0.13c0.546,0.133,1.069,0.318,1.567,0.554c0.238,0.111,0.469,0.233,0.694,0.367  c0.072,0.043,0.145,0.086,0.215,0.131c0.118,0.074,0.235,0.15,0.35,0.231c0.039,0.027,0.076,0.057,0.114,0.085  c0.292,0.214,0.57,0.443,0.832,0.692c0.686,0.651,1.259,1.417,1.692,2.267c0.004,0.008,0.007,0.016,0.011,0.023  c0.137,0.269,0.257,0.546,0.364,0.831c0.054,0.145,0.113,0.287,0.16,0.436c0.036,0.115,0.061,0.235,0.091,0.353  c0.182,0.684,0.288,1.397,0.288,2.138C49.486,58.595,49.469,58.892,49.438,59.186z"
                    ></path>
                    <path
                      d="M45.434,58.729c-0.142-0.326-0.34-0.6-0.593-0.803c-0.201-0.162-0.437-0.277-0.697-0.349  c-0.188-0.052-0.386-0.088-0.602-0.088h-0.146H42.33h-0.448v-0.003v-0.176v-0.256v-0.552v-0.211v-0.765v-0.49V54.19h0.961h1.179  h0.427h0.067h0.27h0.247v-0.548V53.44v-0.556V52.69h-0.485h-0.241h-0.34h-1.008h-1.076V51.8v-0.412h-0.434h-0.316h-0.75v1.303  h-1.245c-0.483,0-0.91,0.081-1.267,0.241c-0.35,0.157-0.637,0.377-0.854,0.658c-0.004,0.006-0.007,0.012-0.011,0.018  c-0.178,0.235-0.303,0.497-0.386,0.794c-0.005,0.019-0.014,0.034-0.019,0.053c-0.027,0.105-0.043,0.223-0.061,0.337  c-0.019,0.119-0.032,0.242-0.041,0.371c-0.008,0.114-0.019,0.226-0.019,0.347v0.453v0.209c0,0.154,0.011,0.3,0.023,0.443  c0.02,0.217,0.049,0.425,0.097,0.614c0.085,0.329,0.221,0.612,0.417,0.864c0.213,0.275,0.498,0.496,0.851,0.656  c0.075,0.034,0.167,0.05,0.249,0.076c0.302,0.1,0.635,0.164,1.019,0.164h0.251h0.994v0.424v0.289v0.873v0.906v0.808v0.104h-1.76  h-0.561h-0.584v0.75v0.194v0.556h2.904v0.758v0.547h0.75h0.75v-0.263v-0.764v-0.278h0.497h1.163c0.224,0,0.428-0.039,0.622-0.095  c0.32-0.091,0.597-0.253,0.823-0.479c0.36-0.357,0.593-0.868,0.663-1.498c0.015-0.134,0.029-0.268,0.029-0.411v-0.343v-0.747v-0.348  c0-0.122-0.015-0.234-0.025-0.35C45.624,59.292,45.549,58.993,45.434,58.729z M40.382,55.903v0.809v0.777h-0.075h-1.17  c-0.084,0-0.154-0.01-0.229-0.017c-0.165-0.016-0.314-0.042-0.42-0.09c-0.124-0.057-0.222-0.128-0.284-0.209  c-0.069-0.089-0.116-0.189-0.149-0.316c-0.022-0.087-0.038-0.185-0.05-0.287c-0.015-0.123-0.023-0.254-0.023-0.396  c0-0.001,0-0.002,0-0.003v-0.418v-0.244c0-0.202,0.02-0.383,0.049-0.544c0.009-0.046,0.014-0.098,0.024-0.139  c0.033-0.129,0.081-0.231,0.149-0.321c0.062-0.079,0.158-0.15,0.279-0.204c0.161-0.072,0.387-0.11,0.653-0.11h1.245V55.903z   M44.18,60.27v0.754v0.388c0,0.145-0.013,0.262-0.031,0.367c-0.105,0.609-0.472,0.615-0.606,0.615h-0.876h-0.784V62.08v-0.826  v-0.796v-0.812v-0.657h1.66c0.423,0,0.638,0.331,0.638,0.984V60.27z"
                    ></path>
                  </svg>
                </div>
                <div>MultiCurrency</div>
              </button>
            </div>

            <div v-if="false" class="col-2 px-0 border-left">
              <div
                class="d-flex justify-content-center align-items-center h-100"
              >
                <div class>
                  <div class="d-flex align-items-center">
                    <span class="available-box"></span>
                    <div class="ml-2">{{ $t("available") }}</div>
                  </div>

                  <div class="d-flex align-items-center">
                    <span class="filling-fast-box"></span>
                    <div class="ml-2">{{ $t("fillingfast") }}</div>
                  </div>

                  <div class="d-flex align-items-center">
                    <span class="house-full-box"></span>
                    <div class="ml-2">{{ $t("housefull") }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="section.movieDetail"
              class="col-2 px-0 border-bottom child"
              :style="'order:' + order(1)"
            >
              <button
                class="btn-pos-menu"
                v-on:click="posFooterAction('PosPickUpTicket')"
              >
                <div class="svg-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="27"
                    viewBox="0 0 50.334 40.34"
                  >
                    <g
                      id="noun_box_office_19312"
                      data-name="noun_box office_19312"
                      transform="translate(0 -10.06)"
                    >
                      <g id="Group_314" data-name="Group 314">
                        <g id="Group_313" data-name="Group 313">
                          <path
                            id="Path_1091"
                            data-name="Path 1091"
                            d="M35.117,39.266a4.011,4.011,0,1,1,4.015-4.008A4.013,4.013,0,0,1,35.117,39.266Z"
                            fill="#969696"
                          />
                        </g>
                        <path
                          id="Path_1092"
                          data-name="Path 1092"
                          d="M34.236,50.055l.13-.084h.007l4.945-5.1a.532.532,0,1,1,.765.739l-4.592,4.735H46.259a22.475,22.475,0,0,0-4.772-9.213c-.957-1.157-3.522-2.261-5.292-.594A11.614,11.614,0,0,0,33.4,46.023l-4.509-4.562a1.863,1.863,0,0,0-2.651,2.619L31.9,49.8a1.87,1.87,0,0,0,2.339.254Z"
                          fill="#969696"
                        />
                      </g>
                      <g id="Group_316" data-name="Group 316">
                        <g id="Group_315" data-name="Group 315">
                          <path
                            id="Path_1093"
                            data-name="Path 1093"
                            d="M11.14,39.266a4.011,4.011,0,1,0-4.013-4.008A4.013,4.013,0,0,0,11.14,39.266Z"
                            fill="#969696"
                          />
                        </g>
                        <path
                          id="Path_1094"
                          data-name="Path 1094"
                          d="M12.02,50.055l-.129-.084h-.005l-4.946-5.1a.532.532,0,0,0-.765.739l4.593,4.735H0a22.475,22.475,0,0,1,4.772-9.213c.955-1.157,3.522-2.261,5.292-.594a11.612,11.612,0,0,1,2.793,5.484l4.51-4.562a1.863,1.863,0,0,1,2.65,2.619L14.361,49.8a1.872,1.872,0,0,1-2.341.254Z"
                          fill="#969696"
                        />
                      </g>
                      <path
                        id="Path_1095"
                        data-name="Path 1095"
                        d="M21.349,23.732V33.985h3.62v-6.65H46.714V50.4h3.62V23.732Z"
                        fill="#969696"
                      />
                      <rect
                        id="Rectangle_213"
                        data-name="Rectangle 213"
                        width="3.62"
                        height="13.323"
                        transform="translate(21.349 37.077)"
                        fill="#969696"
                      />
                      <path
                        id="Path_1096"
                        data-name="Path 1096"
                        d="M45.635,13.034V10.06H40.559V11.7H39.113V10.06H26.6v2.975a2.6,2.6,0,0,1,0,5.2v2.973H39.113V19.57h1.446v1.642h5.076V18.24a2.6,2.6,0,0,1,0-5.206ZM40.559,18H39.113V16.354h1.446Zm0-3.165H39.113V13.187h1.446Z"
                        fill="#969696"
                      />
                    </g>
                  </svg>
                </div>

                <div>{{ $t("pickup") }} {{ $tc("ticket", 1) }}</div>
              </button>
            </div>

            <div
              v-if="section.movieDetail"
              class="col-2 px-0"
              :style="'order:' + order(1)"
            >
              <button
                class="btn-pos-menu"
                v-on:click="posFooterAction('PosRefund')"
                :disabled="diabledRefundBtn"
              >
                <div class="svg-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="29.888"
                    height="27.632"
                    viewBox="0 0 29.888 27.632"
                  >
                    <path
                      d="M58.485,84.785A1.169,1.169,0,0,1,60.416,86.1,13.816,13.816,0,1,1,62.4,74.956l.477-.818A1.171,1.171,0,0,1,64.9,75.319l-2.175,3.72a1.17,1.17,0,0,1-1.773.294L57.8,76.6a1.168,1.168,0,0,1,1.529-1.766l.82.71a11.476,11.476,0,1,0-1.66,9.244ZM47.992,69.939h2.23v1.92c2.013.291,3.559,1.4,3.643,3.779l-2.555.088a1.91,1.91,0,0,0-1.088-1.633v2.813c2.186.564,4.013,1.4,4.013,4.047a3.693,3.693,0,0,1-2.306,3.439,6.019,6.019,0,0,1-1.707.41v1.89h-2.23V84.775a4.354,4.354,0,0,1-4.013-4.239l2.485-.246A2.638,2.638,0,0,0,47.992,82.5V78.979c-1.839-.527-3.537-1.453-3.537-3.671,0-2.152,1.688-3.181,3.537-3.454V69.939Zm2.23,9.6v3.033a1.7,1.7,0,0,0,1.458-1.605c0-.755-.679-1.167-1.458-1.428ZM47.992,76.3V74.022c-.582.158-1.105.486-1.105,1.117C46.887,75.7,47.393,76.058,47.992,76.3Z"
                      transform="translate(-35.19 -64.5)"
                      fill="#969696"
                    />
                  </svg>
                </div>
                <div>{{ $tc("refund", 1) }}</div>
              </button>
            </div>

            <div
              v-if="section.movieDetail"
              class="col-2 px-0"
              :style="'order:' + order(5)"
            >
              <button
                class="btn-pos-menu"
                v-on:click="posFooterAction('UnpaidBooking')"
              >
                <div class="svg-container">
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M16 9H3V10H16V9Z" fill="#969696" />
                    <path d="M16 20H3V21H16V20Z" fill="#969696" />
                    <path d="M26.5 9H20V10H26.5V9Z" fill="#969696" />
                    <path d="M26.5 20H20V21H26.5V20Z" fill="#969696" />
                    <mask id="path-5-inside-1" fill="white">
                      <path
                        d="M29.5 11.5C29.7761 11.5 30 11.2761 30 11V7C30 6.72387 29.7761 6.5 29.5 6.5H0.5C0.223875 6.5 0 6.72387 0 7V11C0 11.2761 0.223875 11.5 0.5 11.5C2.433 11.5 4 13.067 4 15C4 16.933 2.433 18.5 0.5 18.5C0.223875 18.5 0 18.7239 0 19V23C0 23.2761 0.223875 23.5 0.5 23.5H29.5C29.7761 23.5 30 23.2761 30 23V19C30 18.7239 29.7761 18.5 29.5 18.5C27.567 18.5 26 16.933 26 15C26 13.067 27.567 11.5 29.5 11.5ZM25.0292 15.5012C25.2633 17.5896 26.9116 19.2379 29 19.472V22.5H1V19.472C3.46981 19.1952 5.24762 16.9686 4.97081 14.4988C4.73675 12.4104 3.08838 10.7621 1 10.528V7.5H29V10.528C26.5302 10.8048 24.7524 13.0314 25.0292 15.5012Z"
                      />
                    </mask>
                    <path
                      d="M29.5 11.5C29.7761 11.5 30 11.2761 30 11V7C30 6.72387 29.7761 6.5 29.5 6.5H0.5C0.223875 6.5 0 6.72387 0 7V11C0 11.2761 0.223875 11.5 0.5 11.5C2.433 11.5 4 13.067 4 15C4 16.933 2.433 18.5 0.5 18.5C0.223875 18.5 0 18.7239 0 19V23C0 23.2761 0.223875 23.5 0.5 23.5H29.5C29.7761 23.5 30 23.2761 30 23V19C30 18.7239 29.7761 18.5 29.5 18.5C27.567 18.5 26 16.933 26 15C26 13.067 27.567 11.5 29.5 11.5ZM25.0292 15.5012C25.2633 17.5896 26.9116 19.2379 29 19.472V22.5H1V19.472C3.46981 19.1952 5.24762 16.9686 4.97081 14.4988C4.73675 12.4104 3.08838 10.7621 1 10.528V7.5H29V10.528C26.5302 10.8048 24.7524 13.0314 25.0292 15.5012Z"
                      fill="#969696"
                    />
                    <path
                      d="M25.0292 15.5012L16.0852 16.5036L16.0852 16.5036L25.0292 15.5012ZM29 19.472H38V11.4243L30.0024 10.528L29 19.472ZM29 22.5V31.5H38V22.5H29ZM1 22.5H-8V31.5H1V22.5ZM1 19.472L-0.00242875 10.528L-8 11.4244L-8 19.472H1ZM4.97081 14.4988L-3.97319 15.5012L-3.97319 15.5012L4.97081 14.4988ZM1 10.528H-8V18.5756L-0.0024324 19.472L1 10.528ZM1 7.5V-1.5H-8V7.5H1ZM29 7.5H38V-1.5H29V7.5ZM29 10.528L30.0024 19.472L38 18.5756V10.528H29ZM29.5 20.5C34.7467 20.5 39 16.2467 39 11H21C21 6.30556 24.8056 2.5 29.5 2.5V20.5ZM39 11V7H21V11H39ZM39 7C39 1.75331 34.7467 -2.5 29.5 -2.5V15.5C24.8056 15.5 21 11.6944 21 7H39ZM29.5 -2.5H0.5V15.5H29.5V-2.5ZM0.5 -2.5C-4.74669 -2.5 -9 1.75331 -9 7H9C9 11.6944 5.19444 15.5 0.5 15.5V-2.5ZM-9 7V11H9V7H-9ZM-9 11C-9 16.2467 -4.74669 20.5 0.5 20.5V2.5C5.19444 2.5 9 6.30556 9 11H-9ZM0.5 20.5C-2.53756 20.5 -5 18.0376 -5 15H13C13 8.09644 7.40356 2.5 0.5 2.5V20.5ZM-5 15C-5 11.9624 -2.53756 9.5 0.5 9.5V27.5C7.40356 27.5 13 21.9036 13 15H-5ZM0.5 9.5C-4.74669 9.5 -9 13.7533 -9 19H9C9 23.6944 5.19444 27.5 0.5 27.5V9.5ZM-9 19V23H9V19H-9ZM-9 23C-9 28.2467 -4.74669 32.5 0.5 32.5V14.5C5.19444 14.5 9 18.3056 9 23H-9ZM0.5 32.5H29.5V14.5H0.5V32.5ZM29.5 32.5C34.7467 32.5 39 28.2467 39 23H21C21 18.3056 24.8056 14.5 29.5 14.5V32.5ZM39 23V19H21V23H39ZM39 19C39 13.7533 34.7467 9.5 29.5 9.5V27.5C24.8056 27.5 21 23.6944 21 19H39ZM29.5 9.5C32.5376 9.5 35 11.9624 35 15H17C17 21.9036 22.5964 27.5 29.5 27.5V9.5ZM35 15C35 18.0376 32.5376 20.5 29.5 20.5V2.5C22.5964 2.5 17 8.09644 17 15H35ZM16.0852 16.5036C16.7874 22.7687 21.7323 27.7138 27.9976 28.416L30.0024 10.528C32.0909 10.7621 33.7391 12.4104 33.9732 14.4988L16.0852 16.5036ZM20 19.472V22.5H38V19.472H20ZM29 13.5H1V31.5H29V13.5ZM10 22.5V19.472H-8V22.5H10ZM2.00243 28.416C9.41174 27.5856 14.7453 20.906 13.9148 13.4964L-3.97319 15.5012C-4.25002 13.0313 -2.47211 10.8048 -0.00242875 10.528L2.00243 28.416ZM13.9148 13.4964C13.2126 7.23107 8.26749 2.28618 2.00243 1.584L-0.0024324 19.472C-2.09074 19.2379 -3.73912 17.5897 -3.97319 15.5012L13.9148 13.4964ZM10 10.528V7.5H-8V10.528H10ZM1 16.5H29V-1.5H1V16.5ZM20 7.5V10.528H38V7.5H20ZM27.9976 1.584C20.5883 2.41442 15.2547 9.09403 16.0852 16.5036L33.9732 14.4988C34.25 16.9687 32.4721 19.1952 30.0024 19.472L27.9976 1.584Z"
                      fill="#969696"
                      mask="url(#path-5-inside-1)"
                    />
                    <path
                      d="M9.00781 13.4453V15.7866C9.00781 16.1756 8.88574 16.4832 8.6416 16.7095C8.39909 16.9357 8.06706 17.0488 7.64551 17.0488C7.23047 17.0488 6.90088 16.939 6.65674 16.7192C6.4126 16.4995 6.28809 16.1976 6.2832 15.8135V13.4453H7.01562V15.7915C7.01562 16.0243 7.07096 16.1943 7.18164 16.3018C7.29395 16.4076 7.44857 16.4604 7.64551 16.4604C8.05729 16.4604 8.26644 16.244 8.27295 15.811V13.4453H9.00781ZM12.499 17H11.7666L10.3408 14.6611V17H9.6084V13.4453H10.3408L11.769 15.7891V13.4453H12.499V17ZM13.8711 15.7476V17H13.1387V13.4453H14.5254C14.7923 13.4453 15.0267 13.4941 15.2285 13.5918C15.432 13.6895 15.5882 13.8286 15.6973 14.0093C15.8063 14.1883 15.8608 14.3926 15.8608 14.6221C15.8608 14.9704 15.7412 15.2454 15.502 15.4473C15.2643 15.6475 14.9347 15.7476 14.5132 15.7476H13.8711ZM13.8711 15.1543H14.5254C14.7191 15.1543 14.8664 15.1087 14.9673 15.0176C15.0698 14.9264 15.1211 14.7962 15.1211 14.627C15.1211 14.4528 15.0698 14.312 14.9673 14.2046C14.8647 14.0972 14.7231 14.0418 14.5425 14.0386H13.8711V15.1543ZM17.9385 16.2676H16.6543L16.4102 17H15.6313L16.9546 13.4453H17.6333L18.9639 17H18.1851L17.9385 16.2676ZM16.8521 15.6743H17.7407L17.2939 14.3438L16.8521 15.6743ZM20.0747 17H19.3423V13.4453H20.0747V17ZM20.7559 17V13.4453H21.8496C22.1621 13.4453 22.4412 13.5161 22.687 13.6577C22.9344 13.7977 23.1273 13.9979 23.2656 14.2583C23.404 14.5171 23.4731 14.8117 23.4731 15.1421V15.3057C23.4731 15.6361 23.4048 15.9299 23.2681 16.187C23.133 16.4442 22.9417 16.6436 22.6943 16.7852C22.4469 16.9268 22.1678 16.9984 21.8569 17H20.7559ZM21.4883 14.0386V16.4116H21.8423C22.1287 16.4116 22.3477 16.318 22.499 16.1309C22.6504 15.9437 22.7277 15.6759 22.731 15.3276V15.1396C22.731 14.7783 22.6561 14.5049 22.5063 14.3193C22.3566 14.1322 22.1377 14.0386 21.8496 14.0386H21.4883Z"
                      fill="#969696"
                    />
                  </svg>
                </div>
                {{ $t("unpaid") }} {{ $t("booking") }}
              </button>
            </div>

            <div
              v-if="section.movieDetail"
              class="col-2 px-0"
              :style="'order:' + order(3)"
              :class="diabledThisBtn ? 'diabledThisBtn' : ''"
            >
              <button
                class="btn-pos-menu"
                v-on:click="posFooterAction('PosSchedule')"
                :disabled="starClient"
              >
                <div class="svg-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="27"
                    viewBox="0 0 27.328 42.496"
                  >
                    <g
                      id="Group_319"
                      data-name="Group 319"
                      transform="translate(-26 -13)"
                    >
                      <g
                        id="Group_318"
                        data-name="Group 318"
                        transform="translate(26 13)"
                      >
                        <path
                          id="Path_1100"
                          data-name="Path 1100"
                          d="M35.2,41.9l-.466,11.831a.087.087,0,0,1-.07.068H28.8a.086.086,0,0,1-.07-.068L28.26,41.9Zm.067-1.7.493-12.531a.091.091,0,0,0,.067.066h-8.2a.085.085,0,0,0,.067-.066L28.193,40.2Zm-9.2-21.531a5.666,5.666,0,1,1,5.666,5.666A5.666,5.666,0,0,1,26.065,18.666Zm9.632,0a3.966,3.966,0,1,0-3.966,3.966A3.966,3.966,0,0,0,35.7,18.666Zm-8.065,7.366h8.2a1.619,1.619,0,0,1,1.631,1.7L36.436,53.8a1.783,1.783,0,0,1-1.768,1.7H28.8a1.782,1.782,0,0,1-1.768-1.7L26,27.733A1.622,1.622,0,0,1,27.633,26.032Z"
                          transform="translate(-26 -13)"
                          fill="#969696"
                          fill-rule="evenodd"
                        />
                        <path
                          id="Path_1101"
                          data-name="Path 1101"
                          d="M63.359,37.931l-.622,15.8a.087.087,0,0,1-.07.068H56.8a.086.086,0,0,1-.07-.068l-.622-15.8Zm.067-1.7.337-8.565a.091.091,0,0,0,.067.066h-8.2a.085.085,0,0,0,.067-.066l.337,8.565h7.389ZM54.065,18.666a5.666,5.666,0,1,1,5.666,5.666A5.666,5.666,0,0,1,54.065,18.666Zm9.632,0a3.966,3.966,0,1,0-3.966,3.966A3.966,3.966,0,0,0,63.7,18.666Zm-8.065,7.366h8.2a1.619,1.619,0,0,1,1.631,1.7L64.436,53.8a1.783,1.783,0,0,1-1.768,1.7H56.8a1.782,1.782,0,0,1-1.768-1.7L54,27.733A1.622,1.622,0,0,1,55.633,26.032Z"
                          transform="translate(-38.135 -13)"
                          fill="#969696"
                          fill-rule="evenodd"
                        />
                        <path
                          id="Path_1102"
                          data-name="Path 1102"
                          d="M1.959,28l7.447.02V41.73H1.959Z"
                          fill="#969696"
                        />
                        <path
                          id="Path_1103"
                          data-name="Path 1103"
                          d="M17.964,23.463l7.774,1.092V41.277H17.964Z"
                          fill="#969696"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <div class="ellipse">{{ $t("occupancy") }}</div>
                <!-- {{ $tc("status", 1) }} -->
              </button>
            </div>

            <div
              v-if="section.seatLayout && enableSyncDualDisplay"
              class="col-2 px-0"
            >
              <button
                class="btn-pos-menu"
                v-on:click="posFooterAction('refreshDualDisplay')"
              >
                <div class="svg-container">
                  <div class="footer-icon-reload"></div>
                </div>
                <div>{{ "Sync Display" }}</div>
              </button>
            </div>

            <div v-if="section.seatLayout" class="col-2 px-0">
              <button
                class="btn-pos-menu"
                v-on:click="posFooterAction('showSessionBlockedSeats')"
              >
                <div class="svg-container">
                  <svg
                    width="96"
                    height="96"
                    viewBox="0 0 96 96"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.95">
                      <rect
                        x="18"
                        y="18"
                        width="14"
                        height="14"
                        rx="3"
                        fill="#8B5CF6"
                      />
                      <rect
                        x="41"
                        y="18"
                        width="14"
                        height="14"
                        rx="3"
                        fill="#8B5CF6"
                      />
                      <rect
                        x="64"
                        y="18"
                        width="14"
                        height="14"
                        rx="3"
                        fill="#8B5CF6"
                      />

                      <!-- Row 2 -->
                      <rect
                        x="18"
                        y="41"
                        width="14"
                        height="14"
                        rx="3"
                        fill="#A78BFA"
                      />
                      <rect
                        x="41"
                        y="41"
                        width="14"
                        height="14"
                        rx="3"
                        fill="#EF4444"
                      />
                      <rect
                        x="64"
                        y="41"
                        width="14"
                        height="14"
                        rx="3"
                        fill="#A78BFA"
                      />

                      <!-- Row 3 -->
                      <rect
                        x="18"
                        y="64"
                        width="14"
                        height="14"
                        rx="3"
                        fill="#C4B5FD"
                      />
                      <rect
                        x="41"
                        y="64"
                        width="14"
                        height="14"
                        rx="3"
                        fill="#C4B5FD"
                      />
                      <rect
                        x="64"
                        y="64"
                        width="14"
                        height="14"
                        rx="3"
                        fill="#C4B5FD"
                      />
                    </g>

                    <circle
                      cx="72"
                      cy="72"
                      r="13"
                      fill="#FFFFFF"
                      stroke="#8B5CF6"
                      stroke-width="2"
                    />

                    <path
                      d="M66 72L70 76L78 68"
                      stroke="#8B5CF6"
                      stroke-width="2.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div>{{ "Reservations" }}</div>
              </button>
            </div>

            <div v-if="section.seatLayout" class="col-2 px-0">
              <button
                class="btn-pos-menu"
                v-on:click="posFooterAction('BlockSeats')"
              >
                <div class="svg-container">
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="4"
                      y="10"
                      width="22"
                      height="14"
                      rx="2"
                      stroke="#969696"
                      stroke-width="1.5"
                      fill="none"
                    />
                    <path
                      d="M9 10V8C9 5.79086 10.7909 4 13 4H17C19.2091 4 21 5.79086 21 8V10"
                      stroke="#969696"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <circle cx="15" cy="17" r="2" fill="#969696" />
                    <path
                      d="M15 19V21"
                      stroke="#969696"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                <div>{{ "Block Seats" }}</div>
              </button>
            </div>

            <div
              v-if="section.seatLayout && fnbactive"
              class="col-2 px-0 footer-menu-action"
            >
              <div
                role="button"
                :tabindex="
                  enableClass || checkoutBtndis || !seatsSelected.length
                    ? -1
                    : 0
                "
                :class="[
                  'footer-menu-action-control',
                  enableClass || checkoutBtndis || !seatsSelected.length
                    ? 'disabled'
                    : '',
                ]"
                @click="
                  enableClass || checkoutBtndis || !seatsSelected.length
                    ? null
                    : onClickProceed('isFnb')
                "
              >
                <span class="footer-menu-action-icon">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M12 5v14M5 12h14" />
                  </svg>
                </span>
                <span>{{ $t("select") }} {{ $tc("fb", 1) }}</span>
              </div>
            </div>

            <div
              v-if="section.checkout"
              class="col-2 px-0 footer-menu-action"
            >
              <div
                role="button"
                :tabindex="enableClass ? -1 : 0"
                :class="[
                  'footer-menu-action-control',
                  enableClass ? 'disabled' : '',
                ]"
                @click="
                  enableClass ? null : $bvModal.show('customerDetails')
                "
              >
                <span class="footer-menu-action-icon">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <circle cx="12" cy="8" r="3.5" />
                    <path d="M5 20c.7-4 3-6 7-6s6.3 2 7 6" />
                  </svg>
                </span>
                <span
                  >{{ $t(isOldCustomer ? "update" : "add") }}
                  {{ $t("customer") }}</span
                >
              </div>
            </div>

            <div
              v-if="section.seatLayout || section.checkout || section.cashCardTopup"
              class="col-2 px-0 footer-menu-action"
            >
              <div
                role="button"
                tabindex="0"
                class="footer-menu-action-control"
                @click="onClickBack()"
              >
                <span class="footer-menu-action-icon">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="m10 6-6 6 6 6M4 12h16" />
                  </svg>
                </span>
                <span>{{ $t("back") }}</span>
              </div>
            </div>

            <div
              v-if="
                section.checkout &&
                authorizeClient(CLIENT_NAMES_OBJ_LIST.star)
              "
              class="col-2 px-0 footer-menu-action"
            >
              <div
                role="button"
                :tabindex="
                  payment_processing || isECRConnected == 'N' ? -1 : 0
                "
                :class="[
                  'footer-menu-action-control',
                  payment_processing || isECRConnected == 'N'
                    ? 'disabled'
                    : '',
                ]"
                @click="
                  payment_processing || isECRConnected == 'N'
                    ? null
                    : onClickCheckOutBtn('generatebillPerSeat')
                "
              >
                <span class="footer-menu-action-icon">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                </span>
                <span v-if="DirectPrint == 'Y'"
                  >{{ $t("print") }} Per Seat</span
                >
                <span v-else>{{ $t("generatebill") }}</span>
              </div>
            </div>

            <div
              v-if="section.seatLayout"
              class="col-2 px-0 footer-menu-action"
            >
              <div
                role="button"
                tabindex="0"
                class="footer-menu-action-control"
                @click="onCancelHandler"
              >
                <span class="footer-menu-action-icon">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="m7 7 10 10M17 7 7 17" />
                  </svg>
                </span>
                <span>{{ $t("Clear") }}</span>
              </div>
            </div>

            <div
              class="col-2 px-0"
              :style="'order:' + order(4)"
            >
              <button class="btn-pos-menu" v-on:click="posFooterAction('Home')">
                <div class="svg-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="27"
                    viewBox="0 0 20 17"
                  >
                    <path
                      id="Icon"
                      d="M733-328v-6h4v6h5v-8h3l-10-9-10,9h3v8Z"
                      transform="translate(-725 345)"
                      fill="#969696"
                      fill-rule="evenodd"
                    />
                  </svg>
                </div>
                <div>{{ "Home" }}</div>
              </button>
            </div>
          </div>

          <div v-if="posHiddenMenus" class="pos-menus-hidden">
            <div class="row h-100 hiddenMenuWrapper d-flex">
              <div class="col-2 px-0 pb-2 border-bottom">
                <button
                  class="btn-pos-menu border-0"
                  v-on:click="posFooterAction('Refresh')"
                >
                  <div class="svg-container">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.5511 0.925995C9.41815 0.917535 6.40535 2.13091 4.15282 4.30831V0.92594C4.15282 0.41455 3.73827 0 3.22688 0C2.71549 0 2.30099 0.41455 2.30099 0.92594V6.4815C2.30088 6.8802 2.55604 7.2342 2.93435 7.36015L8.4899 9.212C8.9757 9.3736 9.5005 9.11075 9.6621 8.625C9.8237 8.1392 9.56085 7.61435 9.07505 7.4528L4.97324 6.088C8.76235 1.96174 15.179 1.68842 19.3053 5.47755C23.4315 9.26665 23.7048 15.6834 19.9157 19.8096C16.1266 23.9358 9.70995 24.2091 5.5837 20.42C3.05397 18.097 1.87158 14.6516 2.44178 11.2648C2.53146 10.7613 2.19607 10.2805 1.69265 10.1908C1.18923 10.101 0.708385 10.4365 0.61865 10.9399C0.617675 10.9454 0.616755 10.9509 0.615885 10.9564C0.505045 11.6195 0.449273 12.2906 0.449219 12.9628C0.45676 19.6076 5.84145 24.9923 12.4861 24.9999C19.1339 25.0179 24.5376 19.6433 24.5556 12.9954C24.5735 6.34765 19.1989 0.943955 12.5511 0.925995Z"
                        fill="#969696"
                      />
                    </svg>
                  </div>
                  {{ $t("refresh") }}
                </button>
              </div>

              <div
                v-if="section.movieDetail"
                :order="order(1)"
                class="col-2 px-0 pb-2 border-bottom"
                :style="'order:' + order(1)"
              >
                <button
                  class="btn-pos-menu"
                  @click="
                    () => {
                      posHiddenMenus = false;
                      posFooterAction('eWalletRecharge');
                    }
                  "
                >
                  <div class="svg-container">
                    <span class="icon-e-wallet-footer"></span>
                  </div>
                  <div>{{ "E Wallet" }}</div>
                </button>
              </div>

              <div
                v-if="section.seatLayout"
                :order="order(1)"
                class="col-2 px-0 pb-2 border-bottom"
                :style="'order:' + order(1)"
              >
                <button
                  class="btn-pos-menu"
                  @click="
                    () => {
                      posHiddenMenus = false;
                      posFooterAction('PrivateBooking');
                    }
                  "
                >
                  <div class="svg-container">
                    <span class="icon-ticket-footer"></span>
                  </div>
                  <div>{{ "Private Booking" }}</div>
                </button>
              </div>

              <div
                v-if="section.movieDetail"
                :order="order(1)"
                class="col-2 px-0 pb-2 border-bottom"
                :style="'order:' + order(1)"
              >
                <button
                  class="btn-pos-menu"
                  @click="
                    () => {
                      posHiddenMenus = false;
                      posFooterAction('moviePass');
                    }
                  "
                >
                  <div class="svg-container">
                    <span class="icon-movie-pass-footer"></span>
                  </div>
                  <div>{{ "Movie Pass" }}</div>
                </button>
              </div>

              <div
                v-if="section.movieDetail"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(2)"
              >
                <button
                  class="btn-pos-menu"
                  @click="posFooterAction('posUserCollection')"
                  :disabled="diabledCashierCollectionBtn"
                >
                  <div class="svg-container">
                    <svg
                      height="100px"
                      width="100px"
                      fill="#969696"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 512 512"
                      style="enable-background: new 0 0 512 512"
                      xml:space="preserve"
                    >
                      <g>
                        <path
                          d="M273.787,344.624c-2.356-1.039-6.93-2.529-13.721-4.47v-18.139c4.782,0.416,8.073,3.292,9.875,8.628l10.551-2.235   c-2.841-9.251-9.65-14.57-20.426-15.956v-7.484h-7.016v7.484c-14.726,1.802-22.089,8.541-22.089,20.218   c0,4.504,1.386,8.376,4.158,11.616s8.749,5.916,17.931,8.03v20.529c-7.034-0.554-11.555-4.487-13.565-11.798l-11.174,2.599   c3.603,11.399,11.85,17.636,24.739,18.71v9.615h7.016v-9.615c7.45-0.658,13.132-2.893,17.047-6.705   c3.915-3.811,5.873-8.593,5.873-14.345c0-4.054-0.944-7.588-2.833-10.603C278.265,347.69,276.143,345.663,273.787,344.624z    M253.049,339.478c-7.068-0.936-10.603-3.829-10.603-8.68c0-2.876,1.013-5.05,3.04-6.523c2.027-1.473,4.548-2.226,7.562-2.261   V339.478z M268.251,369.987c-2.2,1.871-4.929,2.824-8.186,2.859v-19.906c7.657,1.421,11.486,4.66,11.486,9.719   C271.552,365.673,270.452,368.116,268.251,369.987z"
                        ></path>
                        <path
                          d="M414.427,319.087c-14.413-32.836-34.905-63.974-62.675-95.197c-17.781-20.021-33.792-34.591-50.417-45.865   c-3.77-2.561-7.394-4.94-11.141-6.94c4.82-5.494,10.247-11.635,15.851-17.99c11.73-13.286,24.217-27.428,33.435-38.187   c7.192-8.391,8.534-18.509,3.767-28.498c-3.011-6.336-7.82-10.175-12.472-13.885c-1.927-1.527-3.882-3.082-5.708-4.88   c-3.411-3.368-3.268-3.753-0.414-11.045c2.626-6.122-0.457-10.246-4.238-12.101l-3.596-1.812c-3.082-1.613-6.265-3.282-9.875-4.352   c-26.043-7.706-52.886-8.591-79.842-2.669c-9.818,2.155-17.167,5.651-23.132,11.017c-3.04,2.754-4.01,6.279-2.797,10.218   c0.692,2.258,0.738,3.916,0.446,5.141c-0.141,0.316-0.253,0.642-0.336,0.977c-0.6,1.258-1.618,1.868-2.421,2.16   c-14.641,5.109-24.759,13.186-30.952,24.688c-4.31,8.02-3.339,16.311,2.754,23.332c7.421,8.562,30.81,36.318,44.766,52.872   l5.34,6.33c-6.287,3.561-11.944,7.924-17.285,12.207c-37.973,30.496-69.668,67.927-94.198,111.252   c-17.096,30.167-25.901,56.61-27.756,83.21c-2.069,29.882,7.064,55.155,27.142,75.105c6.464,6.45,13.5,10.731,22.376,13.343   c3.824,1.113,7.677,2.24,11.573,3.111c27.67,6.108,55.84,7.906,82.154,8.933c10.874,0.428,21.705,0.642,32.479,0.642   c23.403,0,46.493-1.013,68.954-3.025c14.727-1.327,32.108-3.296,49.304-7.806c9.047-2.369,17.096-4.838,24.117-10.96   c20.164-17.581,30.624-40.528,31.109-68.226C431.123,367.963,425.943,345.373,414.427,319.087z M316.861,75.978   c2.126,2.083,4.381,3.896,6.621,5.68c0.153,0.122,0.299,0.241,0.451,0.362l-17.661,15.778l10.363-22.05   C316.711,75.824,316.782,75.9,316.861,75.978z M202.741,76.206c0.972-0.345,2.069-0.879,3.179-1.607l11.048,19.887l-20.63-15.67   C198.327,77.872,200.457,77.003,202.741,76.206z M179.495,105.546c-2.954-3.425-3.325-6.35-1.284-10.146   c2.013-3.75,4.562-6.994,7.717-9.811l46.139,35.041c1.056,0.799,2.298,1.199,3.539,1.199c1.37,0,2.74-0.485,3.824-1.441   c2.098-1.798,2.626-4.838,1.284-7.249l-27.516-49.51c0.452-2.586,0.372-5.579-0.525-9.013c4.253-3.539,9.675-5.936,16.939-7.535   c25.016-5.494,49.903-4.681,74.02,2.469c2.697,0.799,5.237,2.155,7.777,3.496c0.571,0.3,1.156,0.599,1.741,0.899   c-0.731,1.876-1.435,3.772-1.878,5.716l-27.776,59.099c-1.17,2.512-0.428,5.508,1.798,7.164c1.042,0.785,2.269,1.17,3.496,1.17   c1.398,0,2.783-0.499,3.896-1.498l39.427-35.219c0.2,0.346,0.4,0.691,0.573,1.056c2.768,5.808,2.083,11.002-2.083,15.869   c-9.19,10.731-21.634,24.816-33.321,38.059c-6.709,7.607-13.167,14.91-18.644,21.172c-0.186-0.047-0.362-0.108-0.55-0.152   c-0.785-0.2-1.584-0.314-2.483-0.428l-0.913-0.128c-0.3-0.043-0.585-0.071-0.885-0.071l-21.222,0.009   c-0.033-0.001-0.065-0.008-0.098-0.009c-0.017,0-0.033,0.003-0.049,0.003c-0.022,0-0.043-0.003-0.065-0.003   c-0.058,0-0.114,0.007-0.172,0.009l-13.784,0.006c-0.571,0-1.156,0.086-1.698,0.257l-2.726,0.785   c-0.752,0.212-1.453,0.415-2.13,0.62l-7.503-8.897C210.376,141.949,186.93,114.122,179.495,105.546z M419.036,389.982   c-0.414,24.588-9.276,44.081-27.085,59.607c-5.123,4.467-11.545,6.407-19.408,8.477c-16.354,4.281-33.136,6.179-47.392,7.463   c-32.308,2.911-65.929,3.682-99.921,2.355c-25.772-1.013-53.314-2.768-80.085-8.676c-3.639-0.799-7.221-1.869-11.645-3.168   c-6.108-1.798-11.53-5.109-16.582-10.146c-17.809-17.709-25.572-39.315-23.717-66.029c1.712-24.788,10.061-49.646,26.243-78.244   c23.803-42.026,54.541-78.33,91.359-107.898c7.221-5.794,14.384-11.245,22.718-14.527c1.113-0.428,2.269-0.742,3.625-1.127   l2.098-0.599l2.777-0.001l-32.688,54.3c-1.67,2.768-0.771,6.35,1.998,8.02c2.768,1.684,6.35,0.785,8.02-1.998l27.171-45.131v17.575   c0,3.225,2.626,5.851,5.851,5.851s5.851-2.626,5.851-5.851V194.37l23.774,43.219c1.07,1.941,3.068,3.04,5.123,3.04   c0.956,0,1.927-0.243,2.811-0.728c2.84-1.555,3.867-5.109,2.312-7.934l-29.981-54.508l11.116-0.005   c0.685,0.1,1.969,0.285,1.998,0.3c6.721,1.584,12.515,5.28,19.393,9.946c15.797,10.717,31.124,24.673,48.248,43.953   c26.942,30.296,46.792,60.435,60.706,92.129C414.541,348.47,419.407,369.49,419.036,389.982z"
                        ></path>
                        <path
                          d="M255.998,262.833c-47.221,0-85.636,38.416-85.636,85.636s38.416,85.636,85.636,85.636s85.636-38.416,85.636-85.636   S303.218,262.833,255.998,262.833z M255.998,422.404c-40.77,0-73.935-33.164-73.935-73.935s33.164-73.935,73.935-73.935   s73.935,33.164,73.935,73.935S296.768,422.404,255.998,422.404z"
                        ></path>
                      </g>
                    </svg>
                  </div>
                  <div>Collection</div>
                </button>
              </div>

              <!-- <div
                v-if="section.movieDetail"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(5)"
              >
                <button
                  class="btn-pos-menu"
                  v-on:click="posFooterAction('UnpaidBooking')"
                >
                  <div class="svg-container">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M16 9H3V10H16V9Z" fill="#969696" />
                      <path d="M16 20H3V21H16V20Z" fill="#969696" />
                      <path d="M26.5 9H20V10H26.5V9Z" fill="#969696" />
                      <path d="M26.5 20H20V21H26.5V20Z" fill="#969696" />
                      <mask id="path-5-inside-1" fill="white">
                        <path
                          d="M29.5 11.5C29.7761 11.5 30 11.2761 30 11V7C30 6.72387 29.7761 6.5 29.5 6.5H0.5C0.223875 6.5 0 6.72387 0 7V11C0 11.2761 0.223875 11.5 0.5 11.5C2.433 11.5 4 13.067 4 15C4 16.933 2.433 18.5 0.5 18.5C0.223875 18.5 0 18.7239 0 19V23C0 23.2761 0.223875 23.5 0.5 23.5H29.5C29.7761 23.5 30 23.2761 30 23V19C30 18.7239 29.7761 18.5 29.5 18.5C27.567 18.5 26 16.933 26 15C26 13.067 27.567 11.5 29.5 11.5ZM25.0292 15.5012C25.2633 17.5896 26.9116 19.2379 29 19.472V22.5H1V19.472C3.46981 19.1952 5.24762 16.9686 4.97081 14.4988C4.73675 12.4104 3.08838 10.7621 1 10.528V7.5H29V10.528C26.5302 10.8048 24.7524 13.0314 25.0292 15.5012Z"
                        />
                      </mask>
                      <path
                        d="M29.5 11.5C29.7761 11.5 30 11.2761 30 11V7C30 6.72387 29.7761 6.5 29.5 6.5H0.5C0.223875 6.5 0 6.72387 0 7V11C0 11.2761 0.223875 11.5 0.5 11.5C2.433 11.5 4 13.067 4 15C4 16.933 2.433 18.5 0.5 18.5C0.223875 18.5 0 18.7239 0 19V23C0 23.2761 0.223875 23.5 0.5 23.5H29.5C29.7761 23.5 30 23.2761 30 23V19C30 18.7239 29.7761 18.5 29.5 18.5C27.567 18.5 26 16.933 26 15C26 13.067 27.567 11.5 29.5 11.5ZM25.0292 15.5012C25.2633 17.5896 26.9116 19.2379 29 19.472V22.5H1V19.472C3.46981 19.1952 5.24762 16.9686 4.97081 14.4988C4.73675 12.4104 3.08838 10.7621 1 10.528V7.5H29V10.528C26.5302 10.8048 24.7524 13.0314 25.0292 15.5012Z"
                        fill="#969696"
                      />
                      <path
                        d="M25.0292 15.5012L16.0852 16.5036L16.0852 16.5036L25.0292 15.5012ZM29 19.472H38V11.4243L30.0024 10.528L29 19.472ZM29 22.5V31.5H38V22.5H29ZM1 22.5H-8V31.5H1V22.5ZM1 19.472L-0.00242875 10.528L-8 11.4244L-8 19.472H1ZM4.97081 14.4988L-3.97319 15.5012L-3.97319 15.5012L4.97081 14.4988ZM1 10.528H-8V18.5756L-0.0024324 19.472L1 10.528ZM1 7.5V-1.5H-8V7.5H1ZM29 7.5H38V-1.5H29V7.5ZM29 10.528L30.0024 19.472L38 18.5756V10.528H29ZM29.5 20.5C34.7467 20.5 39 16.2467 39 11H21C21 6.30556 24.8056 2.5 29.5 2.5V20.5ZM39 11V7H21V11H39ZM39 7C39 1.75331 34.7467 -2.5 29.5 -2.5V15.5C24.8056 15.5 21 11.6944 21 7H39ZM29.5 -2.5H0.5V15.5H29.5V-2.5ZM0.5 -2.5C-4.74669 -2.5 -9 1.75331 -9 7H9C9 11.6944 5.19444 15.5 0.5 15.5V-2.5ZM-9 7V11H9V7H-9ZM-9 11C-9 16.2467 -4.74669 20.5 0.5 20.5V2.5C5.19444 2.5 9 6.30556 9 11H-9ZM0.5 20.5C-2.53756 20.5 -5 18.0376 -5 15H13C13 8.09644 7.40356 2.5 0.5 2.5V20.5ZM-5 15C-5 11.9624 -2.53756 9.5 0.5 9.5V27.5C7.40356 27.5 13 21.9036 13 15H-5ZM0.5 9.5C-4.74669 9.5 -9 13.7533 -9 19H9C9 23.6944 5.19444 27.5 0.5 27.5V9.5ZM-9 19V23H9V19H-9ZM-9 23C-9 28.2467 -4.74669 32.5 0.5 32.5V14.5C5.19444 14.5 9 18.3056 9 23H-9ZM0.5 32.5H29.5V14.5H0.5V32.5ZM29.5 32.5C34.7467 32.5 39 28.2467 39 23H21C21 18.3056 24.8056 14.5 29.5 14.5V32.5ZM39 23V19H21V23H39ZM39 19C39 13.7533 34.7467 9.5 29.5 9.5V27.5C24.8056 27.5 21 23.6944 21 19H39ZM29.5 9.5C32.5376 9.5 35 11.9624 35 15H17C17 21.9036 22.5964 27.5 29.5 27.5V9.5ZM35 15C35 18.0376 32.5376 20.5 29.5 20.5V2.5C22.5964 2.5 17 8.09644 17 15H35ZM16.0852 16.5036C16.7874 22.7687 21.7323 27.7138 27.9976 28.416L30.0024 10.528C32.0909 10.7621 33.7391 12.4104 33.9732 14.4988L16.0852 16.5036ZM20 19.472V22.5H38V19.472H20ZM29 13.5H1V31.5H29V13.5ZM10 22.5V19.472H-8V22.5H10ZM2.00243 28.416C9.41174 27.5856 14.7453 20.906 13.9148 13.4964L-3.97319 15.5012C-4.25002 13.0313 -2.47211 10.8048 -0.00242875 10.528L2.00243 28.416ZM13.9148 13.4964C13.2126 7.23107 8.26749 2.28618 2.00243 1.584L-0.0024324 19.472C-2.09074 19.2379 -3.73912 17.5897 -3.97319 15.5012L13.9148 13.4964ZM10 10.528V7.5H-8V10.528H10ZM1 16.5H29V-1.5H1V16.5ZM20 7.5V10.528H38V7.5H20ZM27.9976 1.584C20.5883 2.41442 15.2547 9.09403 16.0852 16.5036L33.9732 14.4988C34.25 16.9687 32.4721 19.1952 30.0024 19.472L27.9976 1.584Z"
                        fill="#969696"
                        mask="url(#path-5-inside-1)"
                      />
                      <path
                        d="M9.00781 13.4453V15.7866C9.00781 16.1756 8.88574 16.4832 8.6416 16.7095C8.39909 16.9357 8.06706 17.0488 7.64551 17.0488C7.23047 17.0488 6.90088 16.939 6.65674 16.7192C6.4126 16.4995 6.28809 16.1976 6.2832 15.8135V13.4453H7.01562V15.7915C7.01562 16.0243 7.07096 16.1943 7.18164 16.3018C7.29395 16.4076 7.44857 16.4604 7.64551 16.4604C8.05729 16.4604 8.26644 16.244 8.27295 15.811V13.4453H9.00781ZM12.499 17H11.7666L10.3408 14.6611V17H9.6084V13.4453H10.3408L11.769 15.7891V13.4453H12.499V17ZM13.8711 15.7476V17H13.1387V13.4453H14.5254C14.7923 13.4453 15.0267 13.4941 15.2285 13.5918C15.432 13.6895 15.5882 13.8286 15.6973 14.0093C15.8063 14.1883 15.8608 14.3926 15.8608 14.6221C15.8608 14.9704 15.7412 15.2454 15.502 15.4473C15.2643 15.6475 14.9347 15.7476 14.5132 15.7476H13.8711ZM13.8711 15.1543H14.5254C14.7191 15.1543 14.8664 15.1087 14.9673 15.0176C15.0698 14.9264 15.1211 14.7962 15.1211 14.627C15.1211 14.4528 15.0698 14.312 14.9673 14.2046C14.8647 14.0972 14.7231 14.0418 14.5425 14.0386H13.8711V15.1543ZM17.9385 16.2676H16.6543L16.4102 17H15.6313L16.9546 13.4453H17.6333L18.9639 17H18.1851L17.9385 16.2676ZM16.8521 15.6743H17.7407L17.2939 14.3438L16.8521 15.6743ZM20.0747 17H19.3423V13.4453H20.0747V17ZM20.7559 17V13.4453H21.8496C22.1621 13.4453 22.4412 13.5161 22.687 13.6577C22.9344 13.7977 23.1273 13.9979 23.2656 14.2583C23.404 14.5171 23.4731 14.8117 23.4731 15.1421V15.3057C23.4731 15.6361 23.4048 15.9299 23.2681 16.187C23.133 16.4442 22.9417 16.6436 22.6943 16.7852C22.4469 16.9268 22.1678 16.9984 21.8569 17H20.7559ZM21.4883 14.0386V16.4116H21.8423C22.1287 16.4116 22.3477 16.318 22.499 16.1309C22.6504 15.9437 22.7277 15.6759 22.731 15.3276V15.1396C22.731 14.7783 22.6561 14.5049 22.5063 14.3193C22.3566 14.1322 22.1377 14.0386 21.8496 14.0386H21.4883Z"
                        fill="#969696"
                      />
                    </svg>
                  </div>
                  {{ $t("unpaid") }} {{ $t("booking") }}
                </button>
              </div> -->

              <div
                v-if="section.movieDetail && !starClient && !novoClient"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(6)"
              >
                <button
                  class="btn-pos-menu"
                  v-on:click="posFooterAction('PayAtCounter')"
                >
                  <div class="svg-container">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M16 9H3V10H16V9Z" fill="#969696" />
                      <path d="M16 20H3V21H16V20Z" fill="#969696" />
                      <path d="M26.5 9H20V10H26.5V9Z" fill="#969696" />
                      <path d="M26.5 20H20V21H26.5V20Z" fill="#969696" />
                      <mask id="path-5-inside-1" fill="white">
                        <path
                          d="M29.5 11.5C29.7761 11.5 30 11.2761 30 11V7C30 6.72387 29.7761 6.5 29.5 6.5H0.5C0.223875 6.5 0 6.72387 0 7V11C0 11.2761 0.223875 11.5 0.5 11.5C2.433 11.5 4 13.067 4 15C4 16.933 2.433 18.5 0.5 18.5C0.223875 18.5 0 18.7239 0 19V23C0 23.2761 0.223875 23.5 0.5 23.5H29.5C29.7761 23.5 30 23.2761 30 23V19C30 18.7239 29.7761 18.5 29.5 18.5C27.567 18.5 26 16.933 26 15C26 13.067 27.567 11.5 29.5 11.5ZM25.0292 15.5012C25.2633 17.5896 26.9116 19.2379 29 19.472V22.5H1V19.472C3.46981 19.1952 5.24762 16.9686 4.97081 14.4988C4.73675 12.4104 3.08838 10.7621 1 10.528V7.5H29V10.528C26.5302 10.8048 24.7524 13.0314 25.0292 15.5012Z"
                        />
                      </mask>
                      <path
                        d="M29.5 11.5C29.7761 11.5 30 11.2761 30 11V7C30 6.72387 29.7761 6.5 29.5 6.5H0.5C0.223875 6.5 0 6.72387 0 7V11C0 11.2761 0.223875 11.5 0.5 11.5C2.433 11.5 4 13.067 4 15C4 16.933 2.433 18.5 0.5 18.5C0.223875 18.5 0 18.7239 0 19V23C0 23.2761 0.223875 23.5 0.5 23.5H29.5C29.7761 23.5 30 23.2761 30 23V19C30 18.7239 29.7761 18.5 29.5 18.5C27.567 18.5 26 16.933 26 15C26 13.067 27.567 11.5 29.5 11.5ZM25.0292 15.5012C25.2633 17.5896 26.9116 19.2379 29 19.472V22.5H1V19.472C3.46981 19.1952 5.24762 16.9686 4.97081 14.4988C4.73675 12.4104 3.08838 10.7621 1 10.528V7.5H29V10.528C26.5302 10.8048 24.7524 13.0314 25.0292 15.5012Z"
                        fill="#969696"
                      />
                      <path
                        d="M25.0292 15.5012L16.0852 16.5036L16.0852 16.5036L25.0292 15.5012ZM29 19.472H38V11.4243L30.0024 10.528L29 19.472ZM29 22.5V31.5H38V22.5H29ZM1 22.5H-8V31.5H1V22.5ZM1 19.472L-0.00242875 10.528L-8 11.4244L-8 19.472H1ZM4.97081 14.4988L-3.97319 15.5012L-3.97319 15.5012L4.97081 14.4988ZM1 10.528H-8V18.5756L-0.0024324 19.472L1 10.528ZM1 7.5V-1.5H-8V7.5H1ZM29 7.5H38V-1.5H29V7.5ZM29 10.528L30.0024 19.472L38 18.5756V10.528H29ZM29.5 20.5C34.7467 20.5 39 16.2467 39 11H21C21 6.30556 24.8056 2.5 29.5 2.5V20.5ZM39 11V7H21V11H39ZM39 7C39 1.75331 34.7467 -2.5 29.5 -2.5V15.5C24.8056 15.5 21 11.6944 21 7H39ZM29.5 -2.5H0.5V15.5H29.5V-2.5ZM0.5 -2.5C-4.74669 -2.5 -9 1.75331 -9 7H9C9 11.6944 5.19444 15.5 0.5 15.5V-2.5ZM-9 7V11H9V7H-9ZM-9 11C-9 16.2467 -4.74669 20.5 0.5 20.5V2.5C5.19444 2.5 9 6.30556 9 11H-9ZM0.5 20.5C-2.53756 20.5 -5 18.0376 -5 15H13C13 8.09644 7.40356 2.5 0.5 2.5V20.5ZM-5 15C-5 11.9624 -2.53756 9.5 0.5 9.5V27.5C7.40356 27.5 13 21.9036 13 15H-5ZM0.5 9.5C-4.74669 9.5 -9 13.7533 -9 19H9C9 23.6944 5.19444 27.5 0.5 27.5V9.5ZM-9 19V23H9V19H-9ZM-9 23C-9 28.2467 -4.74669 32.5 0.5 32.5V14.5C5.19444 14.5 9 18.3056 9 23H-9ZM0.5 32.5H29.5V14.5H0.5V32.5ZM29.5 32.5C34.7467 32.5 39 28.2467 39 23H21C21 18.3056 24.8056 14.5 29.5 14.5V32.5ZM39 23V19H21V23H39ZM39 19C39 13.7533 34.7467 9.5 29.5 9.5V27.5C24.8056 27.5 21 23.6944 21 19H39ZM29.5 9.5C32.5376 9.5 35 11.9624 35 15H17C17 21.9036 22.5964 27.5 29.5 27.5V9.5ZM35 15C35 18.0376 32.5376 20.5 29.5 20.5V2.5C22.5964 2.5 17 8.09644 17 15H35ZM16.0852 16.5036C16.7874 22.7687 21.7323 27.7138 27.9976 28.416L30.0024 10.528C32.0909 10.7621 33.7391 12.4104 33.9732 14.4988L16.0852 16.5036ZM20 19.472V22.5H38V19.472H20ZM29 13.5H1V31.5H29V13.5ZM10 22.5V19.472H-8V22.5H10ZM2.00243 28.416C9.41174 27.5856 14.7453 20.906 13.9148 13.4964L-3.97319 15.5012C-4.25002 13.0313 -2.47211 10.8048 -0.00242875 10.528L2.00243 28.416ZM13.9148 13.4964C13.2126 7.23107 8.26749 2.28618 2.00243 1.584L-0.0024324 19.472C-2.09074 19.2379 -3.73912 17.5897 -3.97319 15.5012L13.9148 13.4964ZM10 10.528V7.5H-8V10.528H10ZM1 16.5H29V-1.5H1V16.5ZM20 7.5V10.528H38V7.5H20ZM27.9976 1.584C20.5883 2.41442 15.2547 9.09403 16.0852 16.5036L33.9732 14.4988C34.25 16.9687 32.4721 19.1952 30.0024 19.472L27.9976 1.584Z"
                        fill="#969696"
                        mask="url(#path-5-inside-1)"
                      />
                      <path
                        d="M9.00781 13.4453V15.7866C9.00781 16.1756 8.88574 16.4832 8.6416 16.7095C8.39909 16.9357 8.06706 17.0488 7.64551 17.0488C7.23047 17.0488 6.90088 16.939 6.65674 16.7192C6.4126 16.4995 6.28809 16.1976 6.2832 15.8135V13.4453H7.01562V15.7915C7.01562 16.0243 7.07096 16.1943 7.18164 16.3018C7.29395 16.4076 7.44857 16.4604 7.64551 16.4604C8.05729 16.4604 8.26644 16.244 8.27295 15.811V13.4453H9.00781ZM12.499 17H11.7666L10.3408 14.6611V17H9.6084V13.4453H10.3408L11.769 15.7891V13.4453H12.499V17ZM13.8711 15.7476V17H13.1387V13.4453H14.5254C14.7923 13.4453 15.0267 13.4941 15.2285 13.5918C15.432 13.6895 15.5882 13.8286 15.6973 14.0093C15.8063 14.1883 15.8608 14.3926 15.8608 14.6221C15.8608 14.9704 15.7412 15.2454 15.502 15.4473C15.2643 15.6475 14.9347 15.7476 14.5132 15.7476H13.8711ZM13.8711 15.1543H14.5254C14.7191 15.1543 14.8664 15.1087 14.9673 15.0176C15.0698 14.9264 15.1211 14.7962 15.1211 14.627C15.1211 14.4528 15.0698 14.312 14.9673 14.2046C14.8647 14.0972 14.7231 14.0418 14.5425 14.0386H13.8711V15.1543ZM17.9385 16.2676H16.6543L16.4102 17H15.6313L16.9546 13.4453H17.6333L18.9639 17H18.1851L17.9385 16.2676ZM16.8521 15.6743H17.7407L17.2939 14.3438L16.8521 15.6743ZM20.0747 17H19.3423V13.4453H20.0747V17ZM20.7559 17V13.4453H21.8496C22.1621 13.4453 22.4412 13.5161 22.687 13.6577C22.9344 13.7977 23.1273 13.9979 23.2656 14.2583C23.404 14.5171 23.4731 14.8117 23.4731 15.1421V15.3057C23.4731 15.6361 23.4048 15.9299 23.2681 16.187C23.133 16.4442 22.9417 16.6436 22.6943 16.7852C22.4469 16.9268 22.1678 16.9984 21.8569 17H20.7559ZM21.4883 14.0386V16.4116H21.8423C22.1287 16.4116 22.3477 16.318 22.499 16.1309C22.6504 15.9437 22.7277 15.6759 22.731 15.3276V15.1396C22.731 14.7783 22.6561 14.5049 22.5063 14.3193C22.3566 14.1322 22.1377 14.0386 21.8496 14.0386H21.4883Z"
                        fill="#969696"
                      />
                    </svg>
                  </div>
                  Pay At Counter
                </button>
              </div>

              <div
                v-if="section.movieDetail && novoClient"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(6)"
              >
                <button
                  class="btn-pos-menu"
                  v-on:click="posFooterAction('CustomerLoyalty')"
                >
                  <div class="svg-container">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M16 9H3V10H16V9Z" fill="#969696" />
                      <path d="M16 20H3V21H16V20Z" fill="#969696" />
                      <path d="M26.5 9H20V10H26.5V9Z" fill="#969696" />
                      <path d="M26.5 20H20V21H26.5V20Z" fill="#969696" />
                      <mask id="path-5-inside-1" fill="white">
                        <path
                          d="M29.5 11.5C29.7761 11.5 30 11.2761 30 11V7C30 6.72387 29.7761 6.5 29.5 6.5H0.5C0.223875 6.5 0 6.72387 0 7V11C0 11.2761 0.223875 11.5 0.5 11.5C2.433 11.5 4 13.067 4 15C4 16.933 2.433 18.5 0.5 18.5C0.223875 18.5 0 18.7239 0 19V23C0 23.2761 0.223875 23.5 0.5 23.5H29.5C29.7761 23.5 30 23.2761 30 23V19C30 18.7239 29.7761 18.5 29.5 18.5C27.567 18.5 26 16.933 26 15C26 13.067 27.567 11.5 29.5 11.5ZM25.0292 15.5012C25.2633 17.5896 26.9116 19.2379 29 19.472V22.5H1V19.472C3.46981 19.1952 5.24762 16.9686 4.97081 14.4988C4.73675 12.4104 3.08838 10.7621 1 10.528V7.5H29V10.528C26.5302 10.8048 24.7524 13.0314 25.0292 15.5012Z"
                        />
                      </mask>
                      <path
                        d="M29.5 11.5C29.7761 11.5 30 11.2761 30 11V7C30 6.72387 29.7761 6.5 29.5 6.5H0.5C0.223875 6.5 0 6.72387 0 7V11C0 11.2761 0.223875 11.5 0.5 11.5C2.433 11.5 4 13.067 4 15C4 16.933 2.433 18.5 0.5 18.5C0.223875 18.5 0 18.7239 0 19V23C0 23.2761 0.223875 23.5 0.5 23.5H29.5C29.7761 23.5 30 23.2761 30 23V19C30 18.7239 29.7761 18.5 29.5 18.5C27.567 18.5 26 16.933 26 15C26 13.067 27.567 11.5 29.5 11.5ZM25.0292 15.5012C25.2633 17.5896 26.9116 19.2379 29 19.472V22.5H1V19.472C3.46981 19.1952 5.24762 16.9686 4.97081 14.4988C4.73675 12.4104 3.08838 10.7621 1 10.528V7.5H29V10.528C26.5302 10.8048 24.7524 13.0314 25.0292 15.5012Z"
                        fill="#969696"
                      />
                      <path
                        d="M25.0292 15.5012L16.0852 16.5036L16.0852 16.5036L25.0292 15.5012ZM29 19.472H38V11.4243L30.0024 10.528L29 19.472ZM29 22.5V31.5H38V22.5H29ZM1 22.5H-8V31.5H1V22.5ZM1 19.472L-0.00242875 10.528L-8 11.4244L-8 19.472H1ZM4.97081 14.4988L-3.97319 15.5012L-3.97319 15.5012L4.97081 14.4988ZM1 10.528H-8V18.5756L-0.0024324 19.472L1 10.528ZM1 7.5V-1.5H-8V7.5H1ZM29 7.5H38V-1.5H29V7.5ZM29 10.528L30.0024 19.472L38 18.5756V10.528H29ZM29.5 20.5C34.7467 20.5 39 16.2467 39 11H21C21 6.30556 24.8056 2.5 29.5 2.5V20.5ZM39 11V7H21V11H39ZM39 7C39 1.75331 34.7467 -2.5 29.5 -2.5V15.5C24.8056 15.5 21 11.6944 21 7H39ZM29.5 -2.5H0.5V15.5H29.5V-2.5ZM0.5 -2.5C-4.74669 -2.5 -9 1.75331 -9 7H9C9 11.6944 5.19444 15.5 0.5 15.5V-2.5ZM-9 7V11H9V7H-9ZM-9 11C-9 16.2467 -4.74669 20.5 0.5 20.5V2.5C5.19444 2.5 9 6.30556 9 11H-9ZM0.5 20.5C-2.53756 20.5 -5 18.0376 -5 15H13C13 8.09644 7.40356 2.5 0.5 2.5V20.5ZM-5 15C-5 11.9624 -2.53756 9.5 0.5 9.5V27.5C7.40356 27.5 13 21.9036 13 15H-5ZM0.5 9.5C-4.74669 9.5 -9 13.7533 -9 19H9C9 23.6944 5.19444 27.5 0.5 27.5V9.5ZM-9 19V23H9V19H-9ZM-9 23C-9 28.2467 -4.74669 32.5 0.5 32.5V14.5C5.19444 14.5 9 18.3056 9 23H-9ZM0.5 32.5H29.5V14.5H0.5V32.5ZM29.5 32.5C34.7467 32.5 39 28.2467 39 23H21C21 18.3056 24.8056 14.5 29.5 14.5V32.5ZM39 23V19H21V23H39ZM39 19C39 13.7533 34.7467 9.5 29.5 9.5V27.5C24.8056 27.5 21 23.6944 21 19H39ZM29.5 9.5C32.5376 9.5 35 11.9624 35 15H17C17 21.9036 22.5964 27.5 29.5 27.5V9.5ZM35 15C35 18.0376 32.5376 20.5 29.5 20.5V2.5C22.5964 2.5 17 8.09644 17 15H35ZM16.0852 16.5036C16.7874 22.7687 21.7323 27.7138 27.9976 28.416L30.0024 10.528C32.0909 10.7621 33.7391 12.4104 33.9732 14.4988L16.0852 16.5036ZM20 19.472V22.5H38V19.472H20ZM29 13.5H1V31.5H29V13.5ZM10 22.5V19.472H-8V22.5H10ZM2.00243 28.416C9.41174 27.5856 14.7453 20.906 13.9148 13.4964L-3.97319 15.5012C-4.25002 13.0313 -2.47211 10.8048 -0.00242875 10.528L2.00243 28.416ZM13.9148 13.4964C13.2126 7.23107 8.26749 2.28618 2.00243 1.584L-0.0024324 19.472C-2.09074 19.2379 -3.73912 17.5897 -3.97319 15.5012L13.9148 13.4964ZM10 10.528V7.5H-8V10.528H10ZM1 16.5H29V-1.5H1V16.5ZM20 7.5V10.528H38V7.5H20ZM27.9976 1.584C20.5883 2.41442 15.2547 9.09403 16.0852 16.5036L33.9732 14.4988C34.25 16.9687 32.4721 19.1952 30.0024 19.472L27.9976 1.584Z"
                        fill="#969696"
                        mask="url(#path-5-inside-1)"
                      />
                      <path
                        d="M9.00781 13.4453V15.7866C9.00781 16.1756 8.88574 16.4832 8.6416 16.7095C8.39909 16.9357 8.06706 17.0488 7.64551 17.0488C7.23047 17.0488 6.90088 16.939 6.65674 16.7192C6.4126 16.4995 6.28809 16.1976 6.2832 15.8135V13.4453H7.01562V15.7915C7.01562 16.0243 7.07096 16.1943 7.18164 16.3018C7.29395 16.4076 7.44857 16.4604 7.64551 16.4604C8.05729 16.4604 8.26644 16.244 8.27295 15.811V13.4453H9.00781ZM12.499 17H11.7666L10.3408 14.6611V17H9.6084V13.4453H10.3408L11.769 15.7891V13.4453H12.499V17ZM13.8711 15.7476V17H13.1387V13.4453H14.5254C14.7923 13.4453 15.0267 13.4941 15.2285 13.5918C15.432 13.6895 15.5882 13.8286 15.6973 14.0093C15.8063 14.1883 15.8608 14.3926 15.8608 14.6221C15.8608 14.9704 15.7412 15.2454 15.502 15.4473C15.2643 15.6475 14.9347 15.7476 14.5132 15.7476H13.8711ZM13.8711 15.1543H14.5254C14.7191 15.1543 14.8664 15.1087 14.9673 15.0176C15.0698 14.9264 15.1211 14.7962 15.1211 14.627C15.1211 14.4528 15.0698 14.312 14.9673 14.2046C14.8647 14.0972 14.7231 14.0418 14.5425 14.0386H13.8711V15.1543ZM17.9385 16.2676H16.6543L16.4102 17H15.6313L16.9546 13.4453H17.6333L18.9639 17H18.1851L17.9385 16.2676ZM16.8521 15.6743H17.7407L17.2939 14.3438L16.8521 15.6743ZM20.0747 17H19.3423V13.4453H20.0747V17ZM20.7559 17V13.4453H21.8496C22.1621 13.4453 22.4412 13.5161 22.687 13.6577C22.9344 13.7977 23.1273 13.9979 23.2656 14.2583C23.404 14.5171 23.4731 14.8117 23.4731 15.1421V15.3057C23.4731 15.6361 23.4048 15.9299 23.2681 16.187C23.133 16.4442 22.9417 16.6436 22.6943 16.7852C22.4469 16.9268 22.1678 16.9984 21.8569 17H20.7559ZM21.4883 14.0386V16.4116H21.8423C22.1287 16.4116 22.3477 16.318 22.499 16.1309C22.6504 15.9437 22.7277 15.6759 22.731 15.3276V15.1396C22.731 14.7783 22.6561 14.5049 22.5063 14.3193C22.3566 14.1322 22.1377 14.0386 21.8496 14.0386H21.4883Z"
                        fill="#969696"
                      />
                    </svg>
                  </div>
                  Customer Loyalty
                </button>
              </div>

              <div
                v-if="section.movieDetail && false"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(7)"
              >
                <button
                  class="btn-pos-menu"
                  v-on:click="posFooterAction('PosPickUpTicket')"
                >
                  <div class="svg-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="27"
                      height="27"
                      viewBox="0 0 50.334 40.34"
                    >
                      <g
                        id="noun_box_office_19312"
                        data-name="noun_box office_19312"
                        transform="translate(0 -10.06)"
                      >
                        <g id="Group_314" data-name="Group 314">
                          <g id="Group_313" data-name="Group 313">
                            <path
                              id="Path_1091"
                              data-name="Path 1091"
                              d="M35.117,39.266a4.011,4.011,0,1,1,4.015-4.008A4.013,4.013,0,0,1,35.117,39.266Z"
                              fill="#969696"
                            />
                          </g>
                          <path
                            id="Path_1092"
                            data-name="Path 1092"
                            d="M34.236,50.055l.13-.084h.007l4.945-5.1a.532.532,0,1,1,.765.739l-4.592,4.735H46.259a22.475,22.475,0,0,0-4.772-9.213c-.957-1.157-3.522-2.261-5.292-.594A11.614,11.614,0,0,0,33.4,46.023l-4.509-4.562a1.863,1.863,0,0,0-2.651,2.619L31.9,49.8a1.87,1.87,0,0,0,2.339.254Z"
                            fill="#969696"
                          />
                        </g>
                        <g id="Group_316" data-name="Group 316">
                          <g id="Group_315" data-name="Group 315">
                            <path
                              id="Path_1093"
                              data-name="Path 1093"
                              d="M11.14,39.266a4.011,4.011,0,1,0-4.013-4.008A4.013,4.013,0,0,0,11.14,39.266Z"
                              fill="#969696"
                            />
                          </g>
                          <path
                            id="Path_1094"
                            data-name="Path 1094"
                            d="M12.02,50.055l-.129-.084h-.005l-4.946-5.1a.532.532,0,0,0-.765.739l4.593,4.735H0a22.475,22.475,0,0,1,4.772-9.213c.955-1.157,3.522-2.261,5.292-.594a11.612,11.612,0,0,1,2.793,5.484l4.51-4.562a1.863,1.863,0,0,1,2.65,2.619L14.361,49.8a1.872,1.872,0,0,1-2.341.254Z"
                            fill="#969696"
                          />
                        </g>
                        <path
                          id="Path_1095"
                          data-name="Path 1095"
                          d="M21.349,23.732V33.985h3.62v-6.65H46.714V50.4h3.62V23.732Z"
                          fill="#969696"
                        />
                        <rect
                          id="Rectangle_213"
                          data-name="Rectangle 213"
                          width="3.62"
                          height="13.323"
                          transform="translate(21.349 37.077)"
                          fill="#969696"
                        />
                        <path
                          id="Path_1096"
                          data-name="Path 1096"
                          d="M45.635,13.034V10.06H40.559V11.7H39.113V10.06H26.6v2.975a2.6,2.6,0,0,1,0,5.2v2.973H39.113V19.57h1.446v1.642h5.076V18.24a2.6,2.6,0,0,1,0-5.206ZM40.559,18H39.113V16.354h1.446Zm0-3.165H39.113V13.187h1.446Z"
                          fill="#969696"
                        />
                      </g>
                    </svg>
                  </div>

                  <div>{{ $t("pickup") }} {{ $tc("ticket", 1) }}</div>
                </button>
              </div>

              <div
                v-if="
                  section.movieDetail &&
                  !authorizeClient(CLIENT_NAMES_OBJ_LIST.star)
                "
                :order="order(1)"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(1)"
              >
                <button
                  class="btn-pos-menu"
                  @click="
                    () => {
                      posHiddenMenus = false;
                      posFooterAction('cashCard');
                    }
                  "
                >
                  <div class="svg-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="100"
                      height="100"
                      viewBox="0 0 100 100"
                    >
                      <rect width="100%" height="100%" fill="#ffffff"></rect>
                      <g
                        transform="translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)"
                        style="fill: #969696"
                      >
                        <svg
                          fill="#969696"
                          xmlns:dc="http://purl.org/dc/elements/1.1/"
                          xmlns:cc="http://creativecommons.org/ns#"
                          xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                          xmlns:svg="http://www.w3.org/2000/svg"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
                          xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
                          version="1.1"
                          x="0px"
                          y="0px"
                          viewBox="0 0 100 100"
                        >
                          <g transform="translate(0,-952.36218)">
                            <path
                              d="m 85.625011,975.36216 c 4.591382,0 8.374996,3.76154 8.374996,8.31249 l 0,37.37505 c 0,4.5509 -3.783614,8.3125 -8.374996,8.3125 l -71.281204,0 c -4.591488,0 -8.343814,-3.7786 -8.343814,-8.3125 l 0,-37.37505 c 0,-4.53394 3.752326,-8.31249 8.343814,-8.31249 l 71.281204,0 z m 0,4.37499 -71.281204,0 c -2.154614,0 -3.906212,1.78494 -3.906212,3.9375 l 0,1.93752 79.125022,0 0,-1.93752 c 0,-2.13555 -1.783098,-3.9375 -3.937606,-3.9375 z m 3.937606,19.96877 -79.125022,0 0,21.34378 c 0,2.1525 1.751598,3.9375 3.906212,3.9375 l 71.281204,0 c 2.154508,0 3.937606,-1.802 3.937606,-3.9375 l 0,-21.34378 z"
                              style="
                                text-indent: 0;
                                text-transform: none;
                                direction: ltr;
                                block-progression: tb;
                                baseline-shift: baseline;
                                color: #000000;
                                enable-background: accumulate;
                              "
                              fill="#969696"
                              fill-opacity="1"
                              fill-rule="evenodd"
                              stroke="none"
                              marker="none"
                              visibility="visible"
                              display="inline"
                              overflow="visible"
                            ></path>
                            <path
                              d="m 45.792535,1005.9578 a 2.7593622,2.1945051 0 1 1 0,4.3881 l -25.369546,0 a 2.7593622,2.1945051 0 1 1 0,-4.3881 l 25.369546,0 z"
                              style="
                                text-indent: 0;
                                text-transform: none;
                                direction: ltr;
                                block-progression: tb;
                                baseline-shift: baseline;
                                color: #000000;
                                enable-background: accumulate;
                              "
                              fill="#969696"
                              fill-opacity="1"
                              fill-rule="evenodd"
                              stroke="none"
                              marker="none"
                              visibility="visible"
                              display="inline"
                              overflow="visible"
                            ></path>
                            <path
                              d="m 40.222173,1013.8106 a 2.2140577,2.1945051 0 1 1 0,4.3881 l -20.355944,0 a 2.2140577,2.1945051 0 1 1 0,-4.3881 l 20.355944,0 z"
                              style="
                                text-indent: 0;
                                text-transform: none;
                                direction: ltr;
                                block-progression: tb;
                                baseline-shift: baseline;
                                color: #000000;
                                enable-background: accumulate;
                              "
                              fill="#969696"
                              fill-opacity="1"
                              fill-rule="evenodd"
                              stroke="none"
                              marker="none"
                              visibility="visible"
                              display="inline"
                              overflow="visible"
                            ></path>
                          </g>
                        </svg>
                      </g>
                    </svg>
                  </div>
                  <div>{{ $t("cash") }} {{ $t("card") }}</div>
                </button>
              </div>

              <div
                v-if="false"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(17)"
              >
                <button class="btn-pos-menu" v-b-modal.splitPayments>
                  <div class="svg-container">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M29.7263 5.89913L24.1014 0.274214C23.7358 -0.0914048 23.1414 -0.0914048 22.7758 0.274214L17.1509 5.89913C16.8827 6.16912 16.8021 6.57037 16.9465 6.92099C17.0909 7.27161 17.434 7.50035 17.8127 7.50035H20.6252V10.1066C20.6252 11.0609 20.1583 11.9384 19.3746 12.4578L15.949 14.7415C15.6284 14.9515 15.3134 15.1952 15.0003 15.4784C14.6871 15.1952 14.374 14.9534 14.0572 14.7452L10.6222 12.4559C9.84222 11.9384 9.37535 11.0609 9.37535 10.1066V7.50035H12.1878C12.5666 7.50035 12.9097 7.27161 13.054 6.92099C13.1984 6.57037 13.1178 6.16912 12.8515 5.89913L7.22663 0.274214C6.86102 -0.0914048 6.26665 -0.0914048 5.90103 0.274214L0.276119 5.89913C0.00799783 6.16912 -0.0726259 6.57037 0.0717469 6.92099C0.21612 7.27161 0.559239 7.50035 0.937983 7.50035H3.75044V10.1066C3.75044 12.9378 5.15479 15.5627 7.50601 17.1302L10.941 19.4195C11.7209 19.937 12.1878 20.8145 12.1878 21.7689V29.0625C12.1878 29.58 12.6078 30 13.1253 30H16.8752C17.3927 30 17.8127 29.58 17.8127 29.0625V21.7689C17.8127 20.8145 18.2796 19.937 19.0633 19.4177L22.4945 17.1302C24.8457 15.5627 26.2501 12.9378 26.2501 10.1066V7.50035H29.0625C29.4413 7.50035 29.7844 7.27161 29.9288 6.92099C30.0732 6.57037 29.9925 6.16912 29.7263 5.89913ZM25.3126 5.62538C24.7951 5.62538 24.3751 6.04537 24.3751 6.56287V10.1066C24.3751 12.3078 23.2839 14.3515 21.4539 15.5702L18.0265 17.8558C16.7177 18.7202 15.9377 20.1827 15.9377 21.7689V28.125H14.0628V21.7689C14.0628 20.1827 13.2828 18.7221 11.9778 17.8577L8.54661 15.5702C6.71664 14.3515 5.62541 12.3078 5.62541 10.1066V6.56287C5.62541 6.04537 5.20542 5.62538 4.68792 5.62538H3.20107L6.5629 2.26356L9.92472 5.62538H8.43787C7.92037 5.62538 7.50038 6.04537 7.50038 6.56287V10.1066C7.50038 11.6928 8.28037 13.1534 9.58535 14.0177L13.0222 16.309C13.4478 16.5883 13.8678 16.9558 14.3121 17.4358C14.6646 17.8202 15.3378 17.8202 15.6884 17.4358C16.1309 16.9558 16.5527 16.5883 16.9821 16.3052L20.4096 14.0196C21.7202 13.1553 22.5001 11.6928 22.5001 10.1066V6.56287C22.5001 6.04537 22.0802 5.62538 21.5627 5.62538H20.0758L23.4376 2.26356L26.7995 5.62538H25.3126V5.62538Z"
                        fill="#969696"
                      />
                    </svg>
                  </div>
                  <div>Split Payments</div>
                </button>
              </div>

              <!-- Customer Loyalty Points -->
              <!-- <div
                :order="order(9)"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(9)"
              >
                <button
                  class="btn-pos-menu"
                  @click="posFooterAction('PosCustomerLoyaltyPoints')"
                >
                  <div class="svg-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="100"
                      height="100"
                      viewBox="0 0 100 100"
                    >
                      <rect width="100%" height="100%" fill="#ffffff"></rect>
                      <g
                        transform="translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)"
                        style="fill: #969696"
                      >
                        <svg
                          fill="#969696"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 64 64"
                          x="0px"
                          y="0px"
                        >
                          <title>loyalty</title>
                          <g>
                            <path
                              d="M36,27a9.761,9.761,0,0,0-4,.895A9.761,9.761,0,0,0,28,27,10.011,10.011,0,0,0,18,37c0,9.53,13.026,15.652,13.581,15.908a1,1,0,0,0,.838,0C32.974,52.652,46,46.53,46,37A10.011,10.011,0,0,0,36,27ZM32,50.886C29.831,49.783,20,44.377,20,37a7.9,7.9,0,0,1,11.554-7.1,1.013,1.013,0,0,0,.892,0A7.9,7.9,0,0,1,44,37C44,44.377,34.169,49.783,32,50.886Z"
                            ></path>
                            <polygon
                              points="56 35 56 33 58 33 58 31 56 31 56 29 54 29 54 31 52 31 52 33 54 33 54 35 56 35"
                            ></polygon>
                            <polygon
                              points="31 25 33 25 33 23 35 23 35 21 33 21 33 19 31 19 31 21 29 21 29 23 31 23 31 25"
                            ></polygon>
                            <polygon
                              points="62 41 60 41 60 39 58 39 58 41 56 41 56 43 58 43 58 45 60 45 60 43 62 43 62 41"
                            ></polygon>
                            <polygon
                              points="10 29 8 29 8 31 6 31 6 33 8 33 8 35 10 35 10 33 12 33 12 31 10 31 10 29"
                            ></polygon>
                            <polygon
                              points="6 39 4 39 4 41 2 41 2 43 4 43 4 45 6 45 6 43 8 43 8 41 6 41 6 39"
                            ></polygon>
                            <path
                              d="M58,19a9.01,9.01,0,0,0-8-8.941V5a3,3,0,0,0-3-3H17a3,3,0,0,0-3,3v5.059a9,9,0,0,0,0,17.882V59a3,3,0,0,0,3,3H47a3,3,0,0,0,3-3V27.941A9.01,9.01,0,0,0,58,19Zm-2,0a7,7,0,1,1-7-7A7.008,7.008,0,0,1,56,19ZM22,4H42V5a1,1,0,0,1-1,1H23a1,1,0,0,1-1-1ZM8,19a7,7,0,1,1,7,7A7.008,7.008,0,0,1,8,19ZM47,60H17a1,1,0,0,1-1-1V27.941a9,9,0,0,0,0-17.882V5a1,1,0,0,1,1-1h3V5a3,3,0,0,0,3,3H41a3,3,0,0,0,3-3V4h3a1,1,0,0,1,1,1v5.059a9,9,0,0,0,0,17.882V59A1,1,0,0,1,47,60Z"
                            ></path>
                            <path
                              d="M48,13v1a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h2v2H46v2h2v1h2V24a2,2,0,0,0,2-2V20a2,2,0,0,0-2-2H48V16h4V14H50V13Z"
                            ></path>
                            <path
                              d="M16,25V24a2,2,0,0,0,2-2V20a2,2,0,0,0-2-2H14V16h4V14H16V13H14v1a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h2v2H12v2h2v1Z"
                            ></path>
                            <path
                              d="M33,33H31v1a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h2v2H29v2h2v1h2V44a2,2,0,0,0,2-2V40a2,2,0,0,0-2-2H31V36h4V34H33Z"
                            ></path>
                          </g>
                        </svg>
                      </g>
                    </svg>
                  </div>
                  <div>
                    {{ $t("customer") }} {{ $t("loyalty") }} {{ $t("points") }}
                  </div>
                </button>
              </div> -->
              <!--  -->

              <!-- <div class="col-2 px-0" :style="'order:' + order(13)">
                <button
                  class="btn-pos-menu"
                  v-on:click="gotoRoute('/pos-occupancy')"
                >
                  <div class="svg-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="29.888"
                      height="27.632"
                      viewBox="0 0 29.888 27.632"
                    >
                      <path
                        d="M58.485,84.785A1.169,1.169,0,0,1,60.416,86.1,13.816,13.816,0,1,1,62.4,74.956l.477-.818A1.171,1.171,0,0,1,64.9,75.319l-2.175,3.72a1.17,1.17,0,0,1-1.773.294L57.8,76.6a1.168,1.168,0,0,1,1.529-1.766l.82.71a11.476,11.476,0,1,0-1.66,9.244ZM47.992,69.939h2.23v1.92c2.013.291,3.559,1.4,3.643,3.779l-2.555.088a1.91,1.91,0,0,0-1.088-1.633v2.813c2.186.564,4.013,1.4,4.013,4.047a3.693,3.693,0,0,1-2.306,3.439,6.019,6.019,0,0,1-1.707.41v1.89h-2.23V84.775a4.354,4.354,0,0,1-4.013-4.239l2.485-.246A2.638,2.638,0,0,0,47.992,82.5V78.979c-1.839-.527-3.537-1.453-3.537-3.671,0-2.152,1.688-3.181,3.537-3.454V69.939Zm2.23,9.6v3.033a1.7,1.7,0,0,0,1.458-1.605c0-.755-.679-1.167-1.458-1.428ZM47.992,76.3V74.022c-.582.158-1.105.486-1.105,1.117C46.887,75.7,47.393,76.058,47.992,76.3Z"
                        transform="translate(-35.19 -64.5)"
                        fill="#969696"
                      />
                    </svg>
                  </div>
                  <div>{{ $t("update") }} {{ $t("occupancy") }}</div>
                </button>
              </div> -->

              <div
                v-if="section.movieDetail"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(14)"
              >
                <button
                  class="btn-pos-menu"
                  @click="posFooterAction('posUserTransaction')"
                >
                  <div class="svg-container">
                    <svg
                      height="100px"
                      width="100px"
                      fill="#969696"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      style="enable-background: new 0 0 100 100"
                      xml:space="preserve"
                    >
                      <path
                        d="M41.6,99.3H5.8c-1,0-1.9-0.8-1.9-1.9V2.7c0-1,0.8-1.9,1.9-1.9h60c0.5,0,1,0.2,1.3,0.5l17.3,17  c0.4,0.4,0.6,0.8,0.6,1.4V37c0,1-0.8,1.9-1.9,1.9c-1,0-1.9-0.8-1.9-1.9V20.5L65,4.6H7.7v90.8h33.8c1,0,1.9,0.8,1.9,1.9  S42.6,99.3,41.6,99.3z"
                      ></path>
                      <path
                        d="M18.9,33.3H59c1.2,0,2.2-1,2.2-2.2S60.2,29,59,29H18.9c-1.2,0-2.2,1-2.2,2.2S17.7,33.3,18.9,33.3z"
                      ></path>
                      <path
                        d="M19.1,21.2h40.1c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2H19.1c-1.2,0-2.2,1-2.2,2.2  C17,20.3,17.9,21.2,19.1,21.2z"
                      ></path>
                      <path
                        d="M19.1,45.7h23.4c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2H19.1c-1.2,0-2.2,1-2.2,2.2S17.9,45.7,19.1,45.7z"
                      ></path>
                      <path
                        d="M33.7,58.5H19c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h14.6c1.2,0,2.2,1,2.2,2.2S34.9,58.5,33.7,58.5z"
                      ></path>
                      <path
                        d="M70.8,65.3c0,0.7,0.6,1.2,1.3,1.2c0,0,0,0,0,0c0.7,0,1.3-0.6,1.3-1.3c0-1.9-1.3-5.5-5.9-6v-1.4  c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3v1.4c-1.7,0.2-3.1,0.8-4.2,1.9c-1.6,1.6-1.7,3.7-1.7,4.1c0,0.5-0.1,2.7,1.5,4.4  c1,1.1,2.5,1.8,4.4,2v7.5c-3.1-0.6-3.3-3-3.3-3.5c0-0.7-0.6-1.3-1.3-1.2c-0.7,0-1.3,0.6-1.3,1.3c0,1.9,1.3,5.5,5.9,6v1.4  c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3v-1.4c1.7-0.2,3.1-0.8,4.2-1.9c1.6-1.6,1.7-3.7,1.7-4.1c0-0.5,0.1-2.7-1.5-4.4  c-1-1.1-2.5-1.8-4.4-2v-7.5C70.5,62.3,70.8,64.7,70.8,65.3z M64.9,69.1c-1.1-0.2-1.9-0.5-2.5-1.2c-1-1.1-0.8-2.5-0.8-2.5  c0-0.1,0-0.1,0-0.2c0,0,0-1.4,1-2.4c0.6-0.6,1.3-0.9,2.3-1.1V69.1z M70,72.9c1,1.1,0.8,2.5,0.8,2.5c0,0.1,0,0.1,0,0.2  c0,0,0,1.4-1,2.4c-0.6,0.6-1.3,0.9-2.3,1.1v-7.4C68.6,72,69.4,72.3,70,72.9z"
                      ></path>
                      <path
                        d="M66.8,41.6C50.9,41.6,38,54.5,38,70.4s12.9,28.8,28.8,28.8s28.8-12.9,28.8-28.8S82.7,41.6,66.8,41.6z   M93,69.1h-3.1c-0.3-5.4-2.5-10.4-5.9-14.2l2.1-2.1C90.2,57.1,92.7,62.9,93,69.1z M82.2,53.1c-3.9-3.6-9.1-5.8-14.7-6v-2.8  c6.5,0.2,12.4,2.7,16.9,6.7L82.2,53.1z M64.9,47.1c-5.6,0.4-10.6,2.7-14.4,6.3l-1.8-1.8c4.3-4.1,10-6.8,16.3-7.3V47.1z M48.7,55.3  c-3.2,3.8-5.2,8.6-5.5,13.8h-2.5c0.3-6,2.6-11.4,6.2-15.7L48.7,55.3z M43.2,71.7c0.3,5.5,2.5,10.5,6,14.4L47.4,88  c-3.9-4.4-6.4-10-6.7-16.2H43.2z M51,88c3.8,3.3,8.6,5.5,13.9,5.8v2.8c-6-0.4-11.5-2.9-15.7-6.8L51,88z M67.5,93.8  c5.4-0.2,10.3-2.3,14.2-5.5l2.1,2.1c-4.4,3.8-10.1,6.1-16.3,6.2V93.8z M66.5,91C55.2,91,46,81.8,46,70.4c0-11.3,9.2-20.5,20.5-20.5  c11.3,0,20.5,9.2,20.5,20.5C87.1,81.8,77.9,91,66.5,91z M85.7,88.6l-2.1-2.1c3.7-3.9,6-9.1,6.4-14.8H93C92.7,78.3,90,84.2,85.7,88.6  z"
                      ></path>
                    </svg>
                  </div>
                  <div>Transactions</div>
                </button>
              </div>
              <div
                v-if="section.movieDetail"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(14)"
              >
                <button
                  class="btn-pos-menu"
                  @click="posFooterAction('PosScreenScedulingReport')"
                >
                  <div class="svg-container">
                    <img
                      src="@/assets/img/icons/calender.svg"
                      alt=""
                      height="40"
                      width="100"
                    />
                  </div>
                  <div>Screen Schedules Report</div>
                </button>
              </div>

              <div
                v-if="section.checkout == false && false"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(14)"
              >
                <button
                  class="btn-pos-menu"
                  @click="posFooterAction('posUserFnbTransaction')"
                >
                  <div class="svg-container">
                    <svg
                      height="100px"
                      width="100px"
                      fill="#969696"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      style="enable-background: new 0 0 100 100"
                      xml:space="preserve"
                    >
                      <path
                        d="M41.6,99.3H5.8c-1,0-1.9-0.8-1.9-1.9V2.7c0-1,0.8-1.9,1.9-1.9h60c0.5,0,1,0.2,1.3,0.5l17.3,17  c0.4,0.4,0.6,0.8,0.6,1.4V37c0,1-0.8,1.9-1.9,1.9c-1,0-1.9-0.8-1.9-1.9V20.5L65,4.6H7.7v90.8h33.8c1,0,1.9,0.8,1.9,1.9  S42.6,99.3,41.6,99.3z"
                      ></path>
                      <path
                        d="M18.9,33.3H59c1.2,0,2.2-1,2.2-2.2S60.2,29,59,29H18.9c-1.2,0-2.2,1-2.2,2.2S17.7,33.3,18.9,33.3z"
                      ></path>
                      <path
                        d="M19.1,21.2h40.1c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2H19.1c-1.2,0-2.2,1-2.2,2.2  C17,20.3,17.9,21.2,19.1,21.2z"
                      ></path>
                      <path
                        d="M19.1,45.7h23.4c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2H19.1c-1.2,0-2.2,1-2.2,2.2S17.9,45.7,19.1,45.7z"
                      ></path>
                      <path
                        d="M33.7,58.5H19c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h14.6c1.2,0,2.2,1,2.2,2.2S34.9,58.5,33.7,58.5z"
                      ></path>
                      <path
                        d="M70.8,65.3c0,0.7,0.6,1.2,1.3,1.2c0,0,0,0,0,0c0.7,0,1.3-0.6,1.3-1.3c0-1.9-1.3-5.5-5.9-6v-1.4  c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3v1.4c-1.7,0.2-3.1,0.8-4.2,1.9c-1.6,1.6-1.7,3.7-1.7,4.1c0,0.5-0.1,2.7,1.5,4.4  c1,1.1,2.5,1.8,4.4,2v7.5c-3.1-0.6-3.3-3-3.3-3.5c0-0.7-0.6-1.3-1.3-1.2c-0.7,0-1.3,0.6-1.3,1.3c0,1.9,1.3,5.5,5.9,6v1.4  c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3v-1.4c1.7-0.2,3.1-0.8,4.2-1.9c1.6-1.6,1.7-3.7,1.7-4.1c0-0.5,0.1-2.7-1.5-4.4  c-1-1.1-2.5-1.8-4.4-2v-7.5C70.5,62.3,70.8,64.7,70.8,65.3z M64.9,69.1c-1.1-0.2-1.9-0.5-2.5-1.2c-1-1.1-0.8-2.5-0.8-2.5  c0-0.1,0-0.1,0-0.2c0,0,0-1.4,1-2.4c0.6-0.6,1.3-0.9,2.3-1.1V69.1z M70,72.9c1,1.1,0.8,2.5,0.8,2.5c0,0.1,0,0.1,0,0.2  c0,0,0,1.4-1,2.4c-0.6,0.6-1.3,0.9-2.3,1.1v-7.4C68.6,72,69.4,72.3,70,72.9z"
                      ></path>
                      <path
                        d="M66.8,41.6C50.9,41.6,38,54.5,38,70.4s12.9,28.8,28.8,28.8s28.8-12.9,28.8-28.8S82.7,41.6,66.8,41.6z   M93,69.1h-3.1c-0.3-5.4-2.5-10.4-5.9-14.2l2.1-2.1C90.2,57.1,92.7,62.9,93,69.1z M82.2,53.1c-3.9-3.6-9.1-5.8-14.7-6v-2.8  c6.5,0.2,12.4,2.7,16.9,6.7L82.2,53.1z M64.9,47.1c-5.6,0.4-10.6,2.7-14.4,6.3l-1.8-1.8c4.3-4.1,10-6.8,16.3-7.3V47.1z M48.7,55.3  c-3.2,3.8-5.2,8.6-5.5,13.8h-2.5c0.3-6,2.6-11.4,6.2-15.7L48.7,55.3z M43.2,71.7c0.3,5.5,2.5,10.5,6,14.4L47.4,88  c-3.9-4.4-6.4-10-6.7-16.2H43.2z M51,88c3.8,3.3,8.6,5.5,13.9,5.8v2.8c-6-0.4-11.5-2.9-15.7-6.8L51,88z M67.5,93.8  c5.4-0.2,10.3-2.3,14.2-5.5l2.1,2.1c-4.4,3.8-10.1,6.1-16.3,6.2V93.8z M66.5,91C55.2,91,46,81.8,46,70.4c0-11.3,9.2-20.5,20.5-20.5  c11.3,0,20.5,9.2,20.5,20.5C87.1,81.8,77.9,91,66.5,91z M85.7,88.6l-2.1-2.1c3.7-3.9,6-9.1,6.4-14.8H93C92.7,78.3,90,84.2,85.7,88.6  z"
                      ></path>
                    </svg>
                  </div>
                  <div>Fnb Transactions</div>
                </button>
              </div>

              <div
                v-if="section.movieDetail"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(15)"
              >
                <button
                  class="btn-pos-menu"
                  @click="
                    $router.push({
                      // name: 'Kitchen Pickup',
                      path: '/kitchen-sales',
                      query: { isPosOperator: true },
                    })
                  "
                >
                  <div class="svg-container">
                    <svg
                      height="40px"
                      viewBox="0 -24 480 480"
                      width="40px"
                      fill="#969696"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="m472 96h-106.664062l-37.953126-91.078125c-1.242187-2.980469-4.152343-4.921875-7.382812-4.921875h-136c-4.417969 0-8 3.582031-8 8v32c0 4.417969 3.582031 8 8 8h106.457031l18 48h-60.457031c-4.417969 0-8 3.582031-8 8v48c0 4.417969 3.582031 8 8 8h8.457031l15.542969 264.472656c.25 4.230469 3.757812 7.535156 8 7.527344h160c4.242188.007812 7.75-3.296875 8-7.527344l15.542969-264.472656h8.457031c4.417969 0 8-3.582031 8-8v-48c0-4.417969-3.582031-8-8-8zm-168.503906-58.808594c-1.171875-3.125-4.160156-5.195312-7.496094-5.191406h-104v-16h122.664062l33.335938 80h-22.457031zm133.664062 298.808594h-34.96875c13.859375-12.101562 21.808594-29.601562 21.808594-48s-7.949219-35.898438-21.808594-48h40.617188zm-29.160156-48c0 26.507812-21.492188 48-48 48s-48-21.492188-48-48 21.492188-48 48-48c26.5.027344 47.972656 21.5 48 48zm-112 0c.011719 18.394531 7.960938 35.890625 21.808594 48h-34.96875l-5.648438-96h40.617188c-13.847656 12.109375-21.796875 29.605469-21.808594 48zm-8.457031 128-3.757813-64h152.429688l-3.757813 64zm156.210937-192h-167.507812l-3.757813-64h175.023438zm20.246094-80h-208v-32h208zm0 0"
                      />
                      <path
                        d="m408 384h-24c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8h24c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8zm0 0"
                      />
                      <path
                        d="m352 384h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8zm0 0"
                      />
                      <path
                        d="m24 432h208c13.253906 0 24-10.746094 24-24v-32c-.015625-8.21875-4.242188-15.855469-11.199219-20.230469 4.273438-7.265625 4.273438-16.273437 0-23.539062 6.957031-4.375 11.183594-12.011719 11.199219-20.230469 0-43.257812-29.921875-88-80-88h-88c-57.777344 0-88 44.273438-88 88 .015625 8.21875 4.242188 15.855469 11.199219 20.230469-4.273438 7.265625-4.273438 16.273437 0 23.539062-6.957031 4.375-11.183594 12.011719-11.199219 20.230469v32c0 13.253906 10.746094 24 24 24zm216-24c0 4.417969-3.582031 8-8 8h-208c-4.417969 0-8-3.582031-8-8v-32c0-4.417969 3.582031-8 8-8h62.953125l118.984375 31.726562c3.667969.984376 7.523438-.75 9.222656-4.152343l13.785156-27.574219h3.054688c4.417969 0 8 3.582031 8 8zm-216-64c0-4.417969 3.582031-8 8-8h192c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8h-192c-4.417969 0-8-3.582031-8-8zm187.054688 24-7.292969 14.59375-54.714844-14.59375zm-123.054688-128h88c44.144531 0 64 42.105469 64 72 0 4.417969-3.582031 8-8 8h-208c-4.417969 0-8-3.582031-8-8 0-28.945312 19.199219-72 72-72zm0 0"
                      />
                      <path
                        d="m88 272h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"
                      />
                      <path
                        d="m56 304h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"
                      />
                      <path
                        d="m96 296c0 4.417969 3.582031 8 8 8h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8zm0 0"
                      />
                      <path
                        d="m152 304h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"
                      />
                      <path
                        d="m200 304h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"
                      />
                      <path
                        d="m128 272h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"
                      />
                      <path
                        d="m168 272h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"
                      />
                    </svg>
                  </div>
                  <div>Kitchen Display</div>
                </button>
              </div>
              <!-- FNB REFUND ## -->
              <div
                v-if="section.movieDetail"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(16)"
              >
                <button
                  class="btn-pos-menu"
                  @click="posFooterAction('FnbRefund')"
                >
                  <div class="svg-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="29.888"
                      height="27.632"
                      viewBox="0 0 29.888 27.632"
                    >
                      <path
                        d="M58.485,84.785A1.169,1.169,0,0,1,60.416,86.1,13.816,13.816,0,1,1,62.4,74.956l.477-.818A1.171,1.171,0,0,1,64.9,75.319l-2.175,3.72a1.17,1.17,0,0,1-1.773.294L57.8,76.6a1.168,1.168,0,0,1,1.529-1.766l.82.71a11.476,11.476,0,1,0-1.66,9.244ZM47.992,69.939h2.23v1.92c2.013.291,3.559,1.4,3.643,3.779l-2.555.088a1.91,1.91,0,0,0-1.088-1.633v2.813c2.186.564,4.013,1.4,4.013,4.047a3.693,3.693,0,0,1-2.306,3.439,6.019,6.019,0,0,1-1.707.41v1.89h-2.23V84.775a4.354,4.354,0,0,1-4.013-4.239l2.485-.246A2.638,2.638,0,0,0,47.992,82.5V78.979c-1.839-.527-3.537-1.453-3.537-3.671,0-2.152,1.688-3.181,3.537-3.454V69.939Zm2.23,9.6v3.033a1.7,1.7,0,0,0,1.458-1.605c0-.755-.679-1.167-1.458-1.428ZM47.992,76.3V74.022c-.582.158-1.105.486-1.105,1.117C46.887,75.7,47.393,76.058,47.992,76.3Z"
                        transform="translate(-35.19 -64.5)"
                        fill="#969696"
                      />
                    </svg>
                  </div>
                  <div>Refund FNB</div>
                </button>
              </div>

              <div
                v-if="(section.checkout == false || isCinepolis) && !starClient"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(16)"
              >
                <button class="btn-pos-menu" @click="testprintHandler()">
                  <div class="test-print"></div>
                  <div>Test Print</div>
                </button>
              </div>

              <div
                v-if="
                  section.checkout == false &&
                  authorizeClient(CLIENT_NAMES_OBJ_LIST.empire) &&
                  false
                "
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(16)"
              >
                <button class="btn-pos-menu" @click="callOpenCashDrawer()">
                  <div class="test-print"></div>
                  <div>Cash Drawer</div>
                </button>
              </div>

              <!-- FNB REFUND ## -->
              <div
                v-if="section.checkout == false"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(17)"
              >
                <button class="btn-pos-menu" @click="HARD_RELOAD_POS()">
                  <div class="svg-container">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.5511 0.925995C9.41815 0.917535 6.40535 2.13091 4.15282 4.30831V0.92594C4.15282 0.41455 3.73827 0 3.22688 0C2.71549 0 2.30099 0.41455 2.30099 0.92594V6.4815C2.30088 6.8802 2.55604 7.2342 2.93435 7.36015L8.4899 9.212C8.9757 9.3736 9.5005 9.11075 9.6621 8.625C9.8237 8.1392 9.56085 7.61435 9.07505 7.4528L4.97324 6.088C8.76235 1.96174 15.179 1.68842 19.3053 5.47755C23.4315 9.26665 23.7048 15.6834 19.9157 19.8096C16.1266 23.9358 9.70995 24.2091 5.5837 20.42C3.05397 18.097 1.87158 14.6516 2.44178 11.2648C2.53146 10.7613 2.19607 10.2805 1.69265 10.1908C1.18923 10.101 0.708385 10.4365 0.61865 10.9399C0.617675 10.9454 0.616755 10.9509 0.615885 10.9564C0.505045 11.6195 0.449273 12.2906 0.449219 12.9628C0.45676 19.6076 5.84145 24.9923 12.4861 24.9999C19.1339 25.0179 24.5376 19.6433 24.5556 12.9954C24.5735 6.34765 19.1989 0.943955 12.5511 0.925995Z"
                        fill="#969696"
                      />
                    </svg>
                  </div>
                  <div>Hard Reload</div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        :class="
          !section.movieDetail
            ? 'col-lg-3 col-xl-3 px-0 col-md-3 col-sm-3'
            : ''
        "
      >
        <div class="pos-navigation">
          <div class="row">
            <div class="col-md-12 px-0" v-if="seatsSelected">
              <div
                class="footer-main-action"
                v-if="section.seatLayout == true"
              >
                <div
                  role="button"
                  :tabindex="
                    !seatsSelected.length ||
                    (showDetails.oc_id &&
                      showDetails.oc_buy_no_of_ticket &&
                      seatsSelected.length < showDetails.oc_buy_no_of_ticket) ||
                    enableClass ||
                    checkoutBtndis
                      ? -1
                      : 0
                  "
                  :aria-disabled="
                    !seatsSelected.length ||
                    (showDetails.oc_id &&
                      showDetails.oc_buy_no_of_ticket &&
                      seatsSelected.length < showDetails.oc_buy_no_of_ticket) ||
                    enableClass ||
                    checkoutBtndis
                  "
                  :class="[
                    'footer-main-action-control footer-main-action-blue',
                    !seatsSelected.length ||
                    (showDetails.oc_id &&
                      showDetails.oc_buy_no_of_ticket &&
                      seatsSelected.length < showDetails.oc_buy_no_of_ticket) ||
                    enableClass ||
                    checkoutBtndis
                      ? 'disabled'
                      : '',
                  ]"
                  @click="
                    !seatsSelected.length ||
                    (showDetails.oc_id &&
                      showDetails.oc_buy_no_of_ticket &&
                      seatsSelected.length < showDetails.oc_buy_no_of_ticket) ||
                    enableClass ||
                    checkoutBtndis
                      ? null
                      : onClickProceed()
                  "
                  @keydown.enter="
                    !seatsSelected.length ||
                    (showDetails.oc_id &&
                      showDetails.oc_buy_no_of_ticket &&
                      seatsSelected.length < showDetails.oc_buy_no_of_ticket) ||
                    enableClass ||
                    checkoutBtndis
                      ? null
                      : onClickProceed()
                  "
                >
                  {{ $t("checkout") }}
                </div>
              </div>
              <div class="row" v-else>
                <div v-if="checkoutOnlyCashCard" class="col-md-6 mb-2 pl-1">
                  <button
                    class="fs-14"
                    :class="['btn-blue-lg w-100 ']"
                    v-on:click="onClickProceed()"
                  >
                    {{ $t("checkout") }}
                  </button>
                </div>
              </div>

              <div
                v-if="showCheckOutBtns('checkout') || section.cashCardTopup"
                class="footer-main-action"
              >
                <div
                  role="button"
                  :tabindex="
                    payment_processing ||
                    isECRConnected == 'N' ||
                    OMA_PAYMENT ||
                    payment_mode_id == 58
                      ? -1
                      : 0
                  "
                  :aria-disabled="
                    payment_processing ||
                    isECRConnected == 'N' ||
                    OMA_PAYMENT ||
                    payment_mode_id == 58
                  "
                  :class="[
                    'footer-main-action-control footer-main-action-blue bookNowBtn',
                    payment_processing ||
                    isECRConnected == 'N' ||
                    OMA_PAYMENT ||
                    payment_mode_id == 58
                      ? 'disabled'
                      : '',
                  ]"
                  @click="
                    payment_processing ||
                    isECRConnected == 'N' ||
                    OMA_PAYMENT ||
                    payment_mode_id == 58
                      ? null
                      : onClickCheckOutBtn(
                          section.cashCardTopup ? 'cashcardTopUp' : 'generatebill'
                        )
                  "
                  @keydown.enter="
                    payment_processing ||
                    isECRConnected == 'N' ||
                    OMA_PAYMENT ||
                    payment_mode_id == 58
                      ? null
                      : onClickCheckOutBtn(
                          section.cashCardTopup ? 'cashcardTopUp' : 'generatebill'
                        )
                  "
                >
                  <div class="d-flex justify-content-center align-items-center book-now-content">
                  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 512 512" width="28" height="28" aria-hidden="true" class="book-now-ticket-icon">
                  <path d="M0 0 C0.99870117 -0.05607422 0.99870117 -0.05607422 2.01757812 -0.11328125 C9.90486728 -0.24862082 16.67789485 3.5233228 22.44677734 8.72143555 C23.73564895 9.97127396 25.01088581 11.23529825 26.2734375 12.51171875 C26.96007477 13.19120071 27.64671204 13.87068268 28.35415649 14.570755 C29.79033 15.99920406 31.22024784 17.43396841 32.64404297 18.87475586 C34.80926008 21.05923126 37.00228635 23.21271171 39.19921875 25.36523438 C40.60073205 26.76645732 42.00053165 28.16939687 43.3984375 29.57421875 C44.04638275 30.20688156 44.694328 30.83954437 45.36190796 31.49137878 C50.95970172 37.23356505 54.44759266 43.82148873 54.875 51.9375 C54.49184223 58.81039256 51.96750908 64.4345076 48.82275391 70.48803711 C45.59986299 76.69222665 43.04950446 82.33138498 42.4375 89.375 C42.35628906 90.28378906 42.27507812 91.19257812 42.19140625 92.12890625 C41.56109353 106.47329565 46.46623798 119.80839148 55.46875 130.87109375 C65.41796502 141.55929032 78.16072357 147.14986873 92.6015625 148.71875 C105.40662934 149.12418747 115.93534582 145.02634369 127.00390625 139.1171875 C133.05457143 136.04711165 139.19735747 135.21873339 145.81790161 137.02412415 C152.33509256 139.48629912 156.6512344 142.71452585 161.4921875 147.66796875 C162.20102081 148.37343338 162.90985413 149.07889801 163.64016724 149.80574036 C165.12451662 151.29038677 166.60149331 152.78243827 168.07128906 154.28149414 C170.30854039 156.55847008 172.57372472 158.80457627 174.84375 161.04882812 C176.29082236 162.50345974 177.73619433 163.9597853 179.1796875 165.41796875 C179.84950653 166.08080368 180.51932556 166.74363861 181.20944214 167.42655945 C187.76436349 174.17964502 191.01239889 180.93774004 190.9375 190.375 C190.57736448 207.9260112 177.08993753 217.87268574 165.44421387 229.51545715 C164.25058957 230.71238842 163.05717571 231.90952957 161.86395216 233.10686034 C158.6088408 236.37190323 155.35066365 239.63387113 152.0919168 242.89528501 C148.56865793 246.42247286 145.04822593 249.95248045 141.52735901 253.48205566 C133.04198379 261.98711097 124.55183559 270.48739382 116.06107259 278.98706988 C112.05823004 282.9943047 108.05587364 287.00202503 104.05345154 291.00967979 C90.74496269 304.33516395 77.43522496 317.65939881 64.12186432 330.98001575 C60.6741696 334.42962017 57.22648022 337.87922992 53.77880859 341.32885742 C52.92197123 342.18617852 52.06513387 343.04349963 51.18233174 343.92680015 C37.28231201 357.83513193 23.39083983 371.7519684 9.50289267 385.67235402 C-4.76765927 399.97596561 -19.0457196 414.272047 -33.33121252 428.56073684 C-41.34728138 436.57897057 -49.36002783 444.60046401 -57.36439514 452.63038063 C-64.17532593 459.46300241 -70.99302633 466.28877661 -77.81967604 473.10569475 C-81.30130894 476.58277992 -84.77962862 480.06301734 -88.24928093 483.55206108 C-91.42724693 486.74763481 -94.61435481 489.93378795 -97.80890125 493.11278411 C-98.96100238 494.26250574 -100.10975105 495.41559901 -101.25471598 496.57242749 C-110.22264502 505.62747359 -117.93415964 512.48004792 -131.125 512.75 C-131.79080078 512.78738281 -132.45660156 512.82476563 -133.14257812 512.86328125 C-141.02986728 512.99862082 -147.80289485 509.2266772 -153.57177734 504.02856445 C-154.86064895 502.77872604 -156.13588581 501.51470175 -157.3984375 500.23828125 C-158.08507477 499.55879929 -158.77171204 498.87931732 -159.47915649 498.179245 C-160.91533 496.75079594 -162.34524784 495.31603159 -163.76904297 493.87524414 C-165.93426008 491.69076874 -168.12728635 489.53728829 -170.32421875 487.38476562 C-171.72573205 485.98354268 -173.12553165 484.58060313 -174.5234375 483.17578125 C-175.17138275 482.54311844 -175.819328 481.91045563 -176.48690796 481.25862122 C-182.1084278 475.49209687 -185.57725 468.89674234 -186 460.75 C-185.67330825 454.86954856 -183.40430864 450.11317895 -180.875 444.890625 C-175.85913097 434.56637711 -175.85913097 434.56637711 -173.5625 423.375 C-173.44068359 422.01375 -173.44068359 422.01375 -173.31640625 420.625 C-172.68684619 406.27866168 -177.58971603 392.94347876 -186.59375 381.87890625 C-196.54296502 371.19070968 -209.28572357 365.60013127 -223.7265625 364.03125 C-236.53162934 363.62581253 -247.06034582 367.72365631 -258.12890625 373.6328125 C-264.65628647 376.94477106 -271.03344162 377.29131954 -278.0625 375.3125 C-287.53397632 371.68867702 -294.89426364 362.31939133 -301.99975586 355.2878418 C-303.16663658 354.13756337 -304.33886287 352.99268259 -305.51635742 351.85327148 C-321.14706689 336.72264035 -321.14706689 336.72264035 -322.19140625 326.21484375 C-321.8505295 306.18332173 -310.06483123 296.726739 -296.56921387 283.23454285 C-295.37558957 282.03761158 -294.18217571 280.84047043 -292.98895216 279.64313966 C-289.7338408 276.37809677 -286.47566365 273.11612887 -283.2169168 269.85471499 C-279.69365793 266.32752714 -276.17322593 262.79751955 -272.65235901 259.26794434 C-264.16698379 250.76288903 -255.67683559 242.26260618 -247.18607259 233.76293012 C-243.18323004 229.7556953 -239.18087364 225.74797497 -235.17845154 221.74032021 C-221.86996269 208.41483605 -208.56022496 195.09060119 -195.24686432 181.76998425 C-191.7991696 178.32037983 -188.35148022 174.87077008 -184.90380859 171.42114258 C-184.04697123 170.56382148 -183.19013387 169.70650037 -182.30733174 168.82319985 C-168.40731201 154.91486807 -154.51583983 140.9980316 -140.62789267 127.07764598 C-126.35734073 112.77403439 -112.0792804 98.477953 -97.79378748 84.18926316 C-89.77771862 76.17102943 -81.76497217 68.14953599 -73.76060486 60.11961937 C-66.94967407 53.28699759 -60.13197367 46.46122339 -53.30532396 39.64430525 C-49.82369106 36.16722008 -46.34537138 32.68698266 -42.87571907 29.19793892 C-39.69775307 26.00236519 -36.51064519 22.81621205 -33.31609875 19.63721589 C-32.16399762 18.48749426 -31.01524895 17.33440099 -29.87028402 16.17757251 C-20.90235498 7.12252641 -13.19084036 0.26995208 0 0 Z " fill="#FDB446" transform="translate(321.5625,-0.375)"/>
                  <path d="M0 0 C0.99870117 -0.05607422 0.99870117 -0.05607422 2.01757812 -0.11328125 C9.90486728 -0.24862082 16.67789485 3.5233228 22.44677734 8.72143555 C23.73564895 9.97127396 25.01088581 11.23529825 26.2734375 12.51171875 C26.96007477 13.19120071 27.64671204 13.87068268 28.35415649 14.570755 C29.79033 15.99920406 31.22024784 17.43396841 32.64404297 18.87475586 C34.80926008 21.05923126 37.00228635 23.21271171 39.19921875 25.36523438 C40.60073205 26.76645732 42.00053165 28.16939687 43.3984375 29.57421875 C44.04638275 30.20688156 44.694328 30.83954437 45.36190796 31.49137878 C50.95970172 37.23356505 54.44759266 43.82148873 54.875 51.9375 C54.49184223 58.81039256 51.96750908 64.4345076 48.82275391 70.48803711 C45.59986299 76.69222665 43.04950446 82.33138498 42.4375 89.375 C42.35628906 90.28378906 42.27507812 91.19257812 42.19140625 92.12890625 C41.56109353 106.47329565 46.46623798 119.80839148 55.46875 130.87109375 C65.41796502 141.55929032 78.16072357 147.14986873 92.6015625 148.71875 C105.40662934 149.12418747 115.93534582 145.02634369 127.00390625 139.1171875 C133.05457143 136.04711165 139.19735747 135.21873339 145.81790161 137.02412415 C152.33509256 139.48629912 156.6512344 142.71452585 161.4921875 147.66796875 C162.20102081 148.37343338 162.90985413 149.07889801 163.64016724 149.80574036 C165.12451662 151.29038677 166.60149331 152.78243827 168.07128906 154.28149414 C170.30854039 156.55847008 172.57372472 158.80457627 174.84375 161.04882812 C176.29082236 162.50345974 177.73619433 163.9597853 179.1796875 165.41796875 C179.84950653 166.08080368 180.51932556 166.74363861 181.20944214 167.42655945 C187.76436349 174.17964502 191.01239889 180.93774004 190.9375 190.375 C190.57736448 207.9260112 177.08993753 217.87268574 165.44421387 229.51545715 C164.25058957 230.71238842 163.05717571 231.90952957 161.86395216 233.10686034 C158.6088408 236.37190323 155.35066365 239.63387113 152.0919168 242.89528501 C148.56865793 246.42247286 145.04822593 249.95248045 141.52735901 253.48205566 C133.04198379 261.98711097 124.55183559 270.48739382 116.06107259 278.98706988 C112.05823004 282.9943047 108.05587364 287.00202503 104.05345154 291.00967979 C90.74496269 304.33516395 77.43522496 317.65939881 64.12186432 330.98001575 C60.6741696 334.42962017 57.22648022 337.87922992 53.77880859 341.32885742 C52.92197123 342.18617852 52.06513387 343.04349963 51.18233174 343.92680015 C37.28231201 357.83513193 23.39083983 371.7519684 9.50289267 385.67235402 C-4.76765927 399.97596561 -19.0457196 414.272047 -33.33121252 428.56073684 C-41.34728138 436.57897057 -49.36002783 444.60046401 -57.36439514 452.63038063 C-64.17532593 459.46300241 -70.99302633 466.28877661 -77.81967604 473.10569475 C-81.30130894 476.58277992 -84.77962862 480.06301734 -88.24928093 483.55206108 C-91.42724693 486.74763481 -94.61435481 489.93378795 -97.80890125 493.11278411 C-98.96100238 494.26250574 -100.10975105 495.41559901 -101.25471598 496.57242749 C-110.22264502 505.62747359 -117.93415964 512.48004792 -131.125 512.75 C-131.79080078 512.78738281 -132.45660156 512.82476563 -133.14257812 512.86328125 C-141.02986728 512.99862082 -147.80289485 509.2266772 -153.57177734 504.02856445 C-154.86064895 502.77872604 -156.13588581 501.51470175 -157.3984375 500.23828125 C-158.08507477 499.55879929 -158.77171204 498.87931732 -159.47915649 498.179245 C-160.91533 496.75079594 -162.34524784 495.31603159 -163.76904297 493.87524414 C-165.93426008 491.69076874 -168.12728635 489.53728829 -170.32421875 487.38476562 C-171.72573205 485.98354268 -173.12553165 484.58060313 -174.5234375 483.17578125 C-175.17138275 482.54311844 -175.819328 481.91045563 -176.48690796 481.25862122 C-182.1084278 475.49209687 -185.57725 468.89674234 -186 460.75 C-185.67330825 454.86954856 -183.40430864 450.11317895 -180.875 444.890625 C-175.85913097 434.56637711 -175.85913097 434.56637711 -173.5625 423.375 C-173.44068359 422.01375 -173.44068359 422.01375 -173.31640625 420.625 C-172.68684619 406.27866168 -177.58971603 392.94347876 -186.59375 381.87890625 C-196.54296502 371.19070968 -209.28572357 365.60013127 -223.7265625 364.03125 C-236.53162934 363.62581253 -247.06034582 367.72365631 -258.12890625 373.6328125 C-264.65628647 376.94477106 -271.03344162 377.29131954 -278.0625 375.3125 C-287.53397632 371.68867702 -294.89426364 362.31939133 -301.99975586 355.2878418 C-303.16663658 354.13756337 -304.33886287 352.99268259 -305.51635742 351.85327148 C-321.14706689 336.72264035 -321.14706689 336.72264035 -322.19140625 326.21484375 C-321.8505295 306.18332173 -310.06483123 296.726739 -296.56921387 283.23454285 C-295.37558957 282.03761158 -294.18217571 280.84047043 -292.98895216 279.64313966 C-289.7338408 276.37809677 -286.47566365 273.11612887 -283.2169168 269.85471499 C-279.69365793 266.32752714 -276.17322593 262.79751955 -272.65235901 259.26794434 C-264.16698379 250.76288903 -255.67683559 242.26260618 -247.18607259 233.76293012 C-243.18323004 229.7556953 -239.18087364 225.74797497 -235.17845154 221.74032021 C-221.86996269 208.41483605 -208.56022496 195.09060119 -195.24686432 181.76998425 C-191.7991696 178.32037983 -188.35148022 174.87077008 -184.90380859 171.42114258 C-184.04697123 170.56382148 -183.19013387 169.70650037 -182.30733174 168.82319985 C-168.40731201 154.91486807 -154.51583983 140.9980316 -140.62789267 127.07764598 C-126.35734073 112.77403439 -112.0792804 98.477953 -97.79378748 84.18926316 C-89.77771862 76.17102943 -81.76497217 68.14953599 -73.76060486 60.11961937 C-66.94967407 53.28699759 -60.13197367 46.46122339 -53.30532396 39.64430525 C-49.82369106 36.16722008 -46.34537138 32.68698266 -42.87571907 29.19793892 C-39.69775307 26.00236519 -36.51064519 22.81621205 -33.31609875 19.63721589 C-32.16399762 18.48749426 -31.01524895 17.33440099 -29.87028402 16.17757251 C-20.90235498 7.12252641 -13.19084036 0.26995208 0 0 Z M-23.5965271 34.14833069 C-24.80602816 35.35480817 -26.01596221 36.5608517 -27.22628939 37.76650041 C-30.53811525 41.06806504 -33.84370421 44.37581225 -37.14825988 47.68465149 C-40.71789786 51.25675995 -44.29327518 54.82311609 -47.8678894 58.39024353 C-54.86357639 65.37319252 -61.85378676 72.3615989 -68.84193604 79.35209043 C-74.51995822 85.03189617 -80.1997447 90.7099318 -85.8807869 96.38671684 C-86.68953101 97.19486577 -87.49827513 98.0030147 -88.33152664 98.83565299 C-89.97446572 100.47738032 -91.61740599 102.11910645 -93.26034744 103.76083141 C-108.65955098 119.14916383 -124.05223516 134.54400464 -139.44295378 149.94082259 C-153.53135842 164.03440155 -167.62797044 178.11973861 -181.72845761 192.20122821 C-196.20535928 206.65877435 -210.67671663 221.12184845 -225.14206278 235.59095663 C-233.26408865 243.7148973 -241.38831618 251.83660688 -249.51835251 259.95253181 C-256.43571112 266.85800513 -263.34783589 273.76866476 -270.25318186 280.68615133 C-273.77772751 284.21660441 -277.30466877 287.74457479 -280.83813477 291.26610184 C-284.07029306 294.48746555 -287.29549274 297.71562739 -290.51520284 300.94943159 C-291.68329856 302.12019192 -292.85395225 303.28840661 -294.027355 304.45384789 C-295.61806481 306.03450852 -297.19930966 307.62407008 -298.77847862 309.21624851 C-300.10137463 310.53906199 -300.10137463 310.53906199 -301.4509958 311.88859898 C-304.28738614 315.22858942 -305.38681197 317.99877713 -305.9375 322.3125 C-304.88854955 330.87892867 -295.54088727 337.98777301 -289.79223633 343.84545898 C-288.51213199 345.15881702 -287.2428738 346.48283298 -285.98461914 347.81713867 C-284.15558717 349.75582198 -282.29565446 351.65937096 -280.42578125 353.55859375 C-279.87231522 354.15739853 -279.31884918 354.75620331 -278.74861145 355.37315369 C-276.33382957 357.76277163 -274.73099754 359.27593686 -271.26733398 359.56958008 C-265.79628838 359.06165807 -261.65366279 357.20426332 -256.9375 354.5 C-242.03374518 346.55227021 -224.91801745 345.16007627 -208.5625 349.375 C-188.46837591 356.01645812 -173.54164505 367.38395563 -163.5625 386.375 C-162.02951313 389.6560495 -160.68744873 392.93332516 -159.5625 396.375 C-159.20542969 397.35210937 -158.84835938 398.32921875 -158.48046875 399.3359375 C-156.90832599 404.96088289 -157.23417623 410.83350169 -157.25 416.625 C-157.22583008 418.37103516 -157.22583008 418.37103516 -157.20117188 420.15234375 C-157.19445355 432.15126634 -160.11015 441.326019 -165.86523438 451.69726562 C-167.99953301 455.70847995 -169.59592045 458.75746237 -168.5625 463.375 C-166.55860814 466.36063897 -164.0855926 468.82447663 -161.5625 471.375 C-160.68158691 472.28604492 -159.80067383 473.19708984 -158.89306641 474.13574219 C-156.42577163 476.67710161 -153.93226751 479.1909325 -151.42749023 481.6953125 C-149.8621661 483.26285207 -148.30505709 484.83826961 -146.74804688 486.4140625 C-145.74528058 487.41975855 -144.74204237 488.42498435 -143.73828125 489.4296875 C-142.84020752 490.33187012 -141.94213379 491.23405273 -141.0168457 492.16357422 C-137.63974488 495.20642503 -135.02273845 496.79091594 -130.4375 496.5625 C-126.22290368 495.89662819 -124.10822052 494.44446313 -121.01268673 491.54687786 C-120.13721687 490.72950315 -119.26174701 489.91212844 -118.35974777 489.06998479 C-113.34939889 484.24280638 -108.40174893 479.35902824 -103.48451233 474.43745422 C-102.29440773 473.24993912 -101.1040907 472.06263686 -99.91358179 470.87552708 C-96.66747899 467.63742751 -93.42445708 464.39625816 -90.18198287 461.15452564 C-86.67530436 457.64970917 -83.16578343 454.14774073 -79.65667725 450.64535522 C-71.99959002 443.00179916 -64.34623605 435.35451247 -56.6937058 427.70639443 C-51.91443912 422.92989619 -47.13443808 418.15413332 -42.35430717 413.37849998 C-29.11314831 400.14952158 -15.87292747 386.91960595 -2.63616276 373.68623066 C-1.79056422 372.84085169 -0.94496569 371.99547272 -0.07374295 371.12447621 C0.77381974 370.27713179 1.62138244 369.42978737 2.49462885 368.55676585 C4.21199385 366.83984431 5.92936041 365.12292431 7.64672852 363.40600586 C8.49859301 362.5543628 9.3504575 361.70271973 10.22813607 360.8252693 C24.05514225 347.00221771 37.88889782 333.18594175 51.7255488 319.3725451 C65.93915023 305.18263883 80.14713732 290.98713141 94.34947973 276.78595608 C102.32089332 268.81545972 110.29471368 260.84740444 118.27473259 252.88552284 C125.0630914 246.11253944 131.84632042 239.33447118 138.62285792 232.54965941 C142.08069657 229.08790666 145.54093432 225.62864361 149.00772285 222.17585182 C152.18002515 219.01624096 155.34534812 215.84980988 158.5052175 212.67776646 C159.65039031 211.53062855 160.79811315 210.38602958 161.9486035 209.24422482 C163.51079163 207.69308806 165.06346195 206.13299922 166.61410427 204.57033253 C167.91202126 203.27331117 167.91202126 203.27331117 169.23615879 201.95008737 C172.28750483 198.3806804 174.19479743 195.03924617 174.875 190.375 C173.92631984 183.86976465 168.70745752 179.3571686 164.2109375 174.91796875 C163.62204742 174.3295369 163.03315735 173.74110504 162.42642212 173.13484192 C161.18997306 171.90139639 159.95111217 170.67036426 158.70996094 169.44165039 C156.80600578 167.55606845 154.91029115 165.66248919 153.015625 163.76757812 C151.81036865 162.56723339 150.60465556 161.36734706 149.3984375 160.16796875 C148.54685562 159.31805611 148.54685562 159.31805611 147.67807007 158.45097351 C143.85857883 154.54123571 143.85857883 154.54123571 138.79296875 153.07421875 C134.44620445 153.46385886 131.52121562 155.0948235 127.75 157.1875 C117.17081129 163.04364751 107.2557357 164.94259239 95.1875 164.875 C93.99890381 164.86927979 92.81030762 164.86355957 91.58569336 164.85766602 C72.72452627 164.47500555 57.7165769 156.60780834 44.4375 143.375 C43.80070312 142.76140625 43.16390625 142.1478125 42.5078125 141.515625 C29.23799849 127.71501843 25.81131577 109.22747624 25.96679688 90.84960938 C26.31398703 78.10699215 29.94989942 68.62037668 36.046875 57.56640625 C37.62761829 53.93868921 38.02624982 52.28518194 37.4375 48.375 C35.6109712 45.69772875 33.34558406 43.53744739 31.015625 41.296875 C30.35923035 40.64422668 29.70283569 39.99157837 29.02655029 39.31915283 C27.63794903 37.94397836 26.24217935 36.57600986 24.83984375 35.21484375 C22.6952449 33.13252001 20.57269701 31.02963881 18.453125 28.921875 C17.10019446 27.58728738 15.74606673 26.25391211 14.390625 24.921875 C13.75505676 24.29480652 13.11948853 23.66773804 12.46466064 23.02166748 C11.86434021 22.44056213 11.26401978 21.85945679 10.64550781 21.26074219 C10.12144348 20.75033386 9.59737915 20.23992554 9.05743408 19.71405029 C6.20464294 17.35591063 3.84790857 16.43813978 0.1875 15.875 C-9.47226345 17.16296846 -16.97406261 27.50229378 -23.5965271 34.14833069 Z " fill="#1E252B" transform="translate(321.5625,-0.375)"/>
                  <path d="M0 0 C0.29449482 1.41608146 0.5853454 2.83292057 0.875 4.25 C1.06449219 5.16007812 1.25398438 6.07015625 1.44921875 7.0078125 C2 10 2 10 2.33203125 13.0546875 C3.40250369 22.3007462 6.84787901 26.15327758 13.49609375 32.3125 C14.32238281 33.09625 15.14867187 33.88 16 34.6875 C17.175625 35.74517578 17.175625 35.74517578 18.375 36.82421875 C20 39 20 39 19.95703125 41.6171875 C18.86569918 44.33438163 18.20021637 45.01726901 15.6875 46.4375 C14.96949219 46.86289062 14.25148438 47.28828125 13.51171875 47.7265625 C11 49 11 49 8.08203125 50.0859375 C-0.17681827 53.37272933 -3.05012233 57.40751266 -6.50195312 65.26293945 C-6.79134766 65.94187256 -7.08074219 66.62080566 -7.37890625 67.3203125 C-9.77811667 72.90306365 -9.77811667 72.90306365 -12 75 C-14.9102116 75.35968238 -16.40601407 75.44741798 -18.78588867 73.65478516 C-19.59376831 72.73125244 -19.59376831 72.73125244 -20.41796875 71.7890625 C-21.03349609 71.12132812 -21.64902344 70.45359375 -22.28320312 69.765625 C-23.54024185 68.35258454 -24.79041479 66.9334025 -26.03320312 65.5078125 C-30.93013772 60.23028713 -34.86998707 58.639 -42 58 C-43.08152344 57.8865625 -44.16304687 57.773125 -45.27734375 57.65625 C-47.06894806 57.55101627 -48.86061659 57.44687099 -50.65234375 57.34375 C-53 57 -53 57 -56 55 C-57.02511423 49.2644435 -54.40392212 45.90838082 -51.4375 41.3125 C-47.90016836 35.45482403 -45.94829815 31.36683816 -47.328125 24.39453125 C-47.54984375 23.60433594 -47.7715625 22.81414062 -48 22 C-48.18046875 21.26136719 -48.3609375 20.52273438 -48.546875 19.76171875 C-49.02471248 17.83950887 -49.51195502 15.9196436 -50 14 C-50.25 10.625 -50.25 10.625 -50 8 C-48 6 -48 6 -45.1015625 5.98828125 C-43.95429688 6.09527344 -42.80703125 6.20226562 -41.625 6.3125 C-40.48289063 6.41175781 -39.34078125 6.51101563 -38.1640625 6.61328125 C-35 7 -35 7 -33.06713867 7.50244141 C-27.64375591 8.80784522 -22.75554616 8.75104398 -17.83203125 5.99609375 C-16.48014369 5.16245157 -15.1401544 4.30921845 -13.8125 3.4375 C-5.78299619 -1.78976087 -5.78299619 -1.78976087 0 0 Z " fill="#FFFEFD" transform="translate(212,284)"/>
                  <path d="M0 0 C2.875 1.5 2.875 1.5 5 4 C5.8054515 8.28025636 5.96493765 10.57148115 3.49567032 14.22704887 C1.22523023 16.76988442 -1.14888133 19.14896374 -3.59716797 21.52124023 C-4.96760254 22.89583656 -4.96760254 22.89583656 -6.36572266 24.29820251 C-8.86460111 26.80363343 -11.38741966 29.28360966 -13.91547155 31.75955462 C-16.55778268 34.35548405 -19.17775124 36.97377277 -21.80032349 39.58961487 C-26.20435849 43.97619685 -30.62255771 48.34805538 -35.05126953 52.7097168 C-41.30127727 58.8651336 -47.52556303 65.04605896 -53.74476409 71.23257911 C-62.52788606 79.96665693 -71.32313059 88.68860787 -80.14404297 97.38452148 C-81.45171127 98.67873016 -81.45171127 98.67873016 -82.78579712 99.99908447 C-83.97631683 101.17020027 -83.97631683 101.17020027 -85.19088745 102.36497498 C-85.88223219 103.04685096 -86.57357693 103.72872694 -87.28587151 104.43126583 C-89.5506967 106.50398598 -90.73891187 106.96518825 -93.8125 107.375 C-97 107 -97 107 -99.875 104.875 C-102 102 -102 102 -102.75 99.1875 C-100.88931668 91.2795959 -91.85570938 84.71186542 -86.25073242 79.12133789 C-85.40436218 78.27321533 -84.55799194 77.42509277 -83.68597412 76.55126953 C-81.388609 74.25028469 -79.08904428 71.95152874 -76.78827453 69.65394902 C-74.37340068 67.24162522 -71.96098818 64.82684188 -69.548172 62.41246033 C-65.50436794 58.36684435 -61.45847602 54.32332542 -57.41137695 50.28100586 C-52.73158061 45.60667239 -48.05542729 40.92871762 -43.38110656 36.24890906 C-39.35902681 32.22229659 -35.3350084 28.19762933 -31.30935174 24.17459291 C-28.90837992 21.77518015 -26.50808918 19.37509656 -24.10954857 16.97325325 C-21.44286994 14.30404782 -18.77302901 11.63804717 -16.10229492 8.97290039 C-15.30696854 8.17554977 -14.51164215 7.37819916 -13.69221497 6.5566864 C-12.60521805 5.47391922 -12.60521805 5.47391922 -11.4962616 4.36927795 C-10.865629 3.73902238 -10.2349964 3.1087668 -9.58525372 2.45941257 C-6.51953894 -0.36293861 -4.07901552 -0.39990348 0 0 Z " fill="#FF6460" transform="translate(325,143)"/>
                  <path d="M0 0 C1.9375 1.0625 1.9375 1.0625 3 3 C3.65841237 6.884633 4.05555949 9.43678227 1.80610657 12.76808167 C0.9958326 13.65160561 0.9958326 13.65160561 0.16918945 14.55297852 C-0.46860443 15.24884064 -1.10639832 15.94470276 -1.76351929 16.66165161 C-6.2242283 21.3255379 -10.76388305 25.90677507 -15.33203125 30.46484375 C-16.4159732 31.54946067 -17.49976678 32.63422588 -18.5834198 33.71913147 C-20.8384186 35.97559437 -23.0951907 38.23026401 -25.35327148 40.48364258 C-28.24965407 43.37428732 -31.1414682 46.26945455 -34.03200245 49.16594601 C-36.2614783 51.39902737 -38.49332028 53.62973162 -40.72589684 55.8597126 C-41.79397693 56.92712552 -42.86131443 57.99528204 -43.9278965 59.06419182 C-45.41152454 60.55035063 -46.89830448 62.03328154 -48.38598633 63.51538086 C-49.23091141 64.35951035 -50.07583649 65.20363983 -50.94636536 66.073349 C-53.41044163 68.38506254 -54.4581682 68.92775576 -57.8125 69.375 C-61 69 -61 69 -63.875 66.9375 C-66.57288113 63.20807609 -66.56201109 61.53201279 -66 57 C-64.31952643 54.6564659 -62.84940562 52.94756183 -60.79931641 50.98876953 C-59.970205 50.15571541 -59.970205 50.15571541 -59.12434387 49.30583191 C-57.29967344 47.48094045 -55.45138653 45.68217246 -53.6015625 43.8828125 C-52.32694764 42.61872113 -51.05380407 41.35314465 -49.78207397 40.08615112 C-46.4346419 36.75974431 -43.06628763 33.45531283 -39.69354248 30.15460205 C-36.93877127 27.45168957 -34.19898088 24.73387004 -31.45989418 22.01507759 C-25.80857348 16.40603318 -20.14763809 10.80655384 -14.45947266 5.23486328 C-13.93367111 4.71646378 -13.40786957 4.19806427 -12.86613464 3.66395569 C-8.22441853 -0.86718453 -6.46698826 -1.36147121 0 0 Z " fill="#FFFDFC" transform="translate(328,220)"/>
                  <path d="M0 0 C3.66771845 1.83385923 5.46834996 3.25062829 8.25 6.125 C8.95640625 6.84945312 9.6628125 7.57390625 10.390625 8.3203125 C11.18726563 9.15175781 11.18726563 9.15175781 12 10 C10.48623919 13.56764285 8.39486871 15.83706287 5.6484375 18.546875 C4.79765625 19.39121094 3.946875 20.23554688 3.0703125 21.10546875 C2.18085938 21.97816406 1.29140625 22.85085937 0.375 23.75 C-0.5221875 24.63816406 -1.419375 25.52632812 -2.34375 26.44140625 C-4.55807004 28.63216969 -6.77692435 30.81812763 -9 33 C-10.06816445 32.13192399 -11.12918085 31.25505217 -12.1875 30.375 C-13.07501953 29.64410156 -13.07501953 29.64410156 -13.98046875 28.8984375 C-16.54686166 26.48592888 -18.74508093 23.70590288 -21 21 C-14.07 14.07 -7.14 7.14 0 0 Z " fill="#23282B" transform="translate(428,221)"/>
                  <path d="M0 0 C1.06816445 0.86807601 2.12918085 1.74494783 3.1875 2.625 C3.77917969 3.11226562 4.37085938 3.59953125 4.98046875 4.1015625 C7.54686166 6.51407112 9.74508093 9.29409712 12 12 C5.07 18.93 -1.86 25.86 -9 33 C-12.66771845 31.16614077 -14.46834996 29.74937171 -17.25 26.875 C-17.95640625 26.15054688 -18.6628125 25.42609375 -19.390625 24.6796875 C-19.92171875 24.12539062 -20.4528125 23.57109375 -21 23 C-19.48623919 19.43235715 -17.39486871 17.16293713 -14.6484375 14.453125 C-13.79765625 13.60878906 -12.946875 12.76445312 -12.0703125 11.89453125 C-11.18085938 11.02183594 -10.29140625 10.14914063 -9.375 9.25 C-8.4778125 8.36183594 -7.580625 7.47367188 -6.65625 6.55859375 C-4.44192996 4.36783031 -2.22307565 2.18187237 0 0 Z " fill="#23282B" transform="translate(466,183)"/>
                  <path d="M0 0 C3.66771845 1.83385923 5.46834996 3.25062829 8.25 6.125 C8.95640625 6.84945312 9.6628125 7.57390625 10.390625 8.3203125 C11.18726563 9.15175781 11.18726563 9.15175781 12 10 C10.48623919 13.56764285 8.39486871 15.83706287 5.6484375 18.546875 C4.79765625 19.39121094 3.946875 20.23554687 3.0703125 21.10546875 C2.18085938 21.97816406 1.29140625 22.85085937 0.375 23.75 C-0.5221875 24.63816406 -1.419375 25.52632812 -2.34375 26.44140625 C-4.55807004 28.63216969 -6.77692435 30.81812763 -9 33 C-10.06816445 32.13192399 -11.12918085 31.25505217 -12.1875 30.375 C-13.07501953 29.64410156 -13.07501953 29.64410156 -13.98046875 28.8984375 C-16.54686166 26.48592888 -18.74508093 23.70590288 -21 21 C-14.07 14.07 -7.14 7.14 0 0 Z " fill="#23282B" transform="translate(279,72)"/>
                  <path d="M0 0 C1.06816445 0.86807601 2.12918085 1.74494783 3.1875 2.625 C3.77917969 3.11226562 4.37085938 3.59953125 4.98046875 4.1015625 C7.54686166 6.51407112 9.74508093 9.29409712 12 12 C5.07 18.93 -1.86 25.86 -9 33 C-12.66771845 31.16614077 -14.46834996 29.74937171 -17.25 26.875 C-17.95640625 26.15054688 -18.6628125 25.42609375 -19.390625 24.6796875 C-19.92171875 24.12539063 -20.4528125 23.57109375 -21 23 C-19.48623919 19.43235715 -17.39486871 17.16293713 -14.6484375 14.453125 C-13.79765625 13.60878906 -12.946875 12.76445313 -12.0703125 11.89453125 C-11.18085938 11.02183594 -10.29140625 10.14914063 -9.375 9.25 C-8.4778125 8.36183594 -7.580625 7.47367188 -6.65625 6.55859375 C-4.44192996 4.36783031 -2.22307565 2.18187237 0 0 Z " fill="#23282B" transform="translate(317,34)"/>
                  <path d="M0 0 C2.54731079 1.14145066 4.19764958 2.6946942 6.18237305 4.65039062 C6.90038086 5.33746094 7.61838867 6.02453125 8.3581543 6.73242188 C9.86987305 8.83789062 9.86987305 8.83789062 9.73022461 10.68530273 C8.56818051 13.59272125 6.84931986 15.19578381 4.6159668 17.38476562 C3.76196289 18.22910156 2.90795898 19.0734375 2.02807617 19.94335938 C1.13024414 20.81605469 0.23241211 21.68875 -0.69262695 22.58789062 C-2.04517578 23.92013672 -2.04517578 23.92013672 -3.42504883 25.27929688 C-5.65349793 27.47237377 -7.88864288 29.65815106 -10.13012695 31.83789062 C-13.54072098 30.23253776 -15.7480518 28.43270162 -18.38012695 25.71289062 C-19.0865332 24.9884375 -19.79293945 24.26398438 -20.52075195 23.51757812 C-21.0518457 22.96328125 -21.58293945 22.40898437 -22.13012695 21.83789062 C-19.7669059 16.39879208 -15.3746539 12.67392833 -11.25512695 8.52539062 C-10.43915039 7.67654297 -9.62317383 6.82769531 -8.7824707 5.953125 C-7.99227539 5.15583984 -7.20208008 4.35855469 -6.38793945 3.53710938 C-5.66751465 2.80322998 -4.94708984 2.06935059 -4.20483398 1.31323242 C-2.13012695 -0.16210938 -2.13012695 -0.16210938 0 0 Z " fill="#23282B" transform="translate(392.130126953125,259.162109375)"/>
                  <path d="M0 0 C2.54731079 1.14145066 4.19764958 2.6946942 6.18237305 4.65039062 C6.90038086 5.33746094 7.61838867 6.02453125 8.3581543 6.73242188 C9.86987305 8.83789062 9.86987305 8.83789062 9.73022461 10.68530273 C8.56818051 13.59272125 6.84931986 15.19578381 4.6159668 17.38476562 C3.76196289 18.22910156 2.90795898 19.0734375 2.02807617 19.94335938 C1.13024414 20.81605469 0.23241211 21.68875 -0.69262695 22.58789062 C-2.04517578 23.92013672 -2.04517578 23.92013672 -3.42504883 25.27929688 C-5.65349793 27.47237377 -7.88864288 29.65815106 -10.13012695 31.83789062 C-13.54072098 30.23253776 -15.7480518 28.43270162 -18.38012695 25.71289062 C-19.0865332 24.9884375 -19.79293945 24.26398438 -20.52075195 23.51757812 C-21.0518457 22.96328125 -21.58293945 22.40898437 -22.13012695 21.83789062 C-19.7669059 16.39879208 -15.3746539 12.67392833 -11.25512695 8.52539062 C-10.43915039 7.67654297 -9.62317383 6.82769531 -8.7824707 5.953125 C-7.99227539 5.15583984 -7.20208008 4.35855469 -6.38793945 3.53710938 C-5.66751465 2.80322998 -4.94708984 2.06935059 -4.20483398 1.31323242 C-2.13012695 -0.16210938 -2.13012695 -0.16210938 0 0 Z " fill="#23282B" transform="translate(243.130126953125,110.162109375)"/>
                  <path d="M0 0 C4.73083325 4.05499992 8.26704243 7.24896309 12 12 C9.05226582 14.99707817 6.09808792 17.98760494 3.13769531 20.97216797 C2.13100272 21.98893399 1.12611034 23.00748562 0.12304688 24.02783203 C-1.31694371 25.49201218 -2.76323256 26.94970205 -4.2109375 28.40625 C-5.08024902 29.28603516 -5.94956055 30.16582031 -6.84521484 31.07226562 C-9 33 -9 33 -11 33 C-12.62109375 31.390625 -12.62109375 31.390625 -14.4375 29.25 C-15.03433594 28.55390625 -15.63117188 27.8578125 -16.24609375 27.140625 C-17.88667532 25.13831164 -19.44684965 23.07086713 -21 21 C-14.07 14.07 -7.14 7.14 0 0 Z " fill="#21272B" transform="translate(203,446)"/>
                  <path d="M0 0 C2.31 1.98 4.62 3.96 7 6 C8.65975389 7.34192868 10.32346641 8.67909475 12 10 C10.48623919 13.56764285 8.39486871 15.83706287 5.6484375 18.546875 C4.79765625 19.39121094 3.946875 20.23554688 3.0703125 21.10546875 C2.18085938 21.97816406 1.29140625 22.85085938 0.375 23.75 C-0.5221875 24.63816406 -1.419375 25.52632813 -2.34375 26.44140625 C-4.55807004 28.63216969 -6.77692435 30.81812763 -9 33 C-10.06816445 32.13192399 -11.12918085 31.25505217 -12.1875 30.375 C-13.07501953 29.64410156 -13.07501953 29.64410156 -13.98046875 28.8984375 C-16.54686166 26.48592888 -18.74508093 23.70590288 -21 21 C-14.07 14.07 -7.14 7.14 0 0 Z " fill="#21272B" transform="translate(353,296)"/>
                  <path d="M0 0 C7 6 7 6 12 12 C5.07 18.93 -1.86 25.86 -9 33 C-16 27 -16 27 -21 21 C-14.07 14.07 -7.14 7.14 0 0 Z " fill="#20262B" transform="translate(278,371)"/>
                  <path d="M0 0 C7 6 7 6 12 12 C5.07 18.93 -1.86 25.86 -9 33 C-16 27 -16 27 -21 21 C-14.07 14.07 -7.14 7.14 0 0 Z " fill="#21262B" transform="translate(54,297)"/>
                  <path d="M0 0 C7 6 7 6 12 12 C5.07 18.93 -1.86 25.86 -9 33 C-16 27 -16 27 -21 21 C-14.07 14.07 -7.14 7.14 0 0 Z " fill="#20262B" transform="translate(129,222)"/>
                  <path d="M0 0 C7 6 7 6 12 12 C5.07 18.93 -1.86 25.86 -9 33 C-16 27 -16 27 -21 21 C-14.07 14.07 -7.14 7.14 0 0 Z " fill="#21262B" transform="translate(204,147)"/>
                  <path d="M0 0 C3.41059403 1.60535287 5.61792484 3.40518901 8.25 6.125 C8.95640625 6.84945313 9.6628125 7.57390625 10.390625 8.3203125 C11.18726563 9.15175781 11.18726563 9.15175781 12 10 C10.51346494 13.46629835 8.54277649 15.69022036 5.8671875 18.328125 C5.06152344 19.12734375 4.25585938 19.9265625 3.42578125 20.75 C2.58402344 21.575 1.74226563 22.4 0.875 23.25 C0.02550781 24.09046875 -0.82398438 24.9309375 -1.69921875 25.796875 C-3.79504923 27.86915683 -5.89540713 29.93662393 -8 32 C-11.41059403 30.39464713 -13.61792484 28.59481099 -16.25 25.875 C-16.95640625 25.15054687 -17.6628125 24.42609375 -18.390625 23.6796875 C-18.92171875 23.12539063 -19.4528125 22.57109375 -20 22 C-18.51346494 18.53370165 -16.54277649 16.30977964 -13.8671875 13.671875 C-12.65869141 12.47304688 -12.65869141 12.47304688 -11.42578125 11.25 C-10.58402344 10.425 -9.74226562 9.6 -8.875 8.75 C-8.02550781 7.90953125 -7.17601562 7.0690625 -6.30078125 6.203125 C-4.20495077 4.13084317 -2.10459287 2.06337607 0 0 Z " fill="#20262B" transform="translate(240,409)"/>
                  <path d="M0 0 C3.41059403 1.60535287 5.61792484 3.40518901 8.25 6.125 C8.95640625 6.84945313 9.6628125 7.57390625 10.390625 8.3203125 C11.18726563 9.15175781 11.18726563 9.15175781 12 10 C10.51346494 13.46629835 8.54277649 15.69022036 5.8671875 18.328125 C5.06152344 19.12734375 4.25585938 19.9265625 3.42578125 20.75 C2.58402344 21.575 1.74226563 22.4 0.875 23.25 C0.02550781 24.09046875 -0.82398438 24.9309375 -1.69921875 25.796875 C-3.79504923 27.86915683 -5.89540713 29.93662393 -8 32 C-11.41059403 30.39464713 -13.61792484 28.59481099 -16.25 25.875 C-16.95640625 25.15054687 -17.6628125 24.42609375 -18.390625 23.6796875 C-18.92171875 23.12539063 -19.4528125 22.57109375 -20 22 C-18.51346494 18.53370165 -16.54277649 16.30977964 -13.8671875 13.671875 C-12.65869141 12.47304688 -12.65869141 12.47304688 -11.42578125 11.25 C-10.58402344 10.425 -9.74226563 9.6 -8.875 8.75 C-8.02550781 7.90953125 -7.17601562 7.0690625 -6.30078125 6.203125 C-4.20495077 4.13084317 -2.10459287 2.06337607 0 0 Z " fill="#20262B" transform="translate(315,334)"/>
                  <path d="M0 0 C3.41059403 1.60535287 5.61792484 3.40518901 8.25 6.125 C8.95640625 6.84945313 9.6628125 7.57390625 10.390625 8.3203125 C11.18726563 9.15175781 11.18726563 9.15175781 12 10 C10.51346494 13.46629835 8.54277649 15.69022036 5.8671875 18.328125 C5.06152344 19.12734375 4.25585938 19.9265625 3.42578125 20.75 C2.58402344 21.575 1.74226563 22.4 0.875 23.25 C0.02550781 24.09046875 -0.82398437 24.9309375 -1.69921875 25.796875 C-3.79504923 27.86915683 -5.89540713 29.93662393 -8 32 C-11.41059403 30.39464713 -13.61792484 28.59481099 -16.25 25.875 C-16.95640625 25.15054687 -17.6628125 24.42609375 -18.390625 23.6796875 C-18.92171875 23.12539063 -19.4528125 22.57109375 -20 22 C-18.51346494 18.53370165 -16.54277649 16.30977964 -13.8671875 13.671875 C-12.65869141 12.47304688 -12.65869141 12.47304688 -11.42578125 11.25 C-10.58402344 10.425 -9.74226563 9.6 -8.875 8.75 C-8.02550781 7.90953125 -7.17601563 7.0690625 -6.30078125 6.203125 C-4.20495077 4.13084317 -2.10459287 2.06337607 0 0 Z " fill="#20262B" transform="translate(91,260)"/>
                  <path d="M0 0 C3.41059403 1.60535287 5.61792484 3.40518901 8.25 6.125 C8.95640625 6.84945312 9.6628125 7.57390625 10.390625 8.3203125 C11.18726563 9.15175781 11.18726563 9.15175781 12 10 C10.51346494 13.46629835 8.54277649 15.69022036 5.8671875 18.328125 C5.06152344 19.12734375 4.25585938 19.9265625 3.42578125 20.75 C2.58402344 21.575 1.74226563 22.4 0.875 23.25 C0.02550781 24.09046875 -0.82398438 24.9309375 -1.69921875 25.796875 C-3.79504923 27.86915683 -5.89540713 29.93662393 -8 32 C-11.41059403 30.39464713 -13.61792484 28.59481099 -16.25 25.875 C-16.95640625 25.15054688 -17.6628125 24.42609375 -18.390625 23.6796875 C-18.92171875 23.12539062 -19.4528125 22.57109375 -20 22 C-18.51346494 18.53370165 -16.54277649 16.30977964 -13.8671875 13.671875 C-12.65869141 12.47304687 -12.65869141 12.47304687 -11.42578125 11.25 C-10.58402344 10.425 -9.74226562 9.6 -8.875 8.75 C-8.02550781 7.90953125 -7.17601562 7.0690625 -6.30078125 6.203125 C-4.20495077 4.13084317 -2.10459287 2.06337607 0 0 Z " fill="#20262B" transform="translate(166,185)"/>
                  </svg>
                  <span>BOOK NOW</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12" v-if="section.eWalletTopup">
              <button
                class="btn-blue-lg w-100"
                v-on:click="onClickCheckOutBtn('eWalletRecharge')"
              >
                {{ $t("topup") }}
              </button>
            </div>
            <div
              class="col-md-12 mt-2"
              v-if="section.eWalletTopup"
            >
              <button class="btn-white-lg w-100" v-on:click="onClickCancel()">
                {{ $t("cancel") }}
              </button>
            </div>

            <div class="col-md-6 pr-1" v-if="isUnpaidBooking">
              <button class="btn-white-lg w-100" v-on:click="onClickCancel()">
                {{ $t("cancel") }}
              </button>
            </div>
            <div
              class="col-md-6 pr-1"
              v-if="
                showbutton &&
                !section.movieDetail &&
                !showCheckOutBtns('checkout') &&
                !section.seatLayout &&
                !section.cashCardTopup
              "
            >
              <button class="btn-white-lg w-100" v-on:click="onClickBack()">
                {{ $t("back") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- cinemaManagerLoginPopup -->
    <b-modal
      hide-footer
      no-close-on-esc
      id="cinemaManagerLoginPopup"
      ref="cinemaManagerLoginPopup"
      title="Cinema Manage Details"
    >
      <div class="col-10 text-center mx-auto mb-3">
        <div>
          <p class="fs-16 text-muted mb-4">
            Because you have selected VIP seats / Block seats, will require
            <span class="font-weight-semi-bold">Cinema Manager</span> login
          </p>

          <div class="input-material">
            <input
              type="text"
              v-model="username"
              name="username"
              id="username"
              v-validate="'required'"
              placeholder="username"
            />
            <label>Cinema Manager username</label>
          </div>

          <p class="error_message">
            <span v-if="submitted && errors.has('username')">{{
              errors.first("username")
            }}</span>
          </p>

          <div class="input-material">
            <input
              type="password"
              v-model="password"
              name="password"
              id="password"
              v-validate="'required'"
              placeholder="password"
            />
            <label>Cinema Manager Password</label>
          </div>

          <p class="error_message">
            <span v-if="submitted && errors.has('password')">{{
              errors.first("password")
            }}</span>
          </p>

          <div class="d-flex">
            <button
              @click.prevent.stop="$bvModal.hide('cinemaManagerLoginPopup')"
              class="btn-white-lg w-50 mr-2"
            >
              Cancel
            </button>
            <button
              @click.prevent.stop="CheckLogin"
              class="btn-blue-lg w-50 ml-2"
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- MULTI SEATS MODAL -->
    <b-modal
      hide-footer
      hide-header
      hide-backdrop
      no-close-on-esc
      no-close-on-backdrop
      ref="multiSeatsModal"
      id="multiSeatsModal"
      class="seat_select_modal"
    >
      <div class="text-center pt-3" v-if="seatsSelected">
        <h5 class="font-weight-semi-bold mb-4">
          You opted for
          <strong>{{ totalNumberOfSeats }}</strong>
          but selected only
          <strong>{{ seatsSelected.length }}</strong>
          <br />Are you sure you want to proceed?
        </h5>

        <button
          class="btn-outline-blue-lg"
          @click="$refs.multiSeatsModal.hide()"
        >
          <span class="fs-18">No</span>
        </button>
        <span class="mx-2"></span>
        <button class="btn-blue-lg" @click="reserveSeats()">
          <span class="fs-18">Yes</span>
        </button>
      </div>
    </b-modal>

    <b-modal
      hide-footer
      hide-header
      hide-backdrop
      no-close-on-backdrop
      id="showRateCardPrice"
      ref="showRateCardPrice"
      title="Show Rate Card"
      class=""
      size="xl"
    >
      <div class="d-flex flex-column">
        <div class="d-flex border-bottom border-dark">
          <div class="col-6">
            <h5 class="font-weight-bold mt-2">Show Rate Card</h5>
          </div>
          <div class="col-6 text-right">
            <button
              class="btn-modal-close ml-auto"
              @click="$bvModal.hide('showRateCardPrice')"
            >
              &times;
            </button>
          </div>
        </div>

        <div class="d-flex flex-column" v-if="seatsSelectedRateGroupNew">
          <div
            class="d-flex align-items-center border-bottom flex-wrap"
            v-for="(item, index) in seatsSelectedRateGroupNew"
            :key="index"
          >
            <div
              class="seat-type gold"
              :style="'color:' + item.AllSeats[0].sst_seat_color_code"
            >
              <div class="st-name">{{ item.srt_name }}</div>
              <div>{{ item.totalSelected }}/{{ item.AllSeats.length }}</div>
            </div>
            <div
              class="d-flex align-items-center flex-wrap"
              v-for="(rg, rg_index) in item.rate_card_group"
              :key="rg_index"
            >
              <div class="category">
                <div class="category-name">
                  {{ rg.tt_name }}
                </div>
                <div
                  v-if="rg.rc_description"
                  class="rc-desc"
                  style="font-size: 11px; font-weight: 500"
                >
                  {{ rg.rc_description || "" }}
                </div>
                <div class="category-price">
                  {{ currencyData.curr_code }}
                  {{ currFormat(rg.rc_total_amount) }}
                </div>
                <div class="category-seats">
                  <div
                    class="mod-btn"
                    :id="`decrement${index + 1}${rg_index + 1}`"
                    @click="
                      addIncrementDecrementType(
                        rg,
                        index,
                        rg_index,
                        'decrement'
                      )
                    "
                    :class="rg.totalSeatSelected == 0 ? 'disabled' : ''"
                  >
                    -
                  </div>
                  <div>{{ rg.totalSeatSelected }}</div>
                  <div
                    class="mod-btn"
                    :id="`increment${index + 1}${rg_index + 1}`"
                    @click="
                      addIncrementDecrementType(
                        rg,
                        index,
                        rg_index,
                        'increment'
                      )
                    "
                    :class="
                      item.totalSelected == item.AllSeats.length
                        ? 'disabled'
                        : ''
                    "
                  >
                    +
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex flex-column w-100 px-4 border-bottom py-2">
            <div
              class="d-flex w-100 justify-content-between align-items-center border-bottom"
            >
              <h5>Total Seats</h5>
              <h4 class="font-weight-bold">
                {{ showDetails.totalSeatBooked }}/{{
                  this.seatsSelected.length
                }}
              </h4>
            </div>
            <div
              class="d-flex w-100 justify-content-between align-items-center py-2"
            >
              <h5>Total Price</h5>
              <h3 class="font-weight-bold">
                {{ currency }} {{ currFormat(showDetails.totalAmountPrice) }}
              </h3>
            </div>
          </div>

          <div class="w-100 d-flex align-items-center justify-content-center">
            <button
              v-if="accessLimitation != 'POSONLY'"
              class="fl btn-blue my-3 h5"
              :class="[
                showDetails.totalSeatBooked == this.seatsSelected.length
                  ? noFnbItems
                    ? 'no-fnb-btn'
                    : ''
                  : 'btn-submit-disabled',
              ]"
              @click="RateCardSubmit('isFnb')"
            >
              <div v-if="noFnbItems" class="nfs-17">
                {{ $t("select") }} {{ $tc("fb", 1) }} <br />
                <span class="noFnbItem">(No Fnb Items)</span>
              </div>
              <div v-else>{{ $t("select") }} {{ $tc("fb", 1) }}</div>
            </button>
            <button
              class="fl btn-blue my-3 h5"
              :class="
                showDetails.totalSeatBooked == this.seatsSelected.length
                  ? ''
                  : 'btn-submit-disabled'
              "
              @click="RateCardSubmit"
            >
              Checkout
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="testprintOptions"
      ref="testprintOptions"
      title="Test Print"
      hide-footer
      hide-header
      size="sm"
      centered
    >
      <div class="text-center">
        <button
          @click="printHandler(1)"
          class="btn-blue-lg bg-blue text-white ml-1"
        >
          Ticket
        </button>
        <button
          @click="printHandler(2)"
          class="btn-blue-lg bg-blue text-white ml-1"
        >
          Receipt
        </button>
      </div>
    </b-modal>

    <div ref="onPrint" class="d-none">
      <div v-html="EjsData"></div>
    </div>
    <ManagerAuthLogin
      :moduleName="'posUserTransaction'"
      :onCheckAuth="onCheckAuthentication"
      :refId="'posUserTransaction'"
    />
    <ManagerAuthLogin
      :moduleName="'posUserCollection'"
      :onCheckAuth="onCheckAuthentication"
      :refId="'posUserCollection'"
    />
    <b-modal
      id="stockOutRawMaterialsfooter"
      title="Stock Not Available"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      no-enforce-focus
      no-fade
      no-stacking
      size="lg"
    >
      <div class="pb-1">
        <!-- <p class="fs-16 mb-4">{{ `` }}</p> -->
        <table class="table tableItemRM">
          <thead>
            <tr>
              <td scope="col" style="white-space: nowrap">Raw Material</td>
              <td scope="col" style="white-space: nowrap">Available Qty</td>
              <td scope="col">Required Qty.</td>
              <td scope="col" style="white-space: nowrap">UOM</td>
            </tr>
          </thead>
          <tbody>
            <template v-for="(rm, rmIndex) in StockOutArray">
              <tr :key="rmIndex">
                <td>
                  {{ rm.rm_name || "-" }}
                </td>
                <td>{{ rm.available_stock || 0 }}</td>
                <td>{{ rm.applied_stock || 0 }}</td>
                <td>{{ rm.uom || "-" }}</td>
              </tr>
            </template>
          </tbody>
        </table>

        <span class="mx-1"></span>
        <div class="text-center">
          <button
            class="btn btn-danger btn-danger-lg px-4 fs-14"
            @click.prevent.stop="$bvModal.hide('stockOutRawMaterialsfooter')"
          >
            Close
          </button>
        </div>
      </div>
    </b-modal>
    <FnbRemarks />
    <BoRemarks />

    <PrivateBookingModal
      :cinemaId="getCinemaId()"
      :ssId="$route.params.ss_id"
      :showDetails="showDetails"
      :reservationId="reservation_id"
      :currencyCode="curr_code_mixin"
      @reserved="proceedPrivateBooking"
    />

    <b-modal
      id="blockSeatsCustomerForm"
      ref="blockSeatsCustomerForm"
      hide-footer
      no-close-on-backdrop
      size="lg"
      modal-class="block-seats-customer-modal"
      body-class="block-seats-customer-body"
      @hidden="onBlockSeatsFormHidden"
    >
      <template slot="modal-header" slot-scope="{ close }">
        <div class="block-seats-modal-header">
          <div class="block-seats-modal-icon">VIP</div>
          <div class="block-seats-modal-heading">
            <h5>Block Seats</h5>
            <p>Add customer details to reserve the selected seats</p>
          </div>
          <div class="block-seats-header-details">
            <span>
              Reservation
              <strong>{{ reservation_id || "—" }}</strong>
            </span>
            <span>
              Seats
              <strong>{{ seatsSelected ? seatsSelected.length : 0 }}</strong>
            </span>
          </div>
          <button
            type="button"
            class="block-seats-modal-close"
            aria-label="Close"
            @click="close()"
          >
            &times;
          </button>
        </div>
      </template>
      <div class="block-seats-customer-content">
        <UnpaidBookingCustomerForm
          v-if="showBlockSeatsForm"
          payment-mode-name="Block Seats"
          :hide-amount="true"
          :hide-title="true"
          :wide-layout="true"
          remark-label="Remark"
          remark-placeholder="Enter remark"
          :final-amount-to-pay="finalAmountToPay"
          :curr-code="curr_code_mixin"
          :min-fraction-digits="MIN_FRACTION_DIGITS"
          :reservationId="String(reservation_id || '')"
          :country-code="DEFAULT_MOBILE_CODE"
          @proceed="handleBlockSeatsFormProceed"
        />
      </div>
    </b-modal>

    <b-modal
      id="blockSeatsConfirm"
      title="Confirm Block Seats?"
      hide-footer
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-16 mb-2">
          {{
            `Are you sure you want to VIP reserve ${
              seatsSelected ? seatsSelected.length : 0
            } seat(s) for Reservation ID ${reservation_id}?`
          }}
        </p>
        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('blockSeatsConfirm')"
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-blue btn-blue-lg px-4 fs-14"
          @click.prevent.stop="confirmBlockSeats"
        >
          Confirm
        </button>
      </div>
    </b-modal>

    <b-modal
      id="blockSeatsSuccess"
      title="Seats Blocked"
      hide-footer
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-16 mb-2">
          {{ `Seats VIP Reserved For ${reservation_id}` }}
        </p>
        <button
          class="btn btn-blue btn-blue-lg px-4 fs-14"
          @click.prevent.stop="onBlockSeatsSuccess"
        >
          Confirm
        </button>
      </div>
    </b-modal>
  </footer>
  <footer class="bottomFooter" v-else>
    <div class="d-flex align-items-center justify-content-between">
      <div class="font-weight-bold">
        <strong
          >{{ showDetails.movie_title }} {{ showDetails.lang_name }}
          {{ showDetails.mf_name }} {{ showDetails.rating }}</strong
        >
        |
        <strong>
          {{ showDetails.ss_start_date }}
          {{ showDetails.ss_start_show_time }}</strong
        >
      </div>
      <div class="d-flex align-items-center justify-content-between">
        <h6 class="font-weight-bold mb-0 fs-18 text-truncate mr-3">
          {{ parseFloat(finalAmountToPay).toFixed(this.MIN_FRACTION_DIGITS) }}
          {{ curr_code_mixin }}
        </h6>
        <button
          class="btn btn-outline-primary mr-2"
          @click="onClickBack()"
          style="width: 150px"
        >
          Back
        </button>
        <button
          v-if="!noFnbItems && fnbactive"
          :disabled="!seatsSelected.length"
          class="btn btn-outline-primary mr-2"
          @click="onClickProceed('isFnb')"
          style="width: 150px"
        >
          + F&B
        </button>
        <button
          class="btn btn-primary"
          :disabled="!seatsSelected.length"
          @click="onClickProceed()"
          style="width: 150px"
        >
          Proceed
        </button>
      </div>
    </div>
  </footer>
</template>
<script>
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
import PosService from "@/services/PosService.js";
import { encryptString, generateRandomCode } from "@/helper/collection";
import moment from "moment";
import { CLIENT_NAMES_OBJ, CLIENT_NAME } from "@/helper/Role";
import FnbRemarks from "@/components/Partials/FnBRemarks";
import BoRemarks from "@/components/Partials/BoRemarks";
import PrivateBookingModal from "@/components/Partials/PrivateBookingModal.vue";
import ElectronAppService from "@/services/ElectronAppService";
import { BASEURL } from "@/config/index";
import UnpaidBookingCustomerForm from "@/components/UnpaidBookingCheckout.vue";

export default {
  components: {
    ManagerAuthLogin,
    FnbRemarks,
    BoRemarks,
    UnpaidBookingCustomerForm,
    PrivateBookingModal,
  },
  props: {
    section: { type: Object },
    fullscreen: { type: Boolean, default: false },
    finalAmountToPay: { type: String, default: "0.00" },
    type_id: { type: String, default: "1" },
    reservationId: {
      type: Number,
      default:
        generateRandomCode(10) || Math.floor(Math.random() * 90000000000),
    },
    onClickHandler: { type: Function },
    onBackHandler: { type: Function, default: null },
    onClearHandler: { type: Function, default: null },
    addIncrementDecrementType: { type: Function },
    enableClass: { type: Boolean },
    checkCompleteRateCard: { type: Boolean },
    seatsSelected: { type: Array },
    selected_fnb_items: { type: Array },
    fnb_price: { type: Object, default: () => {} },
    seatsSelectedRateGroupNew: { type: Array },
    showDetails: { type: Object, default: () => {} },
  },

  data() {
    return {
      StockOutArray: [],
      totalNumberOfSeats: "",
      checkoutBtndis: false,
      EjsData: null,
      isReprint: false,
      accessLimitation: "",
      keyboardsVisible: {
        showFirstNameKeyboard: false,
        showLastNameKeyboard: false,
        showEmailKeyboard: false,
      },
      isUnpaidBooking: false,
      posHiddenMenus: false,
      showbutton: true,
      paymentshowbutton: false,
      fnbactive: true,
      submitted: false,
      username: "",
      password: "",
      reserveSeatsImmediate: "Y",
      checkoutOnlyCashCard: false,
      totalAmountPrice: 0,
      totalSeatBooked: 0,
      totalNetAmout: 0,
      checkPopupExist: false,
      currencyData: [],
      EjsData: null,
      paymentModesArray: [],
      total_payment: 0,
      totalAmount: 0,
      newSeatLayoutArray: [],
      rateCardGroup: [],
      ticket_type_id: [],
      noFnbItems: false,
      multiCurrencyModal: false,
      managerAuthId: null,
      pendingProceedType: null,
      showBlockSeatsForm: false,
      blockSeatsCustomerDetails: null,
      blockSeatsRemark: "",
    };
  },
  beforeMount() {},
  mounted() {
    this.accessLimitation = window.localStorage.getItem("USER_ROLE_NAME")
      ? window.localStorage.getItem("USER_ROLE_NAME")
      : "SUPER";

    if (this.accessLimitation == "POSONLY") {
      this.fnbactive = false;
    }
  },
  watch: {},
  computed: {
    ticketCartItems() {
      return this.$store.getters.GET_TICKET_CART_ITEMS || [];
    },
    MANAGER_AUTH_FOR_CHANGES() {
      return this.$store.getters.MANAGER_AUTH_FOR_CHANGES;
    },
    diabledThisBtn() {
      return CLIENT_NAMES_OBJ.WOW.includes(this.CLIENT_SETUP_NAME);
    },
    diabledRefundBtn() {
      return CLIENT_NAMES_OBJ.platinum.includes(this.CLIENT_SETUP_NAME);
    },
    disableTrasactionAuth() {
      return CLIENT_NAMES_OBJ.platinum.includes(this.CLIENT_SETUP_NAME);
    },
    diabledCashierCollectionBtn() {
      return CLIENT_NAMES_OBJ.platinum.includes(this.CLIENT_SETUP_NAME);
    },
    isCinepolis() {
      return CLIENT_NAMES_OBJ.cinepolis.includes(this.CLIENT_SETUP_NAME);
    },
    isEpix() {
      return CLIENT_NAMES_OBJ.epix.includes(this.CLIENT_SETUP_NAME);
    },
    enableSyncDualDisplay() {
      return CLIENT_NAMES_OBJ.enable_sync_dual_display.includes(
        this.CLIENT_SETUP_NAME
      );
    },
    starClient() {
      return CLIENT_NAME.STAR == this.CLIENT_SETUP_NAME;
    },
    novoClient() {
      return (
        CLIENT_NAME.NOVO == this.CLIENT_SETUP_NAME ||
        window.location.pathname.toLowerCase().includes("novo")
      );
    },
    isMultiMovieCartEnabled() {
      // Multi-movie cart is Novo Cinemas only
      return CLIENT_NAME.NOVO == this.CLIENT_SETUP_NAME;
    },
    CLIENT_NAMES_OBJ_LIST() {
      return CLIENT_NAMES_OBJ;
    },
    reservation_id() {
      return this.reservationId;
    },
    DEFAULT_MOBILE_CODE() {
      return this.$store.getters.DEFAULT_MOBILE_CODE || "+971";
    },
    isOldCustomer() {
      return this.$parent.customerDetails["isApplied"] == "Y" ? true : false;
    },
    payment_processing() {
      return this.$parent.machineDisplay.processing;
    },
    payment_mode_id() {
      return this.$parent.payment_mode_id;
    },
    OMA_PAYMENT() {
      let status = false;
      const USE_OMA_CINEPOLIS_CARD_MACHINE =
        this.$store.getters.USE_OMA_CINEPOLIS_CARD_MACHINE == "Y" ? "Y" : "N";
      const USE_CREDIT_CARD_MACHINE_PAYMENT =
        this.$store.getters.USE_CREDIT_CARD_MACHINE_PAYMENT == "Y" ? "Y" : "N";
      const payment_mode_id = this.$parent.payment_mode_id;
      if (
        USE_OMA_CINEPOLIS_CARD_MACHINE == "Y" &&
        ["2", "3"].includes(String(payment_mode_id))
      ) {
        status = true;
      } else if (
        USE_CREDIT_CARD_MACHINE_PAYMENT == "Y" &&
        ["2", "3"].includes(String(payment_mode_id))
      ) {
        status = true;
      }
      return status;
    },
    isECRConnected() {
      return this.$parent.isECRConnected;
    },
    getCustMobCode() {
      return this.$store.getters.getMobileCode;
    },
    DirectPrint() {
      return this.$store.getters.POS_DIRECT_PRINT;
    },
    currency() {
      return this.$store.getters.getCurrencyData.curr_code;
    },
  },
  methods: {
    callOpenCashDrawer() {
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf(" electron/") > -1) {
        ElectronAppService.openCashDrawer()
          .then((response) => {
            console.log("RESPONSE", response);
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      } else {
        console.log("CASH DRAWER OPEN ONLY FOR EXE");
      }
    },
    disableMenu() {
      if (
        this.section.checkout ||
        this.section.seatLayout ||
        this.section.cashCardTopup ||
        this.section.eWalletTopup
      ) {
        return true;
      } else {
        return false;
      }
    },
    showCheckOutBtns(btnName) {
      let routeName = window.location.hash.replace("#", "");
      if (
        routeName.includes("/pos-checkout") &&
        ["checkout"].includes(btnName)
      ) {
        return true;
      } else {
        return false;
      }
    },
    onClickCheckOutBtn(btnName) {
      this.$emit("onClickCheckOutBtn", btnName);
    },
    HARD_RELOAD_POS() {
      this.$router.push({
        path: "/pos-booking",
      });
      window.localStorage.removeItem("fnb_items_array");
      window.localStorage.removeItem("fnb_categories");
      window.localStorage.removeItem("showDataCache");
      window.localStorage.removeItem("datesArray");
      window.location.reload();
    },
    onCheckAuthentication(response) {
      const { valid, name, user_id } = response;
      console.log("response", response);
      if (valid) {
        this.$bvModal.hide(name);
        this.managerAuthId = user_id;
        this.posFooterAction(name, false);
      }
    },
    gotoRoute: function (route) {
      console.log(route);
      this.$router.push(route);
    },
    onClickBack: function () {
      this.sendAuditLogs({
        action: `POS USER CLICKS BACK BUTTON`,
        page_name: "POS FOOTER MENU",
        api_name: window.location.hash,
      });
      if (typeof this.onBackHandler === "function") {
        this.onBackHandler();
        return;
      }
      const { reservation_id = null } = this.$route.params;
      if (reservation_id) {
        let loader = this.$loading.show();
        PosService.PosReleaseSeats({ reservation_id: reservation_id })
          .then((response) => {
            loader.hide();
            this.$router.go(-1);
          })
          .catch((err) => {
            this.$router.go(-1);
            console.log("Error", err);
          })
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 300);
          });
      } else {
        this.$router.go(-1);
      }
    },
    showHiddenMenus: function () {
      this.posHiddenMenus = !this.posHiddenMenus;
    },
    clearMultiMovieCartOnHome(currentReservationId) {
      const items = this.$store.getters.GET_TICKET_CART_ITEMS || [];
      // Clear UI immediately so cart is gone after Home navigation
      this.$store.dispatch("clearTicketCart");
      if (!items.length) {
        return;
      }
      items.forEach((item) => {
        if (
          !item ||
          !item.reservation_id ||
          String(item.reservation_id) === String(currentReservationId || "")
        ) {
          // current route reservation is released separately below
          return;
        }
        PosService.PosReleaseSeats({
          reservation_id: item.reservation_id,
        }).catch((err) => {
          console.log("Error releasing cart reservation on Home:", err);
        });
      });
      this.sendAuditLogs({
        action: `CLEARED MULTI MOVIE CART ON HOME (${items.length} items)`,
        page_name: "POS FOOTER MENU",
        api_name: window.location.hash,
      });
    },
    posFooterAction: function (menu_name, authCheck = true) {
      if (menu_name == "PrivateBooking") {
        this.$bvModal.show("privateBookingModal");
        return;
      }
      if (menu_name == "Refresh" || menu_name == "Home") {
        const { reservation_id = null } = this.$route.params;
        let redirecPath = "/pos-booking";
        if (this.accessLimitation == "FNBONLY") {
          redirecPath = "/pos-fnb";
        }

        // Home/Refresh should drop the multi-movie cart and release
        // those held seats so the sidebar does not keep showing items.
        this.clearMultiMovieCartOnHome(reservation_id);

        this.$router.push({
          path: redirecPath,
        });
        if (menu_name == "Refresh") {
          window.location.reload();
        }

        if (this.accessLimitation != "FNBONLY") {
          if (reservation_id) {
            PosService.PosReleaseSeats({ reservation_id: reservation_id })
              .then((response) => {})
              .catch((err) => {
                console.log("Error", err);
              });
          }
        }
        // window.location.reload();
      }

      if (menu_name == "PosRefund") {
        this.$router.push({
          path: "/pos-refund",
        });
      }

      if (menu_name == "cashCard") {
        this.$router.push({
          path: "/cash-card",
        });
      }

      if (menu_name == "eWalletRecharge") {
        this.$router.push({
          path: "/e-wallet",
        });
      }

      if (menu_name == "moviePass") {
        this.$router.push({
          path: "/movie-pass",
        });
      }

      if (menu_name == "merchandise") {
        this.$router.push({
          path: "/merchandise",
        });
      }

      if (menu_name == "posUserTransaction") {
        if (
          authCheck &&
          this.MANAGER_AUTH_FOR_CHANGES == "Y" &&
          !this.disableTrasactionAuth
        ) {
          this.$bvModal.show("posUserTransaction");
        } else {
          this.$router.push({
            path: "/pos-user-transactions",
          });
        }
      }

      if (menu_name == "PosScreenScedulingReport") {
        this.$router.push({
          path: "/screen-schedules",
        });
      }

      if (menu_name == "posUserCollection") {
        if (authCheck && this.MANAGER_AUTH_FOR_CHANGES == "Y") {
          this.$bvModal.show("posUserCollection");
        } else {
          this.$router.push({
            path: "/pos-user-collection",
          });
        }
      }

      if (menu_name == "showSessionBlockedSeats") {
        if (authCheck && this.MANAGER_AUTH_FOR_CHANGES == "Y") {
          return this.$bvModal.show("showSessionBlockedSeats");
        }
      }

      if (menu_name == "BlockSeats") {
        if (!this.seatsSelected || !this.seatsSelected.length) {
          this.$toasted.show("Please select seats to block");
          return;
        }
        if (!this.checkCompleteRateCard) {
          this.pendingProceedType = "blockSeatsForm";
          this.$refs.showRateCardPrice.show();
        } else {
          this.openBlockSeatsForm();
        }
      }

      if (menu_name == "PosSchedule") {
        this.$router.push({
          path: "/pos-occupancy",
        });
      }

      if (menu_name == "FnbRefund") {
        this.$router.push({
          path: "/fnb-refund",
        });
      }

      if (menu_name == "UnpaidBooking") {
        this.$router.push({
          path: "/unpaid-bookings",
        });
      }

      if (menu_name == "PayAtCounter") {
        this.$router.push({
          path: "/pay-at-counter",
        });
      }
      if (menu_name == "CustomerLoyalty") {
        this.$router.push({
          path: "/customer-loyalty",
        });
      }

      if (menu_name == "PosPickUpTicket") {
        this.$router.push({
          path: "/pos-ticket-pickup",
        });
      }

      const log_menu_name = menu_name
        .split(/(?=[A-Z])/)
        .join(" ")
        .toUpperCase();

      this.sendAuditLogs({
        action: `POS USER CLICKS FOOTER MENU - ${log_menu_name}`,
        page_name: "POS FOOTER MENU",
        api_name: window.location.hash,
      });

      this.onClickHandler(menu_name);
    },
    seatLayoutArrayArrange(seatGroup) {
      seatGroup.map((seat_g) => {
        seat_g.rate_card_group.map((rg) => {
          let findIndex32 = this.rateCardGroup.findIndex((newrg) => {
            return newrg.tt_id == rg.tt_id;
          });
          this.ticket_type_id.push(rg.tt_id);

          if (findIndex32 >= 0) {
            this.rateCardGroup[findIndex32]["count"] =
              this.rateCardGroup[findIndex32]["count"] + rg.totalSeatSelected;
          } else {
            let objRateCard = {
              tt_id: rg.tt_id,
              tt_name: rg.tt_name.trim(),
              count: rg.totalSeatSelected,
            };
            this.rateCardGroup.push(objRateCard);
          }

          for (let i = 0; i < rg.totalSeatSelected; i++) {
            let obj = {
              rate_card_id: rg.rate_card_id,
              tt_id: rg.tt_id,
              rc_g_id: rg.rc_g_id,
              rcg_c_id: rg.rcg_c_id,
              tt_name: rg.tt_name,
              seat_type_id: seat_g.sst_id,
              status: false,
            };

            this.newSeatLayoutArray.push(obj);
          }
        });
      });
    },
    // Build the encrypted `sd` checkout query string (same shape as
    // onClickProceed), given the ticket-type and seat-type ids to carry over.
    buildShowCheckoutQuery({ tt_id, seat_type_id }) {
      let showDatetime = null;
      if (
        this.showDetails.ss_start_show_time &&
        ["00", "01", "02", "03", "04", "05"].includes(
          this.showDetails.ss_start_show_time.split(":")[0]
        )
      ) {
        showDatetime = moment(
          this.showDetails.ss_actual_start_date +
            " " +
            this.showDetails.ss_start_show_time
        )
          .add("-1", "days")
          .format("YYYY-MM-DD HH:mm");
      } else {
        showDatetime = moment(
          this.showDetails.ss_actual_start_date +
            " " +
            this.showDetails.ss_start_show_time
        ).format("YYYY-MM-DD HH:mm");
      }

      let queryObj = {
        screen_id: this.showDetails.screen_id,
        movie_details_id: this.showDetails.md_id,
        oc_id: this.showDetails.hasOwnProperty("oc_id")
          ? this.showDetails.oc_id
          : 0,
        show_date_time: moment(showDatetime).valueOf(),
        show_actual_date_time: moment(
          moment(
            this.showDetails.ss_actual_start_date +
              " " +
              this.showDetails.ss_start_show_time
          ).format("YYYY-MM-DD HH:mm")
        ).valueOf(),
        tt_id: tt_id && tt_id.length ? tt_id : null,
        seat_type_id: seat_type_id && seat_type_id.length ? seat_type_id : null,
      };
      let encryptedObj = encryptString(JSON.stringify(queryObj));
      return `?sd=${encryptedObj}`;
    },
    // Handler for the PrivateBookingModal `reserved` event: seats are already
    // held server-side under reservation_id, so just proceed to checkout like a
    // normal booking.
    proceedPrivateBooking({ reservation_id, tt_id, seat_type_id }) {
      const queryString = this.buildShowCheckoutQuery({ tt_id, seat_type_id });
      this.sendAuditLogs({
        action: `PRIVATE BOOKING RESERVED, WITH RESERVATION ID-${reservation_id}`,
        page_name: "PRIVATE BOOKING",
        api_name: window.location.hash,
      });
      this.$router.push({
        path: `/pos-checkout/1/${reservation_id}${queryString}`,
      });
    },
    onClickProceed: async function (type, skip = true) {
      if (type == "blockSeatsForm") {
        this.$bvModal.hide("showRateCardPrice");
        this.openBlockSeatsForm();
        return false;
      }
      if (!this.checkCompleteRateCard && skip) {
        this.pendingProceedType = typeof type === "string" ? type : null;
        this.$refs.showRateCardPrice.show();

        return false;
      }
      let reservation_id = this.reservation_id;

      console.log("this.seatsSelected", this.seatsSelected);

      // Multi-cart: do not allow adding the same show twice.
      if (type == "addToCart" && this.isMultiMovieCartEnabled) {
        const currentSsId = this.$route.params.ss_id;
        const existingIndex = (this.ticketCartItems || []).findIndex(
          (x) => x && String(x.ss_id) === String(currentSsId)
        );
        if (existingIndex >= 0) {
          this.$toasted.show("This show is already in cart");
          return false;
        }
      }

      this.newSeatLayoutArray = [];
      this.rateCardGroup = [];
      this.seatLayoutArrayArrange(this.seatsSelectedRateGroupNew);
      let seatLayout_id_array = [];

      let seat_type_id_array = [];
      this.seatsSelected.map((x) => {
        seatLayout_id_array.push(x.sl_id);
        seat_type_id_array.push(x.sst_id);
      });

      let payload = {
        cinema_id: this.getCinemaId(),
        seat_layout_id: seatLayout_id_array,
        seat_type_id: seat_type_id_array,
        newSeatLayout: this.newSeatLayoutArray,
        schedule_show_id: this.$route.params.ss_id,
        reservation_id: reservation_id,
        isVipOrBlockSeats: type == "blockSeats",
        groupRateCard: true,
        gogo_ss_id: 0,
        gogo_booking_type_id: 0,
        specialRequest: "",
        isPos: true,
      };

      if (
        this.selected_fnb_items &&
        this.selected_fnb_items.length > 0 &&
        type != "addToCart" &&
        type != "blockSeats"
      ) {
        let tempPriceObj = {
          total_tax: 0,
          total_price: 0,
        };
        payload["withFnb"] = "Y";
        payload["fnb_obj"] = {
          selected_fnb_items: this.selected_fnb_items,
          fnb_price: this.fnb_price || tempPriceObj,
        };
      }
      this.showLoading();

      let queryString = ``;
      let showDatetime = null;

      if (
        this.showDetails.ss_start_show_time &&
        ["00", "01", "02", "03", "04", "05"].includes(
          this.showDetails.ss_start_show_time.split(":")[0]
        )
      ) {
        showDatetime = moment(
          this.showDetails.ss_actual_start_date +
            " " +
            this.showDetails.ss_start_show_time
        )
          .add("-1", "days")
          .format("YYYY-MM-DD HH:mm");
      } else {
        showDatetime = moment(
          this.showDetails.ss_actual_start_date +
            " " +
            this.showDetails.ss_start_show_time
        ).format("YYYY-MM-DD HH:mm");
      }

      let queryObj = {
        screen_id: this.showDetails.screen_id,
        movie_details_id: this.showDetails.md_id,
        oc_id: this.showDetails.hasOwnProperty("oc_id")
          ? this.showDetails.oc_id
          : 0,
        show_date_time: moment(showDatetime).valueOf(),
        show_actual_date_time: moment(
          moment(
            this.showDetails.ss_actual_start_date +
              " " +
              this.showDetails.ss_start_show_time
          ).format("YYYY-MM-DD HH:mm")
        ).valueOf(),
        tt_id: this.ticket_type_id.length > 0 ? this.ticket_type_id : null,
        seat_type_id: seat_type_id_array.length > 0 ? seat_type_id_array : null,
      };
      let encryptedObj = encryptString(JSON.stringify(queryObj));
      queryString += `?sd=${encryptedObj}`;

      let continueBlockBooking = false;
      PosService.PosReserveSeat(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (type == "blockSeats") {
              this.sendAuditLogs({
                action: `BLOCK SEATS - ${this.seatsSelected
                  .map((seat) => seat.sl_seat_name)
                  .join(", ")} RESERVED, WITH RESERVATION ID-${reservation_id}`,
                page_name: "BLOCK SEATS",
                api_name: window.location.hash,
              });
              continueBlockBooking = true;
              this.bookUnPaidBookingForBlock();
              return;
            }
            if (type == "addToCart") {
              if (!this.isMultiMovieCartEnabled) {
                this.$toasted.show("Multi movie cart is not available");
                return;
              }
              // Keep any selected F&B in the pending cart so it carries over
              // to the next movie and gets attached to the final transaction.
              if (this.selected_fnb_items && this.selected_fnb_items.length) {
                let fnbPrice = this.fnb_price || {
                  total_tax: 0,
                  total_price: 0,
                };
                this.$store.dispatch("savePendingFnbCart", {
                  items: this.selected_fnb_items,
                  fnb_price: fnbPrice,
                  fnb_net_amount:
                    parseFloat(fnbPrice.total_price || 0) -
                    parseFloat(fnbPrice.total_tax || 0),
                  cinema_id: this.getCinemaId(),
                });
              }
              this.$store.dispatch("addTicketCartItem", {
                reservation_id: reservation_id,
                sd: encryptedObj,
                ss_id: this.$route.params.ss_id,
                md_id: this.showDetails.md_id,
                screen_id: this.showDetails.screen_id,
                movie_title: this.showDetails.movie_title,
                lang_name: this.showDetails.lang_name,
                mf_name: this.showDetails.mf_name,
                rating: this.showDetails.rating,
                ss_start_date: this.showDetails.ss_start_date,
                ss_actual_start_date: this.showDetails.ss_actual_start_date,
                ss_start_show_time: this.showDetails.ss_start_show_time,
                screen_name: this.showDetails.screen_name,
                seats: this.seatsSelected.map((seat) => seat.sl_seat_name),
                total_amount: this.showDetails.totalAmountPrice || 0,
              });
              this.sendAuditLogs({
                action: `ADDED MOVIE TO CART - ${
                  this.showDetails.movie_title
                }, SEATS - ${this.seatsSelected
                  .map((seat) => seat.sl_seat_name)
                  .join(", ")}, RESERVATION ID-${reservation_id}`,
                page_name: "MULTI MOVIE CART",
                api_name: window.location.hash,
              });
              this.$toasted.show("Movie Added To Cart");
              this.$router.push({ path: "/pos-booking" });
              return;
            }
            if (
              this.$store.state.PendingFnbCart &&
              this.$store.state.PendingFnbCart.items &&
              this.$store.state.PendingFnbCart.items.length > 0 &&
              this.selected_fnb_items &&
              this.selected_fnb_items.length > 0
            ) {
              this.$store.dispatch("clearPendingFnbCart");
            }
            if (this.seatsSelected.length > 0) {
              this.sendAuditLogs({
                action: `SELECTED SEATS - ${this.seatsSelected
                  .map((seat) => seat.sl_seat_name)
                  .join(", ")} RESERVED, WITH RESERVATION ID-${reservation_id}`,
                page_name: "SEATS RESERVED",
                api_name: window.location.hash,
              });
            }
            if (type == "isFnb") {
              this.sendAuditLogs({
                action: `NAVIGATE TO SELECT FNB ITEM.`,
                page_name: "FNB SELECTION",
                api_name: window.location.hash,
              });

              this.$router.push({
                path: `/pos-fnb/${reservation_id}${queryString}`,
              });
            } else {
              let pageTypeId = 1;
              if (
                this.selected_fnb_items &&
                this.selected_fnb_items.length > 0
              ) {
                pageTypeId = 3;
              }
              this.$router.push({
                path: `/pos-checkout/${pageTypeId}/${reservation_id}${queryString}`,
              });
            }
          } else {
            this.$toasted.show(data.message || "Seat Already Reserved");

            console.log(
              'data.hasOwnProperty("noStockArray")',
              data.hasOwnProperty("noStockArray")
            );

            if (
              data.hasOwnProperty("noStockArray") &&
              data.noStockArray &&
              data.noStockArray.length
            ) {
              this.StockOutArray = [...data.noStockArray];
              this.$bvModal.show("stockOutRawMaterialsfooter");
            }

            if (data.hasOwnProperty("notAuthorized") && data.notAuthorized) {
              window.localStorage.clear();
              this.$router.replace({
                path: "/",
              });
            } else {
              setTimeout((z) => {
                window.location.reload();
              }, 1000);
            }
          }
        })
        .finally(() => {
          if (!continueBlockBooking) {
            this.hideLoading();
          }
        });
    },
    openBlockSeatsForm() {
      this.showBlockSeatsForm = true;
      this.$bvModal.show("blockSeatsCustomerForm");
    },
    onBlockSeatsFormHidden() {
      this.showBlockSeatsForm = false;
    },
    handleBlockSeatsFormProceed(formDetails) {
      this.blockSeatsRemark = formDetails.comment || "";
      this.blockSeatsCustomerDetails = {
        customer_id: formDetails.customer_id,
        guestDetails: formDetails.guestDetails,
      };
      this.$bvModal.hide("blockSeatsCustomerForm");
      this.$bvModal.show("blockSeatsConfirm");
    },
    confirmBlockSeats() {
      this.$bvModal.hide("blockSeatsConfirm");
      this.onClickProceed("blockSeats", false);
    },
    bookUnPaidBookingForBlock() {
      this.showLoading();
      let payload = {
        isGroupRateCard: true,
        reservationId: this.reservation_id,
        remarks: this.blockSeatsRemark || "",
      };
      if (
        this.blockSeatsCustomerDetails &&
        this.blockSeatsCustomerDetails.customer_id
      ) {
        payload["customer_id"] = this.blockSeatsCustomerDetails.customer_id;
      }
      if (
        this.blockSeatsCustomerDetails &&
        this.blockSeatsCustomerDetails.guestDetails &&
        this.blockSeatsCustomerDetails.guestDetails["guest_id"]
      ) {
        payload["guest_details"] = this.blockSeatsCustomerDetails.guestDetails;
      }

      PosService.GetReservationDetails(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.$bvModal.show("blockSeatsSuccess");
          } else {
            this.$toasted.show(data.message || "Block Seats Failed");
            if (data.hasOwnProperty("seatRelease") && data.seatRelease) {
              window.location.reload();
            }
          }
        })
        .catch((error) => {
          console.log("Error:", error);
          this.$toasted.show("Block Seats Failed");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    onBlockSeatsSuccess() {
      this.$bvModal.hide("blockSeatsSuccess");
      this.blockSeatsCustomerDetails = null;
      this.blockSeatsRemark = "";
      this.$router.push({ path: "/pos-booking" });
    },
    onCancelHandler: function () {
      if (typeof this.onClearHandler === "function") {
        this.onClearHandler();
        return;
      }
      window.location.reload();
    },
    openFnbRemarks() {
      console.log("refs", this.$refs);
      // this.$refs.remarkInputRef.focus()
    },
    reserveSeats: async function () {
      // this.onClickProceed(type)
    },
    CheckLogin() {},
    onClickCancel: async function () {},
    printHandler(type) {},
    testprintHandler(type) {
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf(" electron/") > -1) {
        try {
          if (this.$socket) {
            this.$socket.emit("on_print_ticket", {
              baseurl: BASEURL,
              ttype: "test_print",
              cinema_id: this.getCinemaId(),
              type: null,
            });
          }
        } catch (err) {
          console.log("Error:", err);
        }
      } else {
        this.printTest(type);
      }
    },
    onClickTestPrint() {},
    order(id) {},
    RateCardSubmit(type) {
      const validType = typeof type === "string" ? type : null;
      this.onClickProceed(validType || this.pendingProceedType, false);
    },
    checkTopUpCashInput() {},
  },
};
</script>

<style scoped>
.seat-type {
  padding: 1rem;
  min-width: 200px;
  height: 115px;
  font-weight: bold;
}

#showRateCardPrice .seat-type {
  /* width: 280px !important; */
  width: 230px !important;
}

.seat-type.gold {
  background-color: #fcf4d9;
  color: #f2c94c;
}

.seat-type.silver {
  background-color: #efefef;
  color: #a8a8a8;
}

.seat-type .st-name {
  font-weight: bold;
  /* font-size: 2.5rem; */
  font-size: 2rem;
  border-bottom: 1px solid #bfbfbf;
  line-height: 1;
  margin-bottom: 0.25rem;
  word-break: break-all;
}

#showRateCardPrice .category {
  width: 230px !important;
}

#showRateCardPrice .category .category-name {
  word-break: break-all;
}

.category {
  display: flex;
  flex-direction: column;
  /* width: 180px; */
  width: 160px;
  /* height: 160px; */
  height: 150px;
  background-color: #efefef;
  color: black;
  text-align: center;
  margin: 1rem;
  border-radius: 0.5rem;
}

.category.disabled {
  background-color: #f9f9f9;
  color: #999999;
}

.category.disabled .mod-btn {
  background-color: #afc8ed;
}

.category .category-name {
  /* font-size: 1.5rem; */
  font-size: 1.25rem;
  font-weight: 500;
  height: 53px;
  text-align: center;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.category .category-price {
  /* font-size: 1.5rem; */
  font-size: 1.25rem;
  font-weight: 500;
  height: 53px;
  text-align: center;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.category .category-seats {
  font-weight: bold;
  font-size: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-top: 1px solid #bfbfbf;
  padding: 0.25rem;
  width: 100%;
  color: black;
  user-select: none;
}

.category .category-seats .mod-btn {
  font-weight: bold;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  color: white;
  background-color: #3876d2;
  height: 40px;
  width: 40px;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.4s;
}

.category .category-seats .mod-btn:hover {
  color: #3876d2;
  background-color: white;
}

.category .category-seats .mod-btn:active,
.category .category-seats .mod-btn.active {
  transform: scale(0.8);
}

.category .category-seats .mod-btn.disabled,
.btn-submit-disabled {
  background-color: lightgrey;
  pointer-events: none;
}

.disableCheckoutBtn {
  opacity: 0.5;
  pointer-events: none;
}

.fl.btn-blue {
  font-size: 20px !important;
  padding: 1.5rem 2rem;
}

.currency-symbol {
  position: absolute;
  top: 50%;
  right: 10px;
  font-size: 12px;
  transform: translateY(-50%);
}

.InputAmount {
  padding-right: 3rem !important;
}

.noFnbItem {
  font-size: 13px;
}

.no-fnb-btn {
  background-color: white !important;
  color: red !important;
  border-color: red !important;
}

.nfs-17 {
  font-size: 17px !important;
}

.disable_item {
  opacity: 0.4;
  pointer-events: none;
}

.ellipse {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.plus-add-btn {
  color: var(--blue);
  font-size: 40px;
  font-weight: 500;
  margin-right: 10px;
}

.plus-add-btn-text {
  font-weight: 500;
  color: var(--blue);
}

.diabledThisBtn {
  opacity: 0.4;
  pointer-events: none;
}

.bottomFooter {
  position: absolute;
  bottom: 9px;
  width: 97%;
}

.footer-main-action {
  height: 75px;
}

.footer-menu-action {
  height: 75px;
  display: flex;
}

.footer-main-action-control,
.footer-menu-action-control {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  height: 75px;
  min-height: 75px;
  min-width: 0;
  padding: 2px 8px;
  color: #454545;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.1;
  text-align: center;
  background-color: #fff;
  border: 0;
  border-left: 1px solid #e0e0e0;
  cursor: pointer;
  user-select: none;
  box-sizing: border-box;
}

.footer-main-action-control {
  flex-direction: row;
  font-size: 15px;
  border-left: 1px solid #d6d6d6;
  border-top: 1px solid #d6d6d6;
  border-right: 1px solid #d6d6d6;
  border-bottom: 1px solid #d6d6d6;
}

.footer-main-action-control:hover,
.footer-menu-action-control:hover {
  background-color: #f2f6fb;
}

.footer-main-action-control:focus,
.footer-menu-action-control:focus {
  position: relative;
  z-index: 1;
  outline: 2px solid var(--blue);
  outline-offset: -2px;
}

.footer-main-action-control.disabled,
.footer-menu-action-control.disabled {
  color: #9a9a9a;
  background-color: #ededed;
  cursor: default;
  opacity: 0.65;
  pointer-events: none;
}

.footer-main-action-blue {
  color: #fff;
  background-color: var(--blue);
}

.footer-main-action-blue:hover {
  background-color: var(--blue);
  filter: brightness(0.94);
}

.footer-main-action-blue.disabled {
  color: #9a9a9a;
  background-color: #ededed;
  filter: none;
}

.checkout-confirm-action {
  color: #198754;
  background-color: #fff;
}

.checkout-confirm-action:hover {
  background-color: #f2fbf6;
}

.checkout-confirm-action.disabled {
  color: #9a9a9a;
  background-color: #ededed;
  filter: none;
}

.checkout-confirm-action.disabled .checkout-confirm-icon {
  fill: #9a9a9a;
  border-color: #9a9a9a;
}

.footer-menu-action-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  color: var(--blue);
  font-size: 20px;
  line-height: 1;
  border: 1px solid #cfd8e3;
  border-radius: 50%;
  flex-shrink: 0;
}

.footer-menu-action-icon svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.checkout-confirm-icon {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  padding: 6px;
  fill: #198754;
  border: 2px solid #198754;
  border-radius: 50%;
}
</style>

<style>
.block-seats-customer-modal .modal-dialog {
  width: calc(100% - 32px);
  max-width: 1120px;
  margin: 24px auto;
}

.block-seats-customer-modal .modal-content {
  max-height: calc(100vh - 32px);
  min-height: 250px;
  border: 0;
  border-radius: 20px;
  box-shadow: 0 24px 70px rgba(30, 27, 75, 0.2);
}

.block-seats-customer-modal .modal-header {
  padding: 0;
  border: 0;
  border-radius: 20px 20px 0 0;
  background: linear-gradient(135deg, #f0eefc 0%, #faf9ff 100%);
}

.block-seats-customer-body {
  padding: 0 !important;
  overflow-y: auto;
}

.block-seats-modal-header {
  width: 100%;
  min-height: 66px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 18px;
}

.block-seats-modal-icon {
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  background: #6558c8;
  box-shadow: 0 8px 18px rgba(101, 88, 200, 0.25);
}

.block-seats-modal-heading {
  min-width: 0;
  flex: 1;
}

.block-seats-modal-heading h5 {
  margin: 0 0 2px;
  color: #272346;
  font-size: 17px;
  font-weight: 700;
}

.block-seats-modal-heading p {
  margin: 0;
  color: #77738f;
  font-size: 12px;
}

.block-seats-header-details {
  display: flex;
  align-items: center;
  gap: 8px;
}

.block-seats-header-details span {
  min-width: 110px;
  padding: 7px 10px;
  border: 1px solid #e2def3;
  border-radius: 9px;
  color: #817c98;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: rgba(255, 255, 255, 0.72);
}

.block-seats-header-details strong {
  display: block;
  max-width: 130px;
  overflow: hidden;
  margin-top: 1px;
  color: #40378b;
  font-size: 13px;
  text-overflow: ellipsis;
  text-transform: none;
  white-space: nowrap;
}

.block-seats-modal-close {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  color: #77738f;
  font-size: 22px;
  line-height: 30px;
  background: rgba(255, 255, 255, 0.75);
  cursor: pointer;
}

.block-seats-modal-close:hover {
  color: #3d376b;
  background: #fff;
}

.block-seats-customer-content {
  padding: 18px 22px 20px;
}

@media (max-width: 850px) {
  .block-seats-customer-modal .modal-dialog {
    width: calc(100% - 20px);
    margin: 10px auto;
  }

  .block-seats-modal-header {
    min-height: 60px;
    padding: 9px 14px;
  }

  .block-seats-modal-icon {
    width: 36px;
    height: 36px;
    flex-basis: 36px;
  }

  .block-seats-modal-heading p {
    display: none;
  }

  .block-seats-header-details {
    display: none;
  }

  .block-seats-customer-content {
    padding: 16px;
  }
}

.bookNowBtn {
  background: seagreen !important;
  font-size: large !important;
  text-transform: uppercase !important;
  font-weight: 400 !important;
  gap: 10px;
}

.book-now-content {
  gap: 10px;
  line-height: 1;
}

.book-now-ticket-icon {
  width: 28px;
  height: 28px;
  display: block;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/posFooter.vue